// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var englishTranslation = {
    translations: {
        configurationPackage: {
            tab: "Configuration package",
            title: "Import a configuration package",
            description: "Apply a complete delivery exported by Election Architect: tenant configuration and settings, roles, administrators, trustees and the election event with its census. Nothing changes until the preview is applied.",
            tenant: "Tenant: {{tenantId}}",
            notPermitted: "Importing a configuration package needs tenant-write, user-write, role-write, trustee-create, trustee-write and election-event-create on this tenant.",
            requirements: "The package must carry",
            censusRequired: "The election event's census",
            sections: {
                "tenant-configuration": "Tenant configuration",
                "tenant-settings": "Tenant settings",
                "role-permissions": "Role permissions",
                "admin-accounts": "Administrator accounts",
                "trustees": "Trustees",
                "election-event": "Election event",
            },
            upload: "Upload package",
            uploadTitle: "Upload a configuration package",
            uploadSubtitle: "The delivery zip from removable media",
            uploadParagraph: "It is previewed first; nothing is applied from the upload itself.",
            documentId: "Or an uploaded document id",
            preview: "Preview",
            apply: "Apply",
            blocked: "The preview found blockers: fix the package or the tenant, then preview again.",
            noTask: "The platform returned no task.",
            mode: { preview: "Preview", apply: "Application" },
            task: "Task {{taskId}}",
            running: "Running…",
            toChange: "Preview only, nothing changed: {{count}} section(s) would change.",
            outcome: {
                running: "Running",
                previewed: "Previewed: nothing was changed",
                applied: "Applied: the tenant matches the package",
                refused: "Refused before this run applied anything; sections an earlier run applied stay applied, as their states say",
                failed: "Failed part-way: the sections before it may be applied, as their states say",
                unknown: "Unknown: a section could not be settled, and nothing further was submitted; check it again before retrying",
            },
            columns: { section: "Section", state: "State", task: "Task", details: "Details" },
            reconciled: "reconciled",
            blocker: "Blocked",
            needsApply: "Would change",
            members: "Members",
            history: "Earlier applications",
            applyRechecks: "Applying previews the package again on the platform before anything changes, and stops at any blocker.",
            earlierApplied: "Applied by an earlier run",
            earlierTasks: "Tasks begun for this section: {{tasks}}",
            inFlight: "A submission is not settled yet (task {{taskId}})",
            stoppedWithoutRecord: "Stopped without a record: sections may have been applied by this or earlier runs; preview again to see the tenant's state",
            lastLog: "Last message: {{message}}",
            unreadable: "The task cannot be read ({{reason}}). It may still be running: check the earlier applications, or stop following it",
            notFound: "not found in this tenant",
            stopFollowing: "Stop following",
            mayHaveTask: "The outcome of the request is unknown, so a task may have been created: check the earlier applications before retrying.",
            shaMismatch: "The previewed package is not the one whose SHA-256 was entered ({{expected}}); it cannot be applied.",
            confirmTitle: "Apply this package?",
            confirmBody: "This applies the previewed package to tenant {{tenantId}}. The platform previews it again first and stops at any blocker.",
            cancel: "Cancel",
            proposedChanges: "What applying would change",
            shaMalformed: "The SHA-256 entered is not 64 hexadecimal characters, so the package was not previewed. Enter the digest exactly, or leave it blank.",
            nothingToChange: "Nothing: the tenant already matches the package.",
        },
        ballotPrivacy: {
            title: "Ballot box log",
            subtitle: "Every ballot cast in this election, listed under a pseudonym instead of the voter's name.",
            private: "Voters appear only as pseudonyms",
            signed: "Signed by the election authority and the ballot box",
            device: "Checked on your device",
            own: "Your ballot is in the ballot box",
            listedAs: "Listed as",
            check: "Check my ballot",
            copy: "Copy Ballot ID",
            copied: "Ballot ID copied",
            copyFailed: "Could not copy the Ballot ID. Select the code to copy it.",
            search: "Find a Ballot ID or pseudonym",
            placeholder: "Ballot ID or pseudonym",
            clear: "Clear search",
            ballots: "{{count}} ballots",
            matches: "{{count}} of {{total}} ballots match",
            capped: "More than {{count}} of {{total}} ballots match; type more of the code",
            ballotId: "Ballot ID",
            pseudonym: "Pseudonym",
            castAt: "Cast",
            channel: "Channel",
            yours: "Yours",
            channels: {
                online: "Online",
                kiosk: "Kiosk",
                telephone: "Telephone",
            },
            previous: "Previous",
            next: "Next",
            rows: "Rows per page",
            noMatch: "No Ballot ID or pseudonym starts with {{prefix}}",
            noBallots: "No ballots have been cast yet.",
            invalidPrefix: "The codes use the digits 0 to 9 and capital letters, without I, L, O and U. Enter up to eight characters.",
            loadError: "The ballot box log could not be loaded. Please try again.",
            retry: "Try again",
            help: "About the ballot box log",
            helpText: "Each voter is listed under a pseudonym, a code such as 7QKM-2HXD. The log never says who the voter is. The election authority signs which voter key each pseudonym uses. Open a ballot to check its signatures in this browser.",
            detailTitle: "Ballot {{ballotId}}",
            checking: "Checking the signatures…",
            passed: "All four checks passed",
            verified: "Checked on this device with the published keys.",
            failed: "A check failed",
            failedHelp: "Do not rely on this entry.",
            pending: "Still being added to the log",
            pendingHelp: "The signed entries may appear after a ballot is cast. Check again later.",
            proofError: "The signed entries or published keys could not be loaded. Try again.",
            checkLabels: {
                binding: "Voter key registered",
                received: "Ballot received",
                ballotId: "Ballot ID",
                cast: "Ballot cast",
            },
            checkDescriptions: {
                binding: "The election authority signed which voter key this pseudonym uses.",
                received: "The ballot box received a ballot signed with that voter key.",
                ballotId: "The Ballot ID is computed from that signed ballot.",
                cast: "The same key cast the ballot, and the ballot box confirmed the cast.",
            },
            states: {
                passed: "Passed",
                failed: "Does not match.",
                pending: "Not in the log yet.",
            },
            neverPublished: "Never published: the voter's name, username, IP address, country or device.",
            download: "Download signed log entries",
            downloadAction: "Download",
            signedEntries: "Signed log entries ({{count}})",
            close: "Close",
            systemKey: "Election event log key",
            boxKey: "Ballot box key",
            userLogs: "A voter's own entries: sign-ins and messages. Their ballots are in the log under a pseudonym, so they never appear here; only a logged resolution links the two.",
            ballotSection: "Ballot and pseudonym",
            admin: {
                voterKey: "Voter key",
                entries: "This ballot's entries, checked in this browser",
                thisEntry: "This entry",
                entryNumber: "Entry {{id}}",
                receivedTitle: "Ballot {{ballotId}} received",
                castTitle: "Ballot {{ballotId}} cast",
                receivedHelp: "This log's system key signed that the pseudonym uses this voter key; the ballot box signed that it received a ballot signed with it, and the Ballot ID comes from that ballot.",
                castHelp: "The same key cast it, and the ballot box confirmed the cast.",
                pseudonymHelp: "A pseudonym, never the voter",
                neverPublished: "No entry about a ballot names the voter or holds their IP address, country or device. Only a logged resolution links a pseudonym to its voter.",
                signedBy: "The log's system key and the ballot box key",
            },
            resolution: "Pseudonym resolution",
            resolutionHelp: "The answer went only to the person who asked. The voter is never named in this log.",
            reason: "Reason given",
            settings: {
                legacyNetwork: "Forensic attribution is available for new events that use voter pseudonyms. Historical and Datafix events keep their existing ballot identity mode.",
                authority: "The election event log key {{fingerprint}} signs which voter key each pseudonym uses.",
                loading: "Loading privacy permissions",
                loadError: "The current privacy permissions could not be loaded.",
                noRoles: "No role yet",
                title: "Privacy",
                identity: "Voter pseudonyms",
                example: "A pseudonym looks like",
                on: "On: ballots, the log and its exports name a pseudonym for each voter, never the voter.",
                legacy: "This event uses the historical voter identity mode.",
                immutable: "The identity mode is set when the event is created and cannot be changed.",
                network: "Network data",
                description: "The IP address, country and browser of each ballot sent. They are never kept with ballots, voter records or log entries.",
                forensic: "Keep for forensic review",
                forensicHelp: "Kept apart in the forensic store. Only people with Forensic Read see it, and every view is logged.",
                none: "Do not store",
                noneHelp: "Nothing new is kept, and the dashboard's IP Addresses list is not shown. Previously retained forensic data follows its retention policy.",
                permissions: "Who can see or link it",
                permissionHelp: "No preset role holds these permissions. Give them in Users and Roles to the few people who need them.",
                forensicPermission: "Forensic Read",
                forensicPermissionHelp: "Sees the network data in the forensic store",
                resolvePermission: "Resolve a pseudonym",
                resolvePermissionHelp: "Links one pseudonym to its voter, with a reason. Each use is logged.",
                roles: "Manage in Users and Roles",
            },
            forensic: {
                address: "IP address",
                allElections: "All permitted elections",
                exportError: "The forensic records could not be exported.",
                subtitle: "Where ballots were sent from, by pseudonym. Only people with Forensic Read see this list, and each view is logged.",
                store: "Forensic store",
                ballots: "Ballots",
                pseudonyms: "Pseudonyms",
                first: "First ballot",
                last: "Last ballot",
                shared: "Shared",
                sharedHelp: "Ballots of several pseudonyms came from this address, as from a hotel or office network.",
                more: "+{{count}} more",
                view: "View ballots",
                copy: "Copy IP address",
                detailTitle: "IP address {{ip}}",
                detailHelp: "Opening this address was written to the election event’s log. Nobody is named here: each ballot is listed by its pseudonym.",
                error: "The forensic records could not be loaded.",
                empty: "No forensic ballot records for this address.",
                emptyList: "No ballot network records yet.",
            },
        },
        readiness: {
            close: "Close",
            action: "Check readiness",
            title: "Election readiness",
            description: "Compare this official event with a completed rehearsal. A passing check writes signed evidence to this official event’s log.",
            testedEvent: "Tested event",
            archived: "Archived",
            noEvents: "No other events available",
            retry: "Retry",
            eventsError: "Could not load election events.",
            run: "Run check",
            running: "Checking readiness…",
            error: "The check could not be completed. Check Logs before retrying; the response may have been lost after evidence was recorded.",
            downloadError: "Could not download the report. Try again.",
            success: "Readiness verified. Signed evidence was recorded in the official event’s Logs.",
            failed: "Readiness failed. Resolve the failed checks and run again. No readiness entry was recorded.",
            download: "Download JSON report",
            snapshot: "This report is a snapshot. Repeat after relevant changes; it does not freeze the event or replace operational approval.",
            results: "Check results",
            condition: "Condition checked by the server",
            noDetail: "The server reported no further detail for this check.",
            reasons: "Why it failed",
            noArea: "no or an unknown area",
            eventRoles: {
                official: "official",
                tested: "tested",
                both: "both",
            },
            scope: {
                event: "The {{event}} event",
                election: "Election {{election}}",
            },
            certification: {
                declared_sha256_missing: "no declared SHA-256 was given",
                declared_sha256_mismatch: "the declared SHA-256 differs from the file",
                no_counts: "it has no voters by area",
                blank_area: "some voters have no area",
                invalid_sha256: "its SHA-256 is invalid",
            },
            findings: {
                same_event: "The official and tested events are the same event.",
                configuration_missing: "The {{event}} event was not imported from a signed configuration package.",
                configuration_incomplete: "The official event’s signed configuration has no valid value for “{{field}}”.",
                external_id_mismatch: "The events come from different configurations: {{official}} (official) and {{tested}} (tested).",
                content_mismatch: "The signed content differs: SHA-256 {{official}} (official) and {{tested}} (tested).",
                approvers_mismatch: "The verified approvers differ: {{only_official}} only on the official event and {{only_tested}} only on the tested event.",
                areas_mismatch: "{{area}} is only in the {{event}} event’s signed content.",
                voter_import_missing: "The {{event}} event has no certified voter import.",
                voter_import_in_progress: "A voter import is still running on the {{event}} event.",
                voter_file_not_certified: "The {{event}} event’s last voter import is not certified: {{reason}}.",
                voter_receipt_not_signed: "The {{event}} event’s log has no matching signed record of voter import {{import_id}}.",
                registry_count_changed: "The {{event}} event now has {{current}} voters in {{area}}, but its certified import has {{imported}}.",
                voter_area_not_configured: "The {{event}} event’s certified voters include {{area}}, which is not in its signed content.",
                voter_file_mismatch: "The certified voter files differ: SHA-256 {{official}} (official) and {{tested}} (tested).",
                voter_count_mismatch: "The certified files differ in {{area}}: {{official}} voters (official) and {{tested}} (tested).",
                ballots_present: "The official event has {{count}} stored ballots.",
                received_ballots_present: "The official event has {{count}} ballots received for review.",
                tally_sessions_present: "The official event has {{count}} tally sessions.",
                status_missing: "{{scope}} has no voting status.",
                voting_started: "{{scope}}: the {{channel}} channel is {{status}}.",
                voting_dates_recorded: "{{scope}}: the {{channel}} channel has recorded voting dates.",
                no_elections: "The {{event}} event has no elections.",
                publication_missing: "The {{event}} event has no active publication.",
                publication_mismatch: "The {{event}} event’s {{design_count}} published ballot designs do not match every design of its signed configuration.",
                publication_empty: "The {{event}} event’s published ballot designs could not be checked against a signed configuration.",
                channels_open: "The tested event still has voting channels that have not closed.",
                seal_at_close_off: "The tested event does not seal ballot boxes at close.",
                no_expected_boxes: "The tested event’s publication expects no ballot boxes.",
                boxes_unsealed: "Election {{election}} of the tested event has {{unsealed}} unsealed ballot boxes.",
            },
        },
        plugins: {
            title: "Plugins",
            description: "Plugins are bundled with this release. Turning one on adds its menu item and permissions for this tenant; turning it off hides it and keeps its data and permissions.",
            enabled: "On",
            disabled: "Off",
            compatible: "Compatible",
            incompatible: "Stored data needs a newer release",
            api: "Plugin API {{major}}",
            permissions: "Permissions",
            adminGroup: "granted to the admin group when turned on",
            enable: "Turn on",
            disable: "Turn off",
            confirmEnableTitle: "Turn on {{name}}?",
            confirmDisableTitle: "Turn off {{name}}?",
            confirmEnable: "{{name}} appears in the menu for users with its permissions. Its permissions are created in this tenant and granted to the admin group.",
            confirmDisable: "{{name}} is hidden and its requests are refused. Its data, history and permissions are kept, and nothing else in the tenant changes.",
            confirm: "Confirm",
            noPermission: "Changing plugins needs the tenant-write permission.",
            retry: "Retry",
            loading: "Loading plugins…",
            signIn: "Sign in to the selected tenant to use its plugins.",
            unavailable: "This plugin is not part of this release.",
            incompatibleRoute: "This plugin's stored data needs a newer release. Its data is unchanged.",
            disabledRoute: "{{name}} is not turned on for this tenant. A tenant administrator can turn it on in Settings → Plugins.",
            forbidden: "You don't have permission to use {{name}}.",
        },
        projects: {
            title: "Projects",
            subtitle: "Plan tenant work on a timeline. Projects never change election schedules.",
            cancel: "Cancel",
            retry: "Retry",
            loading: "Loading…",
            list: {
                create: "New project",
                import: "Import",
                emptyTitle: "No projects yet",
                emptyHelp: "Create a project, or import a CSV file exported from another project.",
                emptyViewer: "No projects have been created in this tenant.",
                active_one: "Active ({{count}})",
                active_other: "Active ({{count}})",
                archived_one: "Archived ({{count}})",
                archived_other: "Archived ({{count}})",
                name: "Name",
                dates: "Dates",
                tasks: "Tasks",
                timezone: "Timezone",
                updated: "Last change",
                updatedBy: "{{at}} · {{actor}}",
                archivedChip: "Archived",
                noneInTab: "No projects here.",
            },
            create: {
                title: "New project",
                name: "Project name",
                timezone: "Timezone",
                timezoneHelp: "Every date in the project is entered and shown in this IANA timezone.",
                submit: "Create project",
            },
            import: {
                title: "Import a project",
                help: "Importing always creates a new project. Use a UTF-8 CSV file with the columns {{columns}}, as exported from a project, with a UTC offset on every date. Nothing is saved until you create the project.",
                choose: "Choose CSV file",
                noFile: "No file chosen",
                fileLimit: "The file must be at most 1 MiB.",
                invalidFile: "The file is not valid UTF-8 text.",
                valid_one: "{{count}} task is ready to import.",
                valid_other: "{{count}} tasks are ready to import.",
                invalid_one: "{{count}} of {{total}} rows has errors. Correct the file and choose it again.",
                invalid_other: "{{count}} of {{total}} rows have errors. Correct the file and choose it again.",
                previewTable: "Import preview",
                line: "Line",
                result: "Check",
                rowValid: "Ready",
                commit: "Create project",
            },
            detail: {
                timezone: "All dates and times are in {{timezone}}.",
                export: "Export",
                archive: "Archive",
                restore: "Restore",
                addTask: "Add task",
                viewOnly: "View only. Changing tasks needs the projects-write permission.",
                archivedNotice: "This project is archived. Restore it to change its tasks.",
            },
            notices: {
                saved: "Saved “{{title}}”.",
                moved: "Saved “{{title}}”: {{start}} – {{end}}.",
                deleted: "Deleted “{{title}}”.",
                archived: "Project archived.",
                restored: "Project restored.",
            },
            panel: {
                details: "Task details",
                edit: "Edit task",
                add: "Add task",
                close: "Close task details",
                hint: "Select a task on the timeline to see its details here.",
                noTasks: "This project has no tasks yet.",
            },
            conflict: {
                body: "Someone else changed this task ({{actor}}, {{at}}). Your changes are still here. Review their version before saving again.",
                load: "Load their version",
            },
            unsaved: {
                body: "You have unsaved changes. Save them, or discard them to {{action}}.",
                keep: "Keep editing",
                discard: "Discard changes",
                actions: {
                    open: "open “{{title}}”",
                    add: "add a new task",
                    leave: "go back to the projects",
                    close: "close the task",
                    state: "change the project",
                },
            },
            deleteDialog: {
                title: "Delete task?",
                body: "“{{title}}” is removed from the project. Its change history is kept.",
                confirm: "Delete",
            },
            history: {
                task: "Change history",
                project: "Project history",
                empty: "No changes recorded yet.",
                more: "Show older changes",
                by: "{{actor}} · {{at}}",
                actions: {
                    create: "Created {{subject}}",
                    update: "Changed {{subject}}",
                    delete: "Deleted {{subject}}",
                    import_one: "Imported {{count}} task",
                    import_other: "Imported {{count}} tasks",
                    export: "Exported as CSV",
                    other: "{{action}}",
                },
            },
            editor: {
                title: "Title",
                type: "Type",
                status: "Status",
                start: "Start",
                end: "End",
                at: "Date and time",
                notes: "Notes",
                order: "Order",
                orderHelp: "Tasks are listed by order, then by start.",
                timezoneNote: "Times are in {{timezone}}.",
                offset: "UTC{{offset}}",
                localTime: {
                    invalid: "Enter a date and time between 1900 and 2200.",
                    skipped: "This time doesn't exist in {{timezone}}: the clocks skip it. Choose another time.",
                    repeated: "This time happens twice in {{timezone}}. Choose which one you mean.",
                },
                chooseInstant: "Which occurrence",
                instantChoice: "At UTC{{offset}}",
                saving: "Saving…",
                toFix_one: "{{count}} field to fix",
                toFix_other: "{{count}} fields to fix",
                save: "Save",
                delete: "Delete",
            },
            validation: {
                title: "Enter a title of at most 200 characters.",
                offset: "Enter valid dates.",
                range: "The end must be after the start.",
                milestone: "A milestone has no end.",
                notes: "Notes must be at most 16,000 characters.",
                order: "Order must be a whole number from 0 to 1,000,000.",
            },
            status: {
                not_started: "Not started",
                in_progress: "In progress",
                done: "Done",
            },
            type: {
                task: "Task",
                milestone: "Milestone",
            },
            units: {
                days_one: "{{count}} day",
                days_other: "{{count}} days",
                hours_one: "{{count}} h",
                hours_other: "{{count}} h",
                minutes_one: "{{count}} min",
                minutes_other: "{{count}} min",
            },
            timeline: {
                title: "Timeline",
                tasks_one: "{{count}} task",
                tasks_other: "{{count}} tasks",
                empty: "No tasks yet.",
                editHelp: "Point at or focus a task for a summary; select it to edit below. Drag a bar or use ← → to move it by 24 hours; add Shift to change the end.",
                viewHelp: "Point at or focus a task for a summary. Select it to see its details below.",
                touchEditHelp: "Tap a task to edit it below, or drag a bar to move it by whole days.",
                touchViewHelp: "Tap a task to see its details below.",
                taskLabel: "{{title}}, {{start}} to {{end}}, {{status}}",
                milestoneLabel: "{{title}}, milestone at {{at}}, {{status}}",
                previewEdit: "Click or press Enter to edit",
                previewView: "Click or press Enter for details",
            },
        },
        philippinePassport: "Passport",
        seamanBook: "Seafarer's Book",
        philSysID: "PhilSys ID",
        iBP: "Integrated Bar of the Philippines ID",
        driversLicense: "Driver's License",
        loading: "Loading...",
        loadingDataProvider: "Loading data provider...",
        tallySheetImport: {
            title: "Tally sheet imports",
            subtitle: "Import ES&S or CSV tally sheet files, preview the generated ballot boxes, and approve them before they create tally sheets.",
            createTitle: "Import tally sheets",
            detailTitle: "Tally sheet import",
            empty: "No tally sheet imports yet.",
            emptyBody: "Start by importing an ES&S Enhanced XML or canonical CSV file for this election event.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "Canonical CSV",
            },
            channel: {
                PAPER: "Paper",
                POSTAL: "Postal",
                IN_PERSON: "In person",
            },
            table: {
                created: "Created",
                createdBy: "Created by",
                file: "File",
                format: "Format",
                channel: "Channel",
                status: "Status",
                labels: "Labels",
                annotations: "Annotations",
                actions: "Actions",
            },
            summary: {
                imported: "Imported",
                changed: "Changed",
                new: "New",
                unchanged: "Unchanged",
                conflicted: "Conflicted",
                errors: "Errors",
            },
            status: {
                PENDING_REVIEW: "Pending review",
                APPROVED: "Approved",
                DISAPPROVED: "Disapproved",
                FAILED_VALIDATION: "Failed validation",
                CONFLICTED: "Conflicted",
                NEW: "New",
                CHANGED: "Changed",
                UNCHANGED: "Unchanged",
            },
            fields: {
                format: "Format",
                channel: "Channel",
                supportedFormats: "Supported formats: XML, CSV",
                generatedTallySheet: "Generated tally sheet",
                sourceCandidates: "Source candidate IDs",
                none: "None",
            },
            actions: {
                create: "Import tally sheets",
                review: "Review",
                source: "Source",
                cancel: "Cancel",
                preview: "Preview",
                save: "Save import",
                approve: "Approve",
                disapprove: "Disapprove",
                close: "Close",
                openExisting: "Open existing",
            },
            notifications: {
                selectFile: "Select an import file before previewing it",
                duplicateSource: "This source file hash already appears in a previous tally sheet import.",
                uploadUrlError: "Could not create upload URL",
                uploadError: "Could not upload import file",
                previewEmpty: "Preview response was empty",
                previewError: "Could not preview import",
                importEmpty: "Import response was empty",
                created: "Tally sheet import created",
                createError: "Could not create import",
                reviewEmpty: "Review response was empty",
                conflicted: "Import has stale baseline conflicts",
                approved: "Import approved",
                disapproved: "Import disapproved",
                reviewError: "Could not review import",
                sourceUrlError: "Could not create source download URL",
                sourceDownloadError: "Could not download source file",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} of {{total}}",
                previous: "Previous",
                next: "Next",
            },
        },
        reconciliation: {
            menuButton: "Ext. voters sync",
            categories: {
                VOTED_INTERNET: "Voted via Internet",
                VOTED_OTHER_CHANNEL: "Voted via other channel",
                DISABLED_DELETE_CALL: "Voter disabled",
                DELETION_REVERTED: "Deletion reverted",
                PROFILE_UPDATE: "Profile update",
                VOTER_ADDED: "Voter added",
                REENABLED: "Voter re-enabled",
                VOTED_UNMARKED: "Voter unmarked as voted",
                ROW_FAILURE: "Row failure",
            },
            table: {
                voterId: "Voter ID",
                field: "Field",
                category: "Category",
                currentValue: "Current value",
                newValue: "New value",
                reason: "Reason",
                rowLabel: "Row",
                noDifferences: "No differences found - the systems are in sync.",
            },
            wizard: {
                title: "External reconciliation sync",
                subtitle: "Synchronize the voter list with the external system",
                drop: {
                    description: "Drop the reconciliation file the external system produced - both diffs (external-side and Sequent-side) are calculated automatically and shown in separate tables.",
                    fileFormatLabel: "CSV file",
                    uploading: "Uploading {{fileName}} and calculating both diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Sequence {{sequence}}, generated {{generatedAt}}",
                    rowFailuresWarning: "{{count}} row(s) could not be reconciled safely and are excluded from both diffs - see below for details.",
                    noDifferences: "No differences - the two systems are already in sync.",
                    diffOnlyDifferences: "This is a convergence check for an already applied Sequence. Differences are shown for follow-up, but this round cannot be applied again.",
                    externalDiffTitle: "External diff",
                    sequentDiffTitle: "Sequent diff",
                    downloadExternalPatch: "Download external patch",
                    externalDiffCaption: "Download the patch and deliver it to the external system outside this tool. Once it applies the patch and produces the next reconciliation file, click 'Back' and drop that file in - 'Apply' unlocks once this table is empty.",
                    noExternalDifferences: "No external-side differences.",
                    sequentDiffCaption: "Apply changes directly to Sequent by clicking 'Apply' - no patch file is generated for these.",
                    noSequentDifferences: "No Sequent-side differences.",
                },
                applying: {
                    inProgress: "Applying Sequent-side changes...",
                    rowFailures: "{{count}} row(s) were excluded from this round and need manual follow-up - see below for details.",
                    rowFailuresTruncated: "Showing the first {{shown}} of {{count}} row failures. Resolve the shared cause and retry to see any remaining failures.",
                    success: "All Sequent-side changes applied successfully.",
                },
                actions: {
                    cancel: "Cancel",
                    back: "Back",
                    apply: "Apply",
                    next: "Next",
                    startOver: "Start over",
                    close: "Close",
                },
                confirm: {
                    title: "Confirm reconciliation changes",
                    categoriesNote: "Categories outlined in orange ({{categories}}) touch voted status or disable voters.",
                    applyChanges: "Apply changes",
                    continue: "Continue",
                },
                summary: {
                    votedOtherChannel: "marks {{count}} voter(s) as voted via other channels",
                    disabled: "disables {{count}} voter(s)",
                    reenabled: "re-enables {{count}} voter(s)",
                    votedUnmarked: "unmarks {{count}} voter(s) as voted",
                    profileUpdated: "updates {{count}} profile(s)",
                    voterAdded: "adds {{count}} voter(s)",
                    prefix: "This will apply changes that {{parts}}.",
                    empty: "There are no Sequent-side changes to apply.",
                },
                notifications: {
                    envelopeLoadError: "Failed to load the reconciliation diff - please try again.",
                    generateFailed: "Failed to calculate the reconciliation diff - see the task widget for details.",
                    applyFailed: "Failed to apply the Sequent-side changes - see the task widget for details.",
                    uploadUrlError: "Failed to get an upload URL",
                    generateTaskError: "Failed to start the reconciliation diff task",
                    uploadError: "Failed to upload the reconciliation file",
                    applyTaskError: "Failed to start the apply task",
                    applyError: "Failed to apply the reconciliation changes",
                },
            },
        },
        tenantLogs: {
            explanation: {
                action: "Action: {{action}}",
                outcome: {
                    succeeded: "Accepted (HTTP {{status}})",
                    denied: "Denied (HTTP {{status}})",
                    failed: "Failed (HTTP {{status}})",
                },
                by: "Requested by {{username}} ({{userId}})",
                detail: "{{name}}: {{value}}",
                board: "Log: {{board}}",
                publicKey: "Public key of the log: {{key}}",
            },
        },
        logsScreen: {
            configurationPackage: {
                imported: "Configuration {{externalId}} revision {{revision}} imported from a signed package.",
                fields: {
                    action: "Action",
                    external_id: "External ID",
                    revision: "Revision",
                    manifest_sha256: "Manifest SHA-256",
                    content_hash: "Content hash",
                    design_digests: "Ballot design digests",
                },
            },
            readiness: {
                passed: "Passed",
                failed: "Failed",
                checkResult: "{{outcome}}: {{description}}",
                checkResultWithMessage: "{{outcome}}: {{description}} Recorded condition: “{{message}}”",
                description: {
                    VotersImported: "Voter file imported.",
                    ReadinessVerified: "Official event readiness verified against the tested event.",
                },
                checks: {
                    configuration: "Both events have the same approved content, verified approvers and areas.",
                    certified_voters: "Both events match the same certified voter file and current counts by area.",
                    official_zero: "The official event has never opened voting and has no ballots or tally sessions.",
                    publication: "The official publication matches its signed configuration.",
                    tested_finished: "The tested event’s voting channels are closed and all expected ballot boxes are sealed.",
                },
                fields: {
                    report: "Readiness report",
                    passed: "Passed",
                    checked_at: "Checked at",
                    evidence: "Evidence",
                    official: "Official event",
                    tested: "Tested event",
                    official_event_id: "Official event ID",
                    tested_event_id: "Tested event ID",
                    event_id: "Event ID",
                    election_id: "Election ID",
                    configuration: "Configuration",
                    external_id: "External ID",
                    revision: "Revision",
                    content_sha256: "Content SHA-256",
                    manifest_sha256: "Manifest SHA-256",
                    approvers: "Verified approvers",
                    areas: "Areas",
                    voters: "Voter import",
                    import_id: "Import ID",
                    document_id: "Document ID",
                    file_name: "File name",
                    sha256: "File SHA-256",
                    declared_sha256: "Declared SHA-256",
                    counts_by_area: "Voters by area",
                    imported_at: "Imported at",
                    voter_log_delivered: "Signed import recorded",
                    current_voter_counts: "Current voters by area",
                    voter_import_in_progress: "Voter import active",
                    status: "Status",
                    elections: "Elections",
                    ballot_count: "Ballots stored",
                    received_ballot_count: "Ballots received at review",
                    tally_session_count: "Tally sessions",
                    publication: "Publication",
                    publication_id: "Publication ID",
                    publication_ids: "Publication IDs",
                    matches_manifest: "Matches signed manifest",
                    design_count: "Published designs",
                    seal_at_close: "Seal at close",
                    expected_boxes: "Expected ballot boxes",
                    sealed_boxes: "Sealed ballot boxes",
                    all_channels_closed: "All voting channels closed",
                    locked_down: "Locked down",
                    log_entry_id: "Log entry ID",
                },
            },
            noPermissions: "You don't have permission to access logs.",
            title: "Logs",
            subtitle: "Everything done in this election event. Sign-ins and changes outside it are in Settings > Logs.",
            empty: "No entries found.",
            tenant: {
                subtitle: "Sign-ins, staff accounts and roles, settings and election events of this organization. Each election event keeps its own log in its Logs tab.",
                noPermissions: "You don't have permission to see this log.",
            },
            entry: {
                title: "Log entry {{id}}",
                statementKind: "Statement kind",
                eventType: "Event Type",
                logType: "Log Type",
                when: "When",
                utc: "{{time}} UTC",
                who: "Who",
                userId: "User ID {{id}}",
                role: "Role {{role}}",
                unknownAccount: "Unknown account (the name typed is not recorded)",
                madeIn: "Made in",
                changed: "Changed",
                objectId: "ID {{id}}",
                actionLabel: "Action",
                details: "Details",
                origin: {
                    "hasura": "Admin Portal (through Hasura)",
                    "harvest": "Admin Portal (through Harvest)",
                    "windmill": "Admin Portal (a Windmill task)",
                    "keycloak-console": "Keycloak's admin console, outside the Admin Portal",
                    "service-account": "Step's service account, for a change made in the Admin Portal",
                },
                action: {
                    create: "Created",
                    update: "Updated",
                    delete: "Deleted",
                    import: "Imported",
                    export: "Exported",
                    archive: "Archived",
                    unarchive: "Unarchived",
                    enable: "Enabled",
                    disable: "Disabled",
                    reset_password: "Password reset",
                    grant: "Granted",
                    revoke: "Revoked",
                },
                objectType: {
                    tenant: "Tenant settings",
                    tenant_log: "Tenant log",
                    staff_account: "Staff account",
                    role: "Role",
                    template: "Template",
                    trustee: "Trustee",
                    election_type: "Election type",
                    election_event: "Election event",
                    election: "Election",
                    contest: "Contest",
                    candidate: "Candidate",
                    area: "Area",
                },
                values: {
                    title: "Old and new values",
                    field: "Field",
                    old: "Old value",
                    new: "New value",
                    none: "(none)",
                    secret: "Changed. Secret values are never logged.",
                    yes: "Yes",
                    no: "No",
                    sha: "SHA-256 {{hash}}",
                },
                field: {
                    tenant: {
                        slug: "Short name",
                        isActive: "Active",
                        logsTimezone: "Timezone for tenant logs (Languages)",
                        languages: "Languages",
                        enabledLanguages: "Enabled languages (Languages)",
                        defaultLanguage: "Default language (Languages)",
                        languageDetection: "Language detection (Languages)",
                        translations: "Translations (Localization)",
                        sms: "SMS",
                        mail: "Email",
                        gapiKey: "Google API key (Integrations)",
                        gapiEmail: "Google API email (Integrations)",
                        helpLinks: "Help links (Look & Feel)",
                        displayName: "Organization name (Look & Feel)",
                        votingCountries: "Countries blocked from voting (Countries)",
                        enrollCountries: "Countries blocked from enrollment (Countries)",
                        logoUrl: "Logo (Look & Feel)",
                        css: "Custom CSS (Look & Feel)",
                        votingChannels: "Voting Channels",
                        onlineVoting: "Online voting (Voting Channels)",
                        kioskVoting: "Kiosk voting (Voting Channels)",
                        telephoneVoting: "Telephone voting (Voting Channels)",
                        earlyVoting: "Early voting (Voting Channels)",
                        paperVoting: "Paper voting (Voting Channels)",
                    },
                },
                signIn: {
                    title: "Sign-in and account security",
                    event: "Keycloak event",
                    error: "Error",
                    authentication: "Authentication",
                    credential: "Credential",
                    failures: "Failures in a row",
                    client: "Client",
                    ipAddress: "IP address",
                },
                keycloak: {
                    title: "Change in Keycloak",
                    account: "Account",
                    operation: "Operation",
                    appliesTo: "Applies to",
                    resource: "Resource",
                    newValue: "New value",
                    error: "Error",
                },
                importedFile: {
                    title: "The imported file",
                    declared: "Declared checksum",
                    sha256: "SHA-256 of the file",
                    declaredSha256: "Declared SHA-256",
                    document: "Document",
                    checksum: {
                        undeclared: "None declared",
                        matches: "Matches the file",
                        mismatch: "Doesn't match the file",
                    },
                    counts: {
                        count: "Rows",
                        elections: "Elections",
                        contests: "Contests",
                        candidates: "Candidates",
                        areas: "Areas",
                        area_contests: "Areas per contest",
                        sections: "Configuration sections",
                    },
                },
                deletedEvent: {
                    title: "The deleted election event's log",
                    lastEntry: "Last entry",
                    stateHash: "State hash",
                    logDatabase: "Log database",
                    status: "Status",
                    retired: "Unloaded and kept until it is erased under the retention policy",
                    task: "Task",
                    systemKey: "The log's system key",
                },
                exported: {
                    title: "Export",
                    entries: "Entries",
                    sha256: "SHA-256 of the file",
                    document: "Document",
                    scope: {
                        TENANT_LOG: "The whole tenant log",
                        ACCOUNT: "One account",
                        ACCOUNT_WITH_EVENTS: "One account, with its entries in every election event",
                        ALL: "The whole election event",
                        ELECTION: "One election",
                        AREA: "One area",
                    },
                },
                writer: {
                    title: "Log writer",
                    release: "Release",
                    lastEntry: "Last entry posted",
                },
                signatures: {
                    title: "Log and signatures",
                    log: "Log",
                    tenantLog: "Tenant log",
                    eventLog: "Election event log",
                    signedBy: "Signed by",
                    adminKey: "{{name}}'s admin key",
                    systemOnly: "The log's system key only",
                    systemSignature: "System signature",
                    publicKey: "Published admin key",
                },
            },
            actions: {
                csv: "Export in CSV",
                pdf: "Export in PDF",
                audit: "Audit",
            },
            auditDialog: {
                title: "Audit electoral log",
                confirm: "Audit",
                description: "The audit checks every log entry against its Merkle log and verifies the published checkpoints. The result is recorded as a task.",
            },
            exportdialog: {
                description: "Please confirm you want to execute this action, it might take a while to execute.",
                title: "Export logs",
                from: "From",
                to: "To",
                timeZone: "Timezone",
                format: "Format",
                csv: "CSV",
                pdf: "PDF",
                sql: "SQL",
                scope: {
                    label: "Scope",
                    tenant: {
                        TENANT_LOG: "The whole tenant log",
                        ACCOUNT: "One account",
                    },
                    event: {
                        ALL: "The whole election event",
                        ELECTION: "One election",
                        AREA: "One area",
                        ACCOUNT: "One account",
                    },
                },
                username: "Username",
                election: "Election",
                area: "Area",
                withElectionEvents: "Include this account's entries in every election event",
                rowsNameLog: "Rows from election events name their log.",
                recorded: "The export itself is recorded in this log.",
                zoneNote: "Each row keeps its time in UTC (ISO 8601) and in {{abbr}}, with the timezone name. The date range includes both ends, in {{abbr}}.",
                zoneNotePdf: "The PDF prints each time in {{abbr}}. The date range includes both ends, in {{abbr}}.",
                rowZones: "Each row's election timezone",
                zoneNoteRows: "Each row keeps its time in UTC (ISO 8601) and in its election's timezone, with the timezone name. The date range includes both ends, in {{abbr}}.",
                zoneNoteRowsPdf: "The PDF prints each time in its election's timezone. The date range includes both ends, in {{abbr}}.",
            },
            filter: {
                createdFrom: "Created from",
                createdTo: "to",
                statementTimestampFrom: "Statement Timestamp from",
                statementTimestampTo: "Statement Timestamp to",
                timeZone: "Timezone",
            },
            scheduledOutcome: {
                outcome: {
                    "waiting-for-initialization": "Waiting for initialization",
                    "runs": "runs",
                    "runs-unsigned": "runs without signatures",
                    "refused": "refused",
                },
                check: {
                    "initialization": "Required initialization is incomplete",
                    "voting-close": "Voting cannot open at or after its close deadline",
                    "needs-signatures": "signatures needed",
                    "covered": "in the signed configuration",
                    "unsigned-close": "close without signatures",
                    "stricter-copy": "current or published settings",
                    "defaults": "nothing published yet",
                },
                changed: "Now {{after}} (was: {{before}}).",
                result: "Outcome: {{outcome}}.",
                deciding: "Deciding check: {{check}}. {{value}}",
                authorizedBy: "Authorized by configuration {{code}}.",
                nextStep: "Next step: {{step}}",
                reason: {
                    "ballot-box-seal-policy": "Kept closed: with Seal at close, voting that has closed stays closed.",
                    "never-opened-kept-open": "Nothing to close on schedule: the Post never opened, so it stays as it is.",
                },
            },
            column: {
                id: "Id",
                statement_kind: "Statement kind",
                created: "Created",
                statement_timestamp: "Statement Timestamp",
                message: "Message",
                user_id: "User Id",
                username: "Username",
                sender_pk: "Sender Pk",
                log_type: "Log Type",
                event_type: "Event Type",
                description: "Description",
                version: "Version",
            },
            main: {
                title: "Main Database Logs",
            },
            iam: {
                title: "IAM Database Logs",
            },
            ballotBoxSeal: {
                sealHash: "Seal hash: {{hash}}",
                counted: "{{counted}} of {{inBox}} ballots counted.",
                notCounted_one: "The other ballot was replaced by the voter's later ballot, discarded, or cast by a voter who is not eligible.",
                notCounted_other: "The other {{count}} ballots were replaced by the voter's later ballot, discarded, or cast by a voter who is not eligible.",
                closeRequest: "Closed by the Close voting request {{request}}.",
                noCloseRequest: "Closed without a Close voting request (Stop Voting or the scheduled close).",
                failedReason: "Why: {{reason}}",
                failedLocked: "The ballot box stays locked and is not sealed: an incident.",
                verifiedCounted: "{{counted}} ballots counted from the seal.",
                tallySession: "Tally session {{session}}.",
                differs: "What differs: {{differs}}",
            },
        },
        tasksScreen: {
            noPermissions: "You don't have permission to access logs.",
            title: "Tasks Execution",
            subtitle: "Information about the executed tasks",
            taskInformation: "Task Information",
            status: "status: {{status}}",
            ok: "Ok",
            column: {
                id: "Index",
                name: "Task name",
                type: "Type",
                execution_status: "Status",
                start_at: "Start time",
                end_at: "End time",
                executed_by_user: "Executer",
                annotations: "Annotations",
                labels: "Labels",
                logs: "Logs",
            },
            tasksExecution: {
                DELETE_TENANT: "Delete tenant",
                PUBLISH_BALLOT: "Publish Ballot",
                EXPORT_ELECTION_EVENT: "Export Election Event",
                CREATE_ELECTION_EVENT: "Create Election Event",
                IMPORT_ELECTION_EVENT: "Import Election Event",
                IMPORT_USERS: "Import Users",
                EDIT_USER: "Edit Voter",
                IMPORT_CANDIDATES: "Import Candidates",
                EXPORT_VOTERS: "Export Voters",
                CREATE_TRANSMISSION_PACKAGE: "Create Transmission Package",
                EXPORT_BALLOT_PUBLICATION: "Export Ballot Publication",
                EXPORT_ACTIVITY_LOGS_REPORT: "Export Activity Logs Report",
                EXPORT_TENANT_LOGS: "Export Tenant Logs",
                EXPORT_MONITORING_DATA: "Export Monitoring Data",
                GENERATE_REPORT: "Generate Report",
                GENERATE_TRANSMISSION_REPORT: "Generate Transmission Report",
                EXPORT_TRUSTEES: "Export Trustees",
                EXPORT_APPLICATION: "Export Applications",
                EXPORT_TENANT_CONFIG: "Export Tenant Config",
                IMPORT_TENANT_CONFIG: "Import Tenant Config",
                APPLY_CONFIGURATION_PACKAGE: "Apply Configuration Package",
                RENDER_DOCUMENT_PDF: "Render Document PDF",
                CREATE_TENANT: "Create Tenant",
                EXPORT_TEMPLATES: "Export Templates",
                IMPORT_TEMPLATES: "Import Templates",
                DELETE_ELECTION_EVENT: "Delete Election Event",
                DELETE_VOTERS: "Delete Voters",
                PREPARE_PUBLICATION_PREVIEW: "Prepare Publication Preview",
                EXPORT_TALLY_RESULTS_XLSX: "Export Tally Results in XLSX format",
                EXPORT_CERTIFICATE_AUTHORITIES: "Export Certificate Authorities",
                PUBLISH_RESULTS_WEBSITE: "Publish Results Website",
                VOTER_INFORMATION_LETTER: "Voter Information Letter",
                AUDIT_ELECTORAL_LOG: "Audit Electoral Log",
            },
            documentAccess: {
                title: "Document access",
                sensitivityNotice: "Sensitive information. Share this password only with the intended recipient.",
                passwordLabel: "Password to open the encrypted PDF",
                showPassword: "Show password",
                copyPassword: "Copy password",
                passwordCopied: "Password copied",
                passwordError: "The PDF password could not be retrieved",
                copyError: "The password could not be copied",
                guidance: "The password is loaded only after you choose Show password. After it loads, a read-only field with copy appears here.",
            },
            widget: {
                taskTitle: "Task: {{title}}",
                viewTask: "View Task",
                downloadDocument: "Download File",
                downloadHashManifest: "Hash manifest",
            },
            exportTasksExecution: {
                success: "Export finished successfully",
                error: "Error exporting Tasks Execution",
            },
        },
        areas: {
            common: {
                title: "Areas",
                subTitle: "Area configuration.",
                deleteError: "Error deleting area",
            },
            createAreaSuccess: "Area created",
            updateAreaSuccess: "Area updated",
            createAreaError: "Could not create Area",
            sequent_backend_area_contest: "Contests",
            empty: {
                header: "No Areas yet.",
                action: "Create Area",
            },
            formImputs: {
                allowEarlyVoting: "Allow Early Voting",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Google Calendar Service Account Key",
                gapiEmail: "Google Calendar Authentication Email",
                gapiKeyHelper: "The stored key is not shown. Paste a new key to replace it.",
                gapiKeySaved: "Google Calendar Service Account Key saved",
            },
            errors: {
                invalidGapiKey: "Invalid Google Calendar Service Account Key format",
                saveGapiKey: "Could not save the Google Calendar Service Account Key",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Help Links",
                logoUrl: "Logo URL",
                css: "Custom CSS",
                displayName: "Display name",
                displayNameHelp: "The organization's name in messages that name it. Empty: the tenant's short name.",
            },
            errors: {
                invalidHelpLinks: "Invalid Help Links format",
            },
        },
        electionTypeScreen: {
            noPermissions: "You don't have permission to access settings.",
            common: {
                title: "Election Type",
                subtitle: "Election type configuration",
                onlineVoting: "Online Voting",
                kioskVoting: "Kiosk Voting",
                telephoneVoting: "Telephone Voting",
                settingTitle: "Settings",
                settingSubtitle: "General Configuration",
                createNew: "Create Election Type",
                emptyHeader: "No Election Types yet.",
                emptyBody: "Do you want to create one?",
            },
            create: {
                title: "Create Election Type",
            },
            edit: {
                title: "Edit Election Type",
            },
            tabs: {
                votingChannels: "VOTING CHANELS",
                electionTypes: "ELECTION TYPES",
                languages: "LANGUAGES",
                localization: "LOCALIZATION",
                integrations: "Integrations",
                lookAndFeel: "Look & Feel",
                schedules: "SCHEDULED EVENTS",
                trustees: "TRUSTEES",
                BackupRestore: "Backup / Restore",
                logs: "Logs",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "No Trustees yet.",
                createNew: "Create Trustee",
                title: "Trustee",
                subtitle: "Trustee configuration",
                emptyBody: "Do you want to create one?",
            },
            create: {
                title: "Create Trustee",
            },
            edit: {
                title: "Edit Trustee",
            },
        },
        scheduleScreen: {
            noPermissions: "You don't have permission to access settings.",
            createScheduleSuccess: "Schedule created",
            createScheduleError: "Error creating schedule",
            deleteScheduleSuccess: "Schedule deleted",
            deleteScheduleError: "Error deleting schedule",
            common: {
                title: "Scheduled",
                subtitle: "Schedules configuration",
                createNew: "Create Schedule",
                emptyHeader: "No Schedule yet.",
                emptyBody: "Do you want to create one?",
            },
            create: {
                title: "Create Schedule",
                selectSchedule: "Select one schedule from the predefined list or write a custom one",
            },
            edit: {
                title: "Edit Schedule",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "System lockdown for finalization of Internet voting settings",
                START_PRE_REGISTRATION_OVCS: "Start and end of pre-registration for OVCS",
                END_PRE_REGISTRATION_OVCS: "End of pre-registration for OVCS",
                START_TEST_VOTING_PERIOD: "Start of test voting period",
                END_TEST_VOTING_PERIOD: "End of test voting period",
                START_INTERNET_VOTING_PERIOD: "Start of Internet voting period",
                END_INTERNET_VOTING_PERIOD: "End of Internet voting period",
                LAB_TEST: "Lab test",
                FIELD_TEST: "Field test",
                MOCK_ELECTIONS: "Mock elections",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Votes by day",
            votesOverTime: "Votes over time",
            timeResolution: "Time resolution",
            timeRange: "Time range",
            minute: "Minute",
            hour: "Hour",
            day: "Day",
            votersByChannels: "Voters by channel",
            voterLoginURL: "Voter Login URL",
            voterEnrollURL: "Voter Enroll URL",
            voterEnrollKioskURL: "Voter Enroll Kiosk URL",
            ballotBoxes: {
                show: "Show ballot boxes",
                loadError: "The ballot boxes' seals could not be read. Reload the page, or check the connection to the server.",
                title: "Ballot boxes",
                sealing: "Voting closed at {{closed}}. The ballot boxes are sealed when the grace period ends, at {{deadline}}.",
                sealed: "Voting closed at {{closed}}. The ballot boxes are sealed: no ballot can be added, changed or deleted.",
                failed: "Voting closed at {{closed}}. A ballot box could not be sealed: it stays locked, and the incident is in the logs.",
                closedBySignatures: "Closed by {{names}} with their certificates, signing code {{code}}.",
                closedByUser: "Closed by {{username}}.",
                closedBySchedule: "Closed by the scheduled close of polls.",
                column: {
                    area: "Area",
                    status: "Status",
                    inTheBox: "In the box",
                    counted: "Counted",
                    sealedAt: "Sealed",
                    sealHash: "Seal hash",
                    record: "Seal record",
                },
                status: {
                    open: "Open",
                    sealing: "Sealing at {{time}}",
                    publishing: "Sealed, publishing",
                    sealed: "Sealed",
                    failed: "Not sealed: incident",
                    due: "Sealing now",
                    overdue: "Sealing overdue",
                },
                help: {
                    publishing: "The ballot box is locked and its seal is on the bulletin board. Its seal record is being published.",
                    counted: "Ballots that count: each eligible voter's latest valid ballot. The others in the box were replaced by the voter's later ballot, discarded, or cast by a voter who is not eligible.",
                },
                copyHash: "Copy seal hash",
                copied: "Seal hash copied",
                copyError: "Could not copy the seal hash",
                notYet: "Not yet",
                openRecord: "Open the seal record of {{area}}",
                downloadRecord: "Download the seal record of {{area}}",
                recordRestricted: "Restricted: ask an administrator who can download documents.",
                recordError: "The seal record could not be downloaded. Try again.",
                recordMissing: "The seal record document is missing: report it as an incident.",
                beforeClose: "The ballot box of each area is sealed when voting closes.",
                notStarted: "Voting hasn't opened yet. The ballot box of each area is sealed when voting closes.",
                openOn: "Voting is open on {{channels}}. The ballot box of each area is sealed when voting closes.",
                paused: "Voting is paused. The ballot box of each area is sealed when voting closes.",
                holding_one: "{{channels}} is enabled and not closed: stop it to seal the ballot boxes.",
                holding_other: "{{channels}} are enabled and not closed: stop them to seal the ballot boxes.",
                sealingNow: "Voting closed at {{closed}}. The ballot boxes are being sealed.",
                sealingPastGrace: "Voting closed at {{closed}}. The grace period ended at {{deadline}}; the ballot boxes are being sealed.",
                why: {
                    due: "Being sealed: this takes up to a minute.",
                    channelOpen: "{{channel}} is still enabled and not closed: stop it to seal the ballot box.",
                    channelNotEnabled: "{{channel}} isn't closed and isn't enabled for this Post: stop it to seal the ballot box.",
                    channelHasBallots: "{{channel}} has ballots in this ballot box and isn't closed: stop it to seal the ballot box.",
                    datafixVotes_one: "{{count}} vote is in progress in Datafix: the ballot box is sealed once it is resolved.",
                    datafixVotes_other: "{{count}} votes are in progress in Datafix: the ballot box is sealed once they are resolved.",
                    sequencer_one: "{{count}} ballot isn't on the bulletin board yet: the ballot box is sealed once the sequencer has added it.",
                    sequencer_other: "{{count}} ballots aren't on the bulletin board yet: the ballot box is sealed once the sequencer has added them.",
                    stale: "Last tried at {{time}}: the sealer may not be running. Check Beat and the seal worker.",
                    notTried: "Not tried yet: the sealer may not be running. Check Beat and the seal worker.",
                    errorCategory: {
                        board: "The last attempt couldn't reach the bulletin board; it is retried every minute.",
                        census: "The last attempt couldn't read the voter list; it is retried every minute.",
                        keystore: "The last attempt couldn't get the signing key; it is retried every minute.",
                        storage: "The last attempt couldn't upload the seal record to the file storage; it is retried every minute.",
                        settings: "The last attempt couldn't read the election's settings; it is retried every minute.",
                        other: "The last attempt failed; it is retried every minute. The service log has the details.",
                        ballots: "The last attempt found a ballot that can't be read yet or is still in progress; it is retried every minute.",
                        database: "The last attempt couldn't complete in the database; it is retried every minute.",
                    },
                },
                failure: {
                    ballotIdMismatch: "A ballot does not match its Ballot ID.",
                    missingContent: "A ballot has no content or no Ballot ID.",
                    unreadable: "A ballot can't be read.",
                    inProgress: "A ballot is still in progress.",
                    alreadyOnBoard: "A seal for this ballot box is already on the bulletin board.",
                    noBoard: "The election event has no bulletin board.",
                    unknownChannel: "A ballot has an unknown voting channel.",
                    unrecorded: "A ballot has no cast-vote record on the bulletin board.",
                },
                incident: {
                    title_one: "{{count}} ballot box could not be sealed",
                    title_other: "{{count}} ballot boxes could not be sealed",
                    body: "This is an incident: each of these ballot boxes stays locked and can't be tallied. Follow the runbook for a failed seal.",
                    line: "{{election}}, {{area}}: {{reason}}",
                },
            },
            ipAddress: {
                emptyState: "No votes yet.",
                title: "IP Addresses",
                ip: "IP",
                country: "Country",
                VoteCount: "Vote Count",
                ElectionName: "Election Name",
                VotersId: "Voters Id",
            },
        },
        electionEventScreen: {
            dataUnavailable: "Data is unavailable for this election event.",
            noAccessibleTabs: "You don't have access to any available tabs for this election event.",
            common: {
                subtitle: "Election event configuration.",
                showMore: "Show More",
                showLess: "Show Less",
                adminPortal: "Admin Portal",
                allowPublishAfterLockdown: "Only allow election event publishing after lockdown",
                reset: "Reset custom filter",
            },
            edit: {
                general: "General",
                dates: "Dates",
                customUrls: "Custom URLs Prefix",
                votingPeriod: "Voting Period",
                language: "Language",
                allowed: "Voting Channels Allowed",
                materials: "Support Materials",
                ballotReceipts: "Ballot Receipts",
                ballotDesign: "Ballot Design",
                templates: "Templates",
                reorder: "Reorder elections",
                advancedConfigurations: "Advanced Configurations",
                importCandidates: "Import Candidates",
                custom_filters: "Custom filters",
                voter_authentication: "Voter Authentication",
                realm_attributes: "Keycloak realm attributes",
                realm_attributes_load_error: "Error loading Keycloak realm attributes",
                realm_attributes_update_error: "Error updating Keycloak realm attributes",
                realm_attributes_not_loaded: "Keycloak realm attributes have not loaded, changes were not saved",
                password_policy: "Password Policy",
                password_policy_load_error: "Error loading Keycloak password policy",
                password_policy_update_error: "Error updating Keycloak password policy",
                password_policy_not_loaded: "Keycloak password policy has not loaded, changes were not saved",
            },
            customUrls: {
                login: "Login",
                enrollment: "Enrollment",
            },
            localization: {
                emptyHeader: "No languages were set for the event",
                selectLanguage: "Select Language",
                notify: {
                    success: "Localization updated Successfully",
                    error: "Localization update failed",
                    duplicateKey: "An override with this key and portal scope already exists.",
                    invalidDateTimeFormat: "Invalid date/time format. Use tokens yyyy, MM, dd, HH, mm, ss (e.g. dd/MM/yyyy HH:mm).",
                    invalidTimeZoneText: "This text must keep {{placeholders}}.",
                },
                common: {
                    title: "Localization",
                    subTitle: "Localization configuration",
                },
                labels: {
                    key: "Key",
                    scope: "Portal scope",
                    value: "Value",
                },
                scopes: {
                    legacy: "Legacy ({{portal}})",
                    global: "Global",
                    votingPortal: "Voting portal",
                    ballotVerifier: "Ballot verifier",
                    resultsPortal: "Results portal",
                    adminPortal: "Admin portal",
                    templates: "Reports and messages",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Minimum length",
                    maximumLength: "Maximum length",
                    includeUppercase: "Include uppercase letters",
                    includeLowercase: "Include lowercase letters",
                    includeDigits: "Include digits",
                    includeSpecialCharacters: "Include special characters",
                    help: {
                        minimumLength: "The minimum number of characters required for the password.",
                        maximumLength: "The maximum number of characters allowed for the password.",
                        includeUppercase: "Require at least one uppercase character in the password.",
                        includeLowercase: "Require at least one lowercase character in the password.",
                        includeDigits: "Require at least one digit in the password.",
                        includeSpecialCharacters: "Require at least one special character in the password string.",
                    },
                    notConfigured: "No password policy is configured. Saving will apply the defaults below.",
                    errors: {
                        lengthRange: "Password lengths must be whole numbers between 1 and 256.",
                        minimumExceedsMaximum: "Minimum length cannot exceed maximum length.",
                        characterClassRequired: "Select at least one character class for the password.",
                    },
                },
                name: "Name",
                alias: "Alias",
                description: "Description",
                startDateTime: "Start Date and Time",
                endDateTime: "End Date and Time",
                language: "Language",
                votingChannels: "Voting Channels",
                materialActivated: "Support Materials Activated",
                supportMaterialsPolicy: {
                    label: "Support Materials Policy",
                    helperText: "Mandatory for Voting requires voters to open each Support Material and acknowledge that they have read them before they can vote.",
                    options: {
                        off: "Off",
                        optional: "Optional",
                        mandatory_for_voting: "Mandatory for Voting",
                    },
                },
                materialTitle: "Title",
                materialSubTitle: "Subtitle",
                logoUrl: "Logo URL",
                userVerification: "You can introduce a custom template that will be used to manually verify the voters",
                redirectFinishUrl: "Redirect Finish URL",
                kioskRedirectFinishUrl: "Kiosk Redirect Finish URL",
                css: "Custom CSS",
                skipElectionList: "Skip Election List Screen",
                showUserProfile: "Show User Profile",
                ballotReceipts: {
                    checksPeriod: {
                        policyLabel: "Period for checking cast ballots",
                        helper: "How long voters can look up their cast ballot and print its receipt in the Voting Portal.",
                        options: {
                            "unlimited": "No limit",
                            "until-date": "Until a date",
                        },
                    },
                    checksAvailableUntil: "Checks available until ({{timezone}})",
                    checksAvailableUntilRequired: "Enter the date and time until which ballots can be checked.",
                },
                voterAccessibilitySettingsPolicy: {
                    policyLabel: "Voter accessibility settings",
                    options: {
                        disabled: "Hide the accessibility settings",
                        enabled: "Offer text size, contrast, spacing and motion settings",
                    },
                },
                audioInstructionsPolicy: {
                    policyLabel: "Audio instructions",
                    options: {
                        "disabled": "No audio instructions",
                        "recorded": "Uploaded recordings only",
                        "recorded-or-synthesized": "Uploaded recordings, or the browser's voice where there is none",
                    },
                },
                showCastVoteLogs: {
                    policyLabel: "Show Cast Vote Logs Tab",
                    options: {
                        "show-logs-tab": "Show Cast Vote Logs Tab",
                        "hide-logs-tab": "Hide Cast Vote Logs Tab",
                    },
                },
                lockdownState: {
                    since: "Locked down since {{date}}.",
                    scheduledEnd: "End of lockdown scheduled for {{date}}.",
                    endScheduled: "An end of lockdown is scheduled.",
                    noScheduledEnd: "No end of lockdown is scheduled.",
                    banner: "This election event is in lockdown.",
                    policyLabel: "Lockdown Status",
                    helperText: "Schedule a start or end of the lockdown period to change this state.",
                    options: {
                        "locked-down": "Locked Down",
                        "not-locked-down": "Not Locked Down",
                    },
                },
                ballotBoxSealPolicy: {
                    policyLabel: "Ballot Box Seal Policy",
                    helperText: "When voting closes, the ballot box of each area is sealed: a signed hash of its ballots goes to the bulletin board, no ballot can be added, changed or deleted, and voting cannot start again.",
                    locked: "It cannot be changed after voting has opened.",
                    options: {
                        "seal-at-close": "Seal at close",
                        "do-not-seal": "Do not seal",
                    },
                    checking: "Checking whether voting has opened…",
                    lockedUnknown: "Locked: the elections could not be read, so whether voting has opened is unknown.",
                    lockedOpened: "Locked: voting has opened in {{names}}.",
                    lockedEvent: "Locked: voting has opened in this election event.",
                    refused: "The Ballot Box Seal Policy can't be changed after voting has opened.",
                    settingLocked: "With Seal at close, the seal relies on this setting.",
                    settingRefused: "This setting can't be changed after voting has opened: with Seal at close, the seal relies on it.",
                    boardRefused: "The election event's bulletin board can't change after voting has opened: with Seal at close, the seals are posted to it.",
                },
                ballotBoxSealRecordPolicy: {
                    policyLabel: "Ballot Box Seal Record",
                    options: {
                        restricted: "Restricted",
                        public: "Public",
                    },
                    help: {
                        restricted: "Only administrators can download it; share it with observers.",
                        public: "Anyone with the event's ids can download it, without signing in; it shows how each ballot counted.",
                    },
                },
                decodedBallots: {
                    policyLabel: "Include decoded ballots to results database",
                    options: {
                        "included": "Include",
                        "not-included": "Don't include",
                    },
                },
                fileIntegrityPolicy: {
                    policyLabel: "Voter file integrity",
                    helperText: "Require the independently certified SHA-256 before importing voters.",
                    options: {
                        OPTIONAL: "Optional SHA-256",
                        REQUIRED_SHA256: "Required SHA-256",
                    },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Single Contest",
                        "multiple-contests": "Multiple Contests",
                    },
                    policyLabel: "Contest encryption policy",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Voting Portal date & time format",
                    helperText: 'Applies event-wide. To override per language, add the key "votingPortalDateTimeFormat" in the Localization tab using tokens yyyy, MM, dd, HH, mm, ss (e.g. dd/MM/yyyy HH:mm). See the docs for details.',
                    options: {
                        "legacy-gb-24h": "Legacy GB 24h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO Local (yyyy-MM-dd HH:mm)",
                        "us-12h": "US 12h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (medium date, short time)",
                        "date-only": "Date Only (no time)",
                        "custom": "Custom format",
                    },
                    customFormat: {
                        label: "Custom date & time format",
                        helperText: "Use tokens yyyy, MM, dd, HH, mm, ss (e.g. dd/MM/yyyy HH:mm). Any other characters are shown literally.",
                        invalid: "Invalid format. Use at least one of the tokens yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "No Countdown",
                    COUNTDOWN: "Countdown",
                    COUNTDOWN_WITH_ALERT: "Countdown with alert",
                    sectionTitle: "Voting Portal",
                    policyLabel: "Voting Portal Countdown policy",
                    coundownSecondsLabel: "time in seconds before expiration to show countdown",
                    alertSecondsLabel: "time in seconds before expiration to show Logout alert",
                },
                voterSigningPolicy: {
                    "policyLabel": "Voter Signing Policy",
                    "no-signature": "No signature",
                    "with-signature": "With signature",
                },
                receiptsPolicy: {
                    "policyLabel": "Receipts signed by the ballot box",
                    "disabled": "Disabled",
                    "signed-by-ballot-box": "Signed by the ballot box",
                    "helperText": "When on, the ballot box stores and signs each ballot at review, and the voter sees a Ballot ID only once the ballot has been received. Voters sign their ballots. Publish the ballots again after changing it.",
                    "lockedHelperText": "This cannot be changed once voting has started.",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Voter Digital Certificate Policy",
                    enabled: "Enabled",
                    disabled: "Disabled",
                },
                enrollment: {
                    policyLabel: "Enrollment",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Keys/Tally Ceremonies Policy",
                    options: {
                        "automated-ceremonies": "Allow Automatic Ceremonies",
                        "manual-ceremonies": "Manual Ceremonies",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Automatic Recount After Import Approval",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Weighted Voting Policy",
                    options: {
                        "areas-weighted-voting": "Weighted Voting for Areas",
                        "disabled-weighted-voting": "Disabled Weighted Voting",
                        "voters-weighted-voting": "Weighted Voting for Voters",
                    },
                    noDelegated: "Weighted Voting for Voters cannot be combined with Delegated Voting",
                    noDecodedBallots: "Weighted Voting for Voters cannot be combined with including decoded ballots in the results",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Delegated Voting Policy",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                batchAnonymityPolicy: {
                    policyLabel: "Batch Anonymity Policy",
                    helperText: "Refuse stops the tally when an area's ballot batch has fewer than five voters, or differs from the batch another tally already posted for the same area and contest.",
                    options: {
                        warn: "Warn",
                        refuse: "Refuse",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Language Detection Policy",
                    options: {
                        "browser-detect": "Browser Detect",
                        "force-default": "Force Default",
                    },
                },
            },
            error: {
                endDate: "End date must be after start date",
                startDate: "Start date must be in the future",
                noResult: "No Election Event yet",
                endDateInvalid: "End date must be in the future",
            },
            voters: {
                title: "Voters",
            },
            createElectionEventSuccess: "Election Event created",
            createElectionEventError: "Error creating election event",
            ivr: {
                tabs: {
                    config: "Configuration",
                    blacklist: "Blocklist",
                    prompts: "Prompts",
                    emulator: "Emulator",
                },
                common: {
                    saveSuccess: "Saved successfully",
                    saveError: "Failed to save",
                    deleteSuccess: "Deleted successfully",
                    deleteError: "Failed to delete",
                },
                config: {
                    configuredPhone: "Configured phone number",
                    infoMsg: "Configure the IVR flow and its properties below. For more details, please contact Sequent.",
                },
                prompts: {
                    emptyMsg: "No prompts created yet",
                    infoMsg: "Configure the prompts used by the IVR. Announcement prompts are required, and system prompts can be overridden for desired languages. SSML is supported, including for mixing languages.",
                    editorTitle: "Prompt",
                    editorSubtitle: "Prompt configuration",
                },
                blacklist: {
                    columns: {
                        phone: "Phone number",
                        reason: "Reason",
                        createdAt: "Created at",
                        createdBy: "Created by",
                        createdBefore: "Created before",
                        createdAfter: "Created after",
                    },
                    emptyMsg: "There are no entries in the blocklist",
                    infoMsg: "Configure the blocklist for the IVR. Calls from these numbers will be disconnected automatically by the system.",
                    noFilterMatch: "No entries match the given filters",
                    phoneRequired: "Phone number is required",
                },
                emulator: {
                    infoMsg: "Select an area and desired elections to experience the IVR session.",
                    apiStatus: {
                        unavailable: "The emulator system is not available in your environment",
                        loading: "Loading the emulator system",
                        error: "Error loading the emulator system",
                    },
                    hints: {
                        title: "Hints",
                        publishRequired: "Any changes made to elections, contests or candidates must be published first to be available. Only the latest published ballot styles for the matching area will be used in the emulator.",
                        eventChangesImmediate: "Changes made to the election event, such as IVR configuration or prompt overrides, are available immediately upon emulator session restart.",
                        credentials: 'The valid voter id and pin are "123" and "123".',
                    },
                    sendDtmf: "Send DTMF input",
                    keypadInput: "Keypad input",
                    sendTimeout: "Send timeout",
                    disconnected: "Disconnected",
                    startSession: "Start new session",
                    endSession: "End the session",
                    noStylesFound: "No published ballot styles found matching your selections",
                    inputPlaceholder: "Press {{keys}} (timeout={{timeout}}s)",
                    inputPlaceholderOr: "or",
                    inputPlaceholderAnyKeys: "Enter up to {{maxDigits}} digits (any digits, timeout={{timeout}}s)",
                    blacklistCaller: "Blocklist the caller",
                    elections: "Elections",
                    area: "Area",
                },
            },
            stats: {
                elegibleVoters: "Eligible Voters",
                voters: "Actual Voters",
                elections: "Elections",
                contests: "Contests",
                areas: "Areas",
                sentEmails: "Emails sent",
                sentSMS: "SMS sent",
                calendar: {
                    title: "Calendar",
                    scheduled: "Scheduled",
                },
            },
            keys: {
                createNew: "Create Key Ceremony",
                emptyHeader: "No Key Ceremony yet.",
                statusLabel: "Status",
                waitingKeys: "Waiting for Keys Generation..",
                started: "Started at",
                actions: {
                    participate: "Participate in Keys Ceremony",
                    view: "View Keys Ceremony",
                },
                breadCrumbs: {
                    configure: "Configure",
                    ceremony: "Ceremony",
                    created: "Finished",
                    start: "Start",
                    status: "Status",
                    download: "Download",
                    check: "Check",
                    success: "Finished",
                },
                notify: {
                    participateNow: "You have been invited to participate in a Key Ceremony. Please <1>click on the ceremony's Key Action</1> to participate.",
                },
            },
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Monitoring",
                data: "Data",
                ivr: "IVR",
                localization: "Localization",
                voters: "Voters",
                areas: "Areas",
                keys: "Keys",
                tally: "Tally",
                tallySheetImports: "Tally sheet imports",
                publish: "Publish",
                logs: "Logs",
                tasks: "Tasks",
                events: "Scheduled Events",
                notifications: "Notifications",
                reports: "Reports",
                approvals: "Approvals",
                cas: "Certificates",
            },
            tally: {
                emptyHeader: "No Tally yet.",
                title: "Election Event Tally",
                elections: "Elections",
                electionNumber: "Number Elections",
                trustees: "Trustees",
                permissionLabels: "Permission Labels",
                status: "Status",
                tallyType: {
                    label: "Tally Type",
                    ELECTORAL_RESULTS: "Electoral Results",
                    INITIALIZATION_REPORT: "Initialization Results",
                },
                create: {
                    title: "Create Tally",
                    subtitle: "Create a new Tally for this Election Event",
                    createTallyButton: "Start Tally Ceremony",
                    createInitializationReportButton: "Generate Initialization Report",
                    error: {
                        create: "Error creating Tally",
                    },
                    success: "Tally created",
                },
                logs: {
                    noLogs: "No logs available",
                },
                notify: {
                    noKeysTally: "The Tally Ceremony cannot start until the Key Ceremony has been successfully completed.",
                    noPublication: "The Tally Ceremony cannot start until you create one publication in the Publish tab.",
                    participateNow: "You have been invited to participate in a Tally ceremony. Please <1>click on the ceremony's Key Action</1> to participate.",
                    startDisabled: "You cannot continue the ceremony because no elections are selected or the elections are not published.",
                    ceremonyDisabled: "You cannot continue the ceremony because the tally session is not connected or the start of the ceremony is not allowed.",
                },
            },
            importAreas: {
                title: "Import Areas",
                subtitle: "Import areas data",
                areaParagraph: "Import areas using a spreadsheet file in Comma Separated Values (CSV) format.",
                importSuccess: "Areas Imported Successfully",
                importError: "Error importing Areas",
                upsert: "Upsert Areas",
            },
            import: {
                eetitle: "Import Election Event",
                eesubtitle: "Import election event data",
                title: "Import Voters",
                subtitle: "Import voters data",
                voters: "Voters",
                votersParagraph: "Import voters using a spreadsheet file in Comma Separated Values (CSV) format. Download an example import CSV file here.",
                electionEventParagraph: "Import Election Events using a JSON file.",
                elections: "Elections",
                areas: "Areas",
                sha: "Integrity Check (SHA-256)",
                cancel: "Cancel",
                import: "Import",
                fileUploadSuccess: "File uploaded to server - but not imported yet",
                fileUploadError: "Error uploading file",
                importVotersSuccess: "Voters Import Scheduled Successfully",
                importVotersError: "Error importing Voters",
                importElectionEventSuccess: "Election event imported Successfully",
                importElectionEventError: "Error importing election event",
                shaRequiredHelp: "Enter the independently certified 64-character hexadecimal SHA-256. Import cannot proceed without it.",
                shaDialog: {
                    ok: "Yes, Import without Integrity Check",
                    cancel: "Go Back",
                    title: "Import Without Integrity Check?",
                    description: "You didn't enter the Integrity Check (SHA-256) field. Please confirm  that you are importing the correct file and you want to import it.",
                },
                passwordDialog: {
                    title: "Decryption Password",
                    description: "Enter the password to decrypt the file",
                    label: "Password",
                    copyPassword: "Copy Password",
                    ok: "Ok",
                },
            },
            export: {
                title: "Export Election Event",
                subtitle: "Export can be a long operation. Are you sure you want to export records?",
                encryptWithPassword: "Encrypt with Password",
                passwordForcedNote: "The archive will be password protected anyway: reports, applications and bulletin-board data are always encrypted. Tick the box to also include decrypted secret voter fields.",
                integrationSecrets: "Integration secrets (service credentials)",
                integrationSecretsNote: "The archive will contain the Scanovate liveness secret in clear text once decrypted. Keep the archive and its password secret, and import it only where that Liveness Plus service is meant to be used.",
                includeVoters: "Include Voters",
                activityLogs: "Activity Logs",
                bulletinBoard: "Bulletin Board",
                publications: "Publications",
                s3Files: "S3 Files",
                scheduledEvents: "Scheduled Events",
                exportSuccess: "Election Event exported successfully",
                exportError: "Error exporting Election Event",
                passwordTitle: "Password",
                passwordDescription: "Password to decrypt the file:",
                copiedSuccess: "Password copied to clipboard",
                copiedError: "Error copying password",
                reports: "Reports",
                applications: "Applications",
                tally: "Tally",
                certificates: "Certificates",
            },
            taskNotification: "{{action}} has started. You can see its status at Tasks Execution table.",
        },
        electionScreen: {
            common: {
                title: "Election",
                subtitle: "Election configuration.",
                fileLoaded: "File loaded",
                noPermission: "You don't have permission to access this election.",
            },
            edit: {
                general: "General",
                dates: "Dates",
                votingPeriod: "Voting Period",
                language: "Language",
                allowed: "Voting Channels Allowed",
                default: "Default",
                defaultLang: "Default language",
                receipts: "Receipts",
                image: "Image",
                advanced: "Advanced Configuration",
                numAllowedVotes: "Number of allowed votes",
                reorder: "Reorder contests",
                castVoteConfirm: "Cast Vote Confirmation Modal",
                gracePeriodPolicy: "Grace Period",
                allowTallyPolicy: "Allow Tally",
                permissionLabel: "Permission Label",
                custom_filters: "Custom filters",
            },
            field: {
                name: "Name",
                language: "Language",
                votingChannels: "Voting Channels",
                startDateTime: "Start Date and Time",
                endDateTime: "End Date and Time",
                startDateTimeWithTimezone: "Start Date and Time ({{timezone}})",
                endDateTimeWithTimezone: "End Date and Time ({{timezone}})",
                scheduledOpening: "Scheduled Opening",
                scheduledClosing: "Scheduled Closing",
                alias: "Alias",
                description: "Description",
                securityConfirmationHtml: "Security Confirmation Html",
                ivrPrompt: "IVR prompt",
                externalId: "External ID",
            },
            securityConfirmationPolicy: {
                label: "Security Confirmation Checkbox Policy",
                none: "None",
                mandatory: "Mandatory",
            },
            error: {
                fileError: "Error uploading file",
                fileLoaded: "File loaded",
                endDate: "End date must be after start date",
                startDate: "Start date must be in the future",
                endDateInvalid: "End date must be in the future",
            },
            createElectionEventSuccess: "Election Event created",
            createElectionEventError: "Error creating election event",
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Monitoring",
                data: "Data",
                voters: "Voters",
                publish: "Publish",
                logs: "Logs",
                approvals: "Approvals",
                tallySheets: "Tally Sheets",
            },
            gracePeriodPolicy: {
                "label": "Grace Period Policy",
                "no-grace-period": "No grace period",
                "grace-period-without-alert": "Grace period without alert",
                "gracePeriodSecs": "Grace period in seconds",
            },
            allowTallyPolicy: {
                "allowed": "Allowed",
                "disallowed": "Disallowed",
                "requires-voting-period-end": "Requires Voting Period End",
            },
            initializeReportPolicy: {
                "label": "Initialize Report Policy",
                "not-required": "Not Required",
                "required": "Required",
            },
            castVoteGoldLevelPolicy: {
                label: "Gold level Authentication Policy",
                options: {
                    "gold-level": "Gold level Authentication",
                    "no-gold-level": "No Gold level Authentication",
                },
            },
            slates: {
                title: "Slates",
                configuration: "Slate configuration (JSON)",
                helper: "Named slates and the candidates each one runs in each contest. Leave empty for an election without slates.",
                loading: "The election's contests and candidates are still loading. Try again in a moment.",
                mobileCandidateLists: {
                    label: "Mobile candidate lists",
                    helper: "How each slate's candidate list starts on phones. Voters can always open or close it.",
                    options: {
                        collapsed: "Collapsed",
                        expanded: "Expanded",
                    },
                },
            },
            startScreenTitlePolicy: {
                label: "Start Screen Title Policy",
                options: {
                    "election": "Election title",
                    "election-event": "Election event title",
                },
            },
            consolidatedReportPolicy: {
                label: "Consolidated Report Policy",
                options: {
                    "generate": "Generate",
                    "do-not-generate": "Do Not Generate",
                },
            },
            declineToVotePolicy: {
                label: "Decline to Vote Policy",
                options: {
                    enabled: "Enabled",
                    disabled: "Disabled",
                },
            },
            blankBallotsPolicy: {
                label: "Blank Ballots Policy",
                options: {
                    enabled: "Enabled",
                    disabled: "Disabled",
                },
            },
            votingScreenBackPolicy: {
                label: "Voting Screen Back Button Policy",
                options: {
                    "election-selection-screen": "Go to the election selection screen",
                    "start-screen": "Go to the election start screen",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Tenants",
            },
            new: {
                subtitle: "Create new tenant",
            },
            createSuccess: "Tenant created",
            createError: "Error creating tenant",
        },
        usersAndRolesScreen: {
            noPermissions: "You don't have permission to access users or roles.",
            common: {
                title: "Users and Roles",
                subtitle: "General configuration",
                mobileNumber: "Mobile",
            },
            editPassword: {
                label: "Change password",
                temporatyLabel: "Temporary",
                temporatyInfo: "If enabled, the user must change the password on next login",
                passwordPolicyViolation: "The password does not meet the Password Policy for this election event. Review the policy under Election Event Data and enter a compliant password.",
                passwordPolicyRules: {
                    minimumLength: "The password minimum length is {{count}}.",
                    maximumLength: "The password maximum length is {{count}}.",
                    uppercase: "Required uppercase characters: {{count}}.",
                    lowercase: "Required lowercase characters: {{count}}.",
                    digits: "Required digits: {{count}}.",
                    specialCharacters: "Required special characters: {{count}}.",
                },
            },
            users: {
                title: "Users",
                subtitle: "View and edit user data",
                review: {
                    title: "Review changes",
                    subtitle: "Confirm these updates before submitting.",
                    confirm: "Confirm changes",
                    noChanges: "No changes to review",
                    field: "Field",
                    currentValue: "Current value",
                    newValue: "New value",
                },
                edit: {
                    title: "User Data",
                    subtitle: "View and edit user",
                },
                create: {
                    title: "User",
                    subtitle: "Create user",
                },
                fields: {
                    "has_voted": "Voted",
                    "support_materials_viewed": "Support Materials Viewed",
                    "vote-weight": "Vote Weight",
                    "voted-channel": "Voted Channel",
                    "disable-comment": "Disable Comment",
                    "username": "Username",
                    "first_name": "First Name",
                    "last_name": "Last Name",
                    "email": "Email",
                    "enabled": "Enabled",
                    "emailVerified": "Email Verified",
                    "groups": "Groups",
                    "attributes": "Attributes",
                    "area": "Area",
                    "password": "Password",
                    "repeatPassword": "Repeat Password",
                    "savePassword": "Save Password",
                    "passwordMismatch": "Passwords must match",
                    "passwordLengthValidate": "Password must be at least 8 characters long",
                    "passwordUppercaseValidate": "Password must contain at least one uppercase letter",
                    "passwordLowercaseValidate": "Password must contain at least one lowercase letter",
                    "passwordDigitValidate": "Password must contain at least one digit",
                    "passwordSpecialCharValidate": "Password must contain at least one special character",
                    "trustee": "Act as Trustee",
                    "permissionLabel": "Permission Label",
                    "authorized-election-ids": "Elections",
                },
                delete: {
                    body: "Are you sure you want to delete this user?",
                    bulkBody: "Are you sure you want to delete the selected users?",
                    bulkBodySelected: "Delete the {{count}} selected users? This cannot be undone.",
                    bulkBodyChoose: "{{count}} users are selected. You can instead delete every user matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Error exporting users",
                    deleteError: "Error deleting user",
                    deleteSuccess: "User deleted",
                    multipleDeleteSuccess: "Users deleted",
                },
            },
            voters: {
                title: "Voters",
                subtitle: "View and edit voter data",
                secretAttribute: {
                    storedPlaceholder: "Stored encrypted value",
                    reveal: "Reveal",
                    hide: "Hide",
                    revealError: "The encrypted voter field could not be revealed",
                    includeInExport: "Include decrypted secret voter fields",
                    exportWarning: "Sensitive export: the downloaded CSV will contain these fields in plaintext.",
                    clear: "Clear",
                    add: "Add value",
                    remove: "Remove value",
                },
                review: {
                    title: "Review changes",
                    subtitle: "Confirm these updates before submitting.",
                    confirm: "Confirm changes",
                    noChanges: "No changes to review",
                    field: "Field",
                    currentValue: "Current value",
                    newValue: "New value",
                },
                logs: {
                    label: "User's Logs",
                },
                create: {
                    title: "Voter",
                    subtitle: "Create Voter",
                },
                manualVerification: {
                    label: "Manually Verify",
                    verify: "Manually Verify this voter",
                    body: "Manually Verify this voter. You will obtain a PDF with a QR Code link that allows the voter to login skipping online KYC.",
                    noEmailOrPhone: "This voter can not be manually verified because they do not have an email address or phone number attributed to them.",
                },
                voterInformationLetter: {
                    label: "Voter Information Letter",
                    generate: "Generate",
                    confirmation: "Generate a Voter Information Letter for this voter? A new password will be assigned and included in an encrypted PDF.",
                    generationStarted: "Voter Information Letter generation started",
                    generationError: "The Voter Information Letter could not be generated",
                    policyNotConfigured: "Password Policy is not configured. Set it under Election Event Data before generating a letter.",
                    policyMinimumLengthMissing: "Password Policy must include a minimum length before generating a letter.",
                    policyCharacterClassMissing: "Password Policy must include at least one character class before generating a letter.",
                },
                emptyHeader: "No voters yet.",
                askCreate: "Do you want to create one?",
                errors: {
                    editError: "Error editing voter",
                    editErrorReason: "Error editing voter: {{reason}}",
                    editSuccess: "Voter edited",
                    createError: "Error creating voter",
                    createErrorReason: "Error creating voter: {{reason}}",
                    createSuccess: "Voter created",
                    attribute: {
                        invalidNamed: '"{{field}}" was refused: {{constraint}}',
                        fieldsToCorrect: "Some fields need correcting before saving",
                        hintBetween: "Between {{min}} and {{max}} characters",
                        hintMin: "At least {{min}} characters",
                        hintMax: "At most {{max}} characters",
                        andMore: "and {{count}} more",
                        invalidLength: '"{{field}}" must be between {{min}} and {{max}} characters',
                        tooShort: '"{{field}}" must be at least {{min}} characters',
                        tooLong: '"{{field}}" must be at most {{max}} characters',
                        required: '"{{field}}" is required',
                        invalidEmail: '"{{field}}" must be a valid email address',
                        invalidFormat: '"{{field}}" does not have the expected format',
                        invalid: '"{{field}}" has an invalid value',
                    },
                    createPasswordError: "Voter created, but their password could not be set",
                    createPasswordErrorReason: "Voter created, but their password could not be set: {{reason}}",
                },
                delete: {
                    body: "Are you sure you want to delete this voter?",
                    bulkBody: "Are you sure you want to delete the selected voters?",
                    bulkBodySelected: "Delete the {{count}} selected voters? This cannot be undone.",
                    bulkBodyChoose: "{{count}} voters are selected. You can instead delete every voter matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Error exporting voters",
                    deleteError: "Error deleting voter",
                    deleteSuccess: "Voter deleted",
                    multipleDeleteSuccess: "Voters deleted",
                    manualVerificationError: "Error manually verifying the voter",
                    manualVerificationSuccess: "Sucessfully verified manually the voter, downloading PDF..",
                },
            },
            roles: {
                title: "Roles",
                edit: {
                    title: "Role Data",
                    subtitle: "View and edit role",
                },
                create: {
                    title: "Role",
                    subtitle: "Create role",
                },
                errors: {
                    createError: "Error creating role",
                    createSuccess: "Role created",
                },
                fields: {
                    name: "Name",
                },
                delete: {
                    body: "Are you sure you want to delete this role?",
                },
                notifications: {
                    deleteError: "Error deleting role",
                    deleteSuccess: "Role deleted",
                    permissionEditError: "Error editing permission",
                    permissionEditSuccess: "Permission edited",
                },
            },
            permissions: {
                "admin-user": "Admin User",
                "admin-dashboard-view": "Admin Dashboard View",
                "monitoring-view": "View Monitoring Dashboards",
                "monitoring-configure": "Configure Monitoring Dashboards",
                "election-event-signatures-tab": "Election Event Signatures Tab",
                "signing-rules-read": "Signatures: read protected actions",
                "signing-rules-write": "Signatures: edit protected actions",
                "signing-certificates-read": "Signatures: read certificates",
                "signing-issuers-write": "Signatures: import and remove trusted issuers",
                "signing-checks-write": "Signatures: edit certificate checks",
                "signing-certificates-register": "Signatures: register certificates",
                "signing-certificates-revoke": "Signatures: revoke certificates",
                "signing-requests-read": "Signatures: read requests",
                "signing-requests-cancel": "Signatures: cancel requests",
                "signing-requests-export": "Signatures: export requests",
                "sign-initialize-voting": "Sign: initialize voting",
                "sign-open-voting": "Sign: open voting",
                "sign-close-voting": "Sign: close voting",
                "sign-generate-election-returns": "Sign: generate election returns",
                "sign-generate-reports": "Sign: generate other election reports",
                "sign-transmit-results": "Sign: transmit results",
                "sign-approve-voter": "Sign: approve a voter manually",
                "sign-approve-configuration": "Sign: approve a configuration version",
                "sign-key-ceremony": "Sign: confirm custody",
                "sign-tally-key": "Sign: authorize tally custody",
                "application-export": "Application Export",
                "application-import": "Application Import",
                "tenant-create": "Create Tenant",
                "tenant-read": "Read Tenant",
                "tenant-write": "Edit Tenant",
                "tenant-delete": "Delete Tenant",
                "election-event-create": "Create Election Event",
                "election-event-read": "Read Election Event",
                "election-event-write": "Edit Election Event",
                "keycloak-realm-attributes-read": "Read Keycloak realm attributes",
                "keycloak-realm-attributes-write": "Edit Keycloak realm attributes",
                "election-event-delete": "Delete Election Event",
                "voter-create": "Create Voter",
                "voter-read": "Read Voter",
                "voter-write": "Edit Voter",
                "voter-secret-attribute-read": "Reveal Secret Voter Fields",
                "voter-secret-attribute-write": "Edit Secret Voter Fields",
                "integration-secret-read": "Export Integration Secrets",
                "user-create": "Create User",
                "user-read": "Read User",
                "user-write": "Edit User",
                "user-permission-create": "Create User Permission",
                "user-permission-read": "Read User Permission",
                "user-permission-write": "Edit User Permission",
                "role-create": "Create Role",
                "role-read": "Read Role",
                "role-write": "Edit Role",
                "role-assign": "Assign Role",
                "communication-template-create": "Create Communication Template",
                "communication-template-read": "Read Communication Template",
                "communication-template-write": "Edit Communication Template",
                "notification-read": "Read Notification",
                "notification-write": "Edit Notification",
                "notification-send": "Send Notification",
                "area-read": "Read Area",
                "area-write": "Edit Area",
                "election-state-write": "Edit Election State",
                "election-type-create": "Create Election Type",
                "election-type-read": "Read Election Type",
                "election-type-write": "Edit Election Type",
                "voting-channel-read": "Read Voting Channel",
                "voting-channel-write": "Edit Voting Channel",
                "trustee-create": "Create Trustee",
                "trustee-read": "Read Trustee",
                "trustee-write": "Edit Trustee",
                "tally-read": "Read Tally",
                "tally-start": "Start Tally",
                "tally-write": "Edit Tally",
                "tally-results-read": "Read Tally Results",
                "publish-read": "Read Publish",
                "publish-write": "Edit Publish",
                "publish-results-read": "Read Results Publication",
                "publish-results-write": "Edit Results Publication",
                "logs-read": "Read Logs",
                "electoral-log-audit": "Audit Electoral Log",
                "electoral-log-console-read": "Browse Electoral Log",
                "electoral-log-console-query": "Query Electoral Log",
                "electoral-log-personal-data-read": "Read Electoral Log Personal Data",
                "task-queues-read": "Read Task Queues",
                "task-queues-write": "Manage Task Queues",
                "task-queues-query": "Query Task Queues",
                "tasks-read": "Read Tasks Execution",
                "keys-read": "Read Keys",
                "document-upload": "Upload Documents",
                "document-download": "Download Documents",
                "document-password-read": "Read Document Passwords",
                "tally-sheet-create": "Create Tally Sheet",
                "tally-sheet-import-create": "Create Tally Sheet Import",
                "tally-sheet-import-review": "Review Tally Sheet Import",
                "tally-sheet-import-view": "View Tally Sheet Import",
                "tally-recount-execute": "Execute Tally Recount",
                "trustee-ceremony": "Trustee Ceremony",
                "tally-sheet-review": "Review Tally Sheet",
                "tally-sheet-view": "View Tally Sheet",
                "admin-ceremony": "Admin Ceremony",
                "tally-sheet-delete": "Delete Tally Sheet",
                "document-read": "Read Documents",
                "document-write": "Edit Documents",
                "support-material-read": "Read Support Materials",
                "support-material-write": "Edit Support Materials",
                "miru-create": "Miru Create",
                "miru-download": "Miru Download",
                "miru-send": "Miru Send",
                "miru-sign": "Miru Sign",
                "contest-write": "Edit Contest",
                "contest-read": "Read Contest",
                "candidate-write": "Edit Candidate",
                "candidate-read": "Read Candidate",
                "permission-label-write": "Edit Permission Label",
                "scheduled-event-write": "Edit Scheduled Events",
                "contest-create": "Create Contest",
                "contest-delete": "Delete Contest",
                "candidate-create": "Create Candidate",
                "candidate-delete": "Delete Candidate",
                "election-create": "Create Election",
                "election-read": "Read Election",
                "election-write": "Edit Election",
                "election-delete": "Delete Election",
                "election-event-archive": "Archive Election Event",
                "election-data-tab": "View Election Data",
                "election-event-areas-tab": "View Election Event Areas",
                "election-event-data-tab": "View Election Event Data",
                "election-event-keys-tab": "View Election Event Keys",
                "election-event-logs-tab": "View Election Event Logs",
                "election-event-publish-tab": "View Election Event Publish",
                "election-event-reports-tab": "View Election Event Reports",
                "election-event-scheduled-tab": "View Election Event Scheduled",
                "election-event-tally-tab": "View Election Event Tally",
                "election-event-tasks-tab": "View Election Event Tasks",
                "election-event-voters-tab": "View Election Event Voters",
                "election-publish-tab": "View Election Publish",
                "election-voters-tab": "View Election Voters",
                "report-write": "Edit Reports",
                "report-read": "Read Reports",
                "users-menu": "View users and roles",
                "settings-menu": "View settings",
                "templates-menu": "View templates",
                "settings-election-types-tab": "View election types settings",
                "settings-voting-channels-tab": "View voting channels settings",
                "settings-templates-tab": "View templates settings",
                "settings-languages-tab": "View languages settings",
                "settings-localization-tab": "View localization settings",
                "settings-look-feel-tab": "View look and feel settings",
                "settings-trustees-tab": "View truestees settings",
                "settings-countries-tab": "View countries settings",
                "voter-import": "Import Voter",
                "ee-voters-columns": "View Election Event Voters Columns",
                "voter-manually-verify": "Manually Verify Voter",
                "ee-voters-logs": "View Election Event Voters Logs",
                "voter-export": "Export Voter",
                "ee-voters-filters": "View Election Event Voters Filters",
                "voter-delete": "Delete Voter",
                "voter-change-password": "Change Voter Password",
                "voter-information-letter": "Generate Voter Information Letter",
                "election-event-localization-selector": "Election Event Localization Selector",
                "localization-create": "Create Localization",
                "localization-read": "Read Localization",
                "localization-write": "Edit Localization",
                "localization-delete": "Delete Localization",
                "area-create": "Create Area",
                "area-delete": "Delete Area",
                "area-export": "Export Area",
                "area-import": "Import Area",
                "area-upsert": "Upsert Area",
                "election-event-areas-columns": "Election Event Areas Columns",
                "election-event-areas-filters": "Election Event Areas Filters",
                "election-event-tasks-back-button": "Back to Election Event Tasks",
                "election-event-tasks-columns": "Election Event Tasks Columns",
                "election-event-tasks-filters": "Election Event Tasks Filters",
                "task-export": "Export Tasks",
                "application-read": "Read Application",
                "application-write": "Edit Application",
                "approval-matrix-write": "Edit Approval Matrix",
                "readiness-check": "Verify election readiness",
                "forensic-read": "Read isolated forensic network data",
                "voter-pseudonym-resolve": "Resolve a voter pseudonym with an audited reason",
                "logs-export": "Export Logs",
                "tenant-logs-read": "Read Tenant Logs",
                "tenant-logs-export": "Export Tenant Logs",
                "election-event-logs-columns": "Election Event Logs Columns",
                "election-events-logs-filters": "Election Event Logs Filters",
                "election-event-scheduled-event-columns": "Election Event Scheduled Event Columns",
                "scheduled-event-create": "Create Scheduled Event",
                "scheduled-event-delete": "Delete Scheduled Event",
                "election-event-reports-columns": "Election Event Reports Columns",
                "report-create": "Create Report",
                "report-delete": "Delete Report",
                "report-generate": "Generate Report",
                "report-preview": "Preview Report",
                "monitor-authenticated-voters": "Monitoring Authenticated Voters",
                "monitor-all-approve-disapprove-voters": "Read Monitoring Approve Disapprove Voters",
                "monitor-automatic-approve-disapprove-voters": "Read Monitoring Automatic Approve Disapprove Voters",
                "monitor-manually-approve-disapprove-voters": "Read Monitoring Manually Approve Disapprove Voters",
                "monitor-enrolled-overseas-voters": "Read Monitoring Enrolled Overseas Voters",
                "monitor-posts-already-closed-voting": "Read Monitoring Posts Already Closed Voting",
                "monitor-posts-already-generated-election-results": "Read Monitoring Posts Already Generated Election Results",
                "monitor-posts-already-opened-voting": "Read Monitoring Posts Already Opened Voting",
                "monitor-posts-already-started-counting-votes": "Read Monitoring Posts Already Started Counting Votes",
                "monitor-posts-initialized-the-system": "Read Monitoring Posts Initialized The System",
                "monitor-posts-started-voting": "Read Monitoring Posts Started Voting",
                "monitor-posts-transmitted-results": "Read Monitoring Posts Transmitted Results",
                "monitor-voters-voted-test-election": "Read Monitoring Voters Voted Test Election",
                "monitor-voters-who-voted": "Read Monitoring Voters Who Voted",
                "election-event-publish-preview": "Preview Election Event Publish",
                "election-event-publish-back-button": "Back to Election Event Publish",
                "election-event-publish-columns": "Election Event Publish Columns",
                "election-event-publish-filters": "Election Event Publish Filters",
                "publish-create": "Create Publish",
                "publish-regenerate": "Regenerate Publish",
                "publish-export": "Export Publish",
                "publish-start-voting": "Start Voting",
                "publish-pause-voting": "Pause Voting",
                "publish-stop-voting": "Stop Voting",
                "publish-changes": "Publish Changes",
                "election-event-publish-view": "Election Event Publish View",
                "election-event-keys-columns": "Election Event Keys Columns",
                "create-ceremony": "Create Ceremony",
                "export-ceremony": "Export Ceremony",
                "election-event-tally-columns": "Election Event Tally Columns",
                "election-event-tally-back-button": "Back to Election Event Tally",
                "transmition-ceremony": "Transmission Ceremony",
                "admin-ip-address-view": "View IP Address",
                "election-approvals-tab": "View Election Approvals",
                "election-event-approvals-tab": "View Election Event Approvals",
                "election-ip-address-view": "View Election IP Address",
                "election-dashboard-tab": "View Election Dashboard",
                "trustees-export": "Export Trustees",
                "user-import": "Import Users",
                "voter-voted-edit": "Edit voters who voted",
                "voter-email-tlf-edit": "Edit voters email/phone fields",
                "cloudflare-write": "Edit Country Blocking Rules in Cloudflare",
                "transmission-report-generate": "Generate Transmission Report",
                "google-meet-link": "Generate google meet link",
                "service-account": "Service account",
                "datafix-account": "Datafix account",
                "gold": "Gold",
                "silver": "Silver",
                "election-event-ivr-tab": "View election event IVR",
                "election-event-cas-tab": "View election event CAS",
                "ca-read": "Read certificate authorities",
                "ca-write": "Edit certificate authorities",
                "generate-preview": "Generate preview",
                "preview-read": "Read preview",
                "tally-resolution-submit": "Submit tally resolution",
                "phone-blacklist-read": "Read phone blacklist",
                "phone-blacklist-create": "Create phone blacklist entries",
                "phone-blacklist-update": "Edit phone blacklist entries",
                "phone-blacklist-delete": "Delete phone blacklist entries",
                "election-event-voter-list-reconciliation": "Reconcile election event voter list",
                "messaging-account-read": "Read messaging accounts",
                "messaging-account-write": "Manage messaging accounts",
                "messaging-config-write": "Configure election event messaging",
                "messaging-config-read": "Read election event messaging",
            },
        },
        generalSettingsScreen: {
            body: "Enable languages in the system. Only languages enabled here will be available for election events.",
        },
        eventsScreen: {
            title: "Scheduled Events",
            subtitle: "Manages the configuration of the automatic execution of events like the start or end of the voting period.",
            messages: {
                createSuccess: "Scheduled Event created successfully",
                createError: "Error creating Scheduled Event",
                editSuccess: "Scheduled Event edited successfully",
                editError: "Error editing Scheduled Event",
                onlineWithEarlyVoting: "A start schedule cannot open Online and Early voting together: early voting has to start before online voting.",
            },
            eventType: {
                label: "Type",
                ALLOW_INIT_REPORT: "Allow Initialization Report",
                START_VOTING_PERIOD: "Start Voting Period",
                END_VOTING_PERIOD: "End Voting Period",
                ALLOW_VOTING_PERIOD_END: "Allow Voting Period End",
                START_ENROLLMENT_PERIOD: "Start Enrollment Period",
                END_ENROLLMENT_PERIOD: "End Enrollment Period",
                START_LOCKDOWN_PERIOD: "Start Lockdown Period",
                END_LOCKDOWN_PERIOD: "End Lockdown Period",
                ALLOW_TALLY: "Allow Tally",
                START_READINESS_TEST: "Start Election Readiness Test",
                END_READINESS_TEST: "End Election Readiness Test",
                START_FINAL_TESTING: "Start Final Testing and Lockdown",
                END_FINAL_TESTING: "End Final Testing and Lockdown",
                START_TEST_VOTING: "Start Test Voting",
                END_TEST_VOTING: "End Test Voting",
            },
            warning: {
                votingWindowDays: "The voting window of {{election}} covers {{days}} local days ({{start_local}} to {{end_local}}, {{time_zone}}); the rule asks for {{expected}}.",
                finalTestingLeadTime: "Final testing of {{election}} starts {{final_testing_local}}, less than {{minimum_days}} days before voting opens at {{voting_start_local}} ({{time_zone}}).",
                closeBeforeOpen: "Voting at {{election}} closes at or before it opens ({{start_local}} to {{end_local}}, {{time_zone}}).",
                shortLastDay: "The last voting day at {{election}} has {{hours}} hours, less than {{minimum_hours}}: voting closes {{end_local}} ({{time_zone}}).",
            },
            election: {
                label: "Election",
            },
            empty: {
                header: "No Scheduled Events yet.",
                body: "Do you want to create one?",
                button: "Create Scheduled Event",
            },
            create: {
                title: "Create Scheduled Event",
                subtitle: "Create a new Scheduled Event configuration.",
            },
            edit: {
                title: "Edit Scheduled Event",
                subtitle: "Edit Scheduled Event configuration.",
                delete: "Are you sure you want delete this Scheduled Event?",
            },
            fields: {
                electionId: "Election",
                eventProcessor: "Type",
                stoppedAt: "Stopped At",
                scheduledDate: "Scheduled At",
            },
        },
        reportsScreen: {
            title: "Reports",
            subtitle: "Generate reports for the election events",
            messages: {
                createSuccess: "Report created successfully",
                createError: "Error creating Report",
                submitError: "Error submitting Report",
                updateSuccess: "Report updated successfully",
                passwordMismatch: "Password and confirm password do not match. Please ensure both fields contain the same password.",
                incorectPassword: "Incorrect password",
                decryptFileTitle: "How to decrypt the file",
                decryptInstructions: "1. '-in' :The path to the encrypted file. \n2. '-out' :The path where the decrypted file will be saved. \n3. '-pass' :The password used to encrypt the file. \n",
                encryptSuccess: "Successfully set up report encryption",
                encryptError: "Error setting up report encryption",
            },
            reportType: {
                BALLOT_RECEIPT: "Ballot Receipt",
                ELECTORAL_RESULTS: "Electoral Results",
                MANUAL_VERIFICATION: "Manual Verification",
                PARTICIPATION_REPORT: "Participation Report",
                STATISTICAL_REPORT: "Statistical Report",
                OVCS_EVENTS: "Overseas Voting Monitoring - OVCS Events",
                AUDIT_LOGS: "Audit Logs",
                ACTIVITY_LOG: "Activity Log",
                STATUS: "Status",
                OVCS_INFORMATION: "OVCS Information",
                OVERSEAS_VOTERS: "List of overseas voters",
                OV_USERS_WHO_VOTED: "List of Overseas Voters who Voted",
                OV_WITH_VOTING_STATUS: "List of Overseas Voters with Voting Status",
                OVCS_STATISTICS: "Overseas Voting Monitoring - OVCS Statistics",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "List of OV who Pre-enrolled but Disapproved",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "List of OV who Pre-enrolled but subject for Manual Validation",
            },
            reportEncryptionPolicy: {
                title: "Encryption Policy",
                UNENCRYPTED: "Unencrypted",
                CONFIGURED_PASSWORD: "Configured Password",
            },
            empty: {
                header: "No Reports yet.",
                body: "Do you want to create one?",
                button: "Create Report",
            },
            create: {
                title: "Create Report",
                subtitle: "Create a new Report configuration.",
            },
            edit: {
                title: "Edit Report",
                subtitle: "Edit Report configuration.",
                delete: "Are you sure you want delete this Report?",
            },
            fields: {
                electionId: "Election",
                template: "Template",
                reportType: "Report Type",
                repeatable: "Repeatable",
                cronExpression: "Cron Expression",
                emailRecipients: "Email Recipients",
                emailRecipientsPlaceholder: "Type email and press Enter",
            },
            delete: {
                body: "Are you sure you want delete this Report?",
            },
            actions: {
                generate: "Generate",
                delete: "Delete",
                edit: "Edit",
                preview: "Preview",
            },
        },
        googleMeet: {
            title: "Generate Google Meet Link",
            generateButton: "Google Meet",
            meetingTitle: "Meeting Title",
            description: "Description (Optional)",
            startDate: "Start Date",
            startTime: "Start Time",
            duration: "Duration (minutes)",
            attendeeEmails: "Attendee Emails",
            attendeeEmailHelp: "Comma-separated emails for meeting participants",
            note: "Note: This will create a calendar event in your Google Calendar with a Google Meet link. You'll need to sign in to your Google account.",
            success: "Google Meet Link Generated Successfully!",
            copy: "Copy to clipboard",
            copied: "Link copied to clipboard!",
            instructions: "Share this link with participants to join the meeting. The calendar event has been added to your Google Calendar.",
            generating: "Generating...",
            generate: "Generate Meet Link",
        },
        common: {
            export: "Export can be a long operation. Are you sure you want to export records?",
            resources: {
                electionEvent: "Election Event",
                election: "Election",
                contest: "Contest",
                candidate: "Candidate",
                noResult: {
                    askCreate: "Do you want to create one?",
                },
            },
            label: {
                add: "Add",
                actions: "Actions",
                create: "Create",
                delete: "Delete",
                archive: "Archive",
                unarchive: "Unarchive",
                cancel: "Cancel",
                edit: "Edit",
                yes: "Yes",
                no: "No",
                save: "Save",
                close: "Close",
                back: "Back",
                next: "Next",
                warning: "Warning",
                json: "Preview",
                noResult: "No result",
                import: "Import",
                export: "Export",
                loadingData: "Loading data ...",
                exportFormat: "Export in {{format}} format - '{{item}}' results",
                allResults: "election event",
                globalAreaResults: "all areas",
                title: "Title",
                subtitle: "Subtitle",
                kind: "File type",
                filter: "Custom Filters",
                approve: "Approve",
                continue: "Continue",
                logout: "Logout",
                selectTenant: "Select Tenant",
                processing: "Processing...",
                tenantName: "Tenant Name",
            },
            language: {
                es: "Spanish",
                en: "English",
                fr: "French",
                cat: "Valencian",
                tl: "Tagalog",
                gl: "Galician",
                nl: "Dutch",
                eu: "Euskera",
            },
            channel: {
                online: "Online",
                kiosk: "Kiosk",
                early_voting: "Early voting",
                telephone: "Telephone voting",
                other: "Other",
            },
            message: {
                delete: "Are you sure you want to delete this item?",
                continueOrLogout: "Do you want to stay connected to this tenant or logout?",
            },
        },
        createResource: {
            electionEvent: "Create an Election Event",
            election: "Create an Election",
            contest: "Create a Contest",
            candidate: "Create a Candidate",
        },
        importResource: {
            electionEvent: "Import an Election Event",
            election: "Import an Election",
            contest: "Import a Contest",
            candidate: "Import a Candidate",
            ImportHashMismatch: "Hashes don't match. Integrity check failure.",
        },
        sideMenu: {
            electionEvents: "Election Events",
            search: "Search",
            usersAndRoles: "Users and Roles",
            electoralLogConsole: "Electoral Log",
            taskQueues: "Task Queues",
            logs: "Logs",
            settings: "Settings",
            help: "Help",
            templates: "Templates",
            active: "Active",
            archived: "Archived",
            addResource: {
                electionEvent: "Create an Election Event",
                election: "Create an Election",
                contest: "Create a Contest",
                candidate: "Create a Candidate",
            },
            menuActions: {
                archive: {
                    electionEvent: "Archive this Election Event",
                },
                unarchive: {
                    electionEvent: "Unarchive this Election Event",
                    election: "Unarchive this election",
                    contest: "Unarchive this Contest",
                    candidate: "Unarchive this Candidate",
                },
                remove: {
                    electionEvent: "Remove this Election Event",
                    election: "Remove this Election",
                    contest: "Remove this Contest",
                    candidate: "Remove this Candidate",
                },
                messages: {
                    confirm: {
                        archive: "Are you sure to archive this item?",
                        unarchive: "Are you sure to unarchive this item?",
                        delete: "Are you sure to delete this item?",
                        sealsUnknown: "The ballot box seals could not be checked: if it has sealed ballot boxes, the delete is refused.",
                        archiveNamed: 'Are you sure you want to archive "{{name}}"?',
                        unarchiveNamed: 'Are you sure you want to unarchive "{{name}}"?',
                        deleteNamed: 'Are you sure you want to delete "{{name}}"?',
                    },
                    notification: {
                        success: {
                            archive: "The item has been archived",
                            unarchive: "The item has been unarchived",
                            delete: "The item has been deleted",
                            reloading: "Wait. The page will be reloaded in a few moments.",
                        },
                        error: {
                            archive: "Error while trying to archive this item",
                            unarchive: "Error while trying to unarchive this item",
                            delete: "Error while trying to delete this item",
                            deleteSealedElection: "This election has sealed ballot boxes and cannot be deleted. Archive its election event instead.",
                            deleteSealedEvent: "This election event has sealed ballot boxes and cannot be deleted. Archive it instead.",
                            deleteMaybeSealed: "Error while trying to delete this item. If it has sealed ballot boxes, it can't be deleted.",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Candidate configuration.",
            },
            edit: {
                externalId: "External ID",
                general: "General",
                type: "Type",
                image: "Image",
                isDisabled: "Disabled",
                isExplicitInvalid: "Invalid Vote",
                isExplicitBlank: "Blank Vote",
                isCategoryList: "Category List",
                isWriteIn: "Write-in",
            },
            field: {
                name: "Name",
                alias: "Alias",
                description: "Description",
            },
            options: {
                "candidate": "Candidate",
                "option": "Option",
                "write-in": "Write-in",
                "open-list": "Open List",
                "closed-list": "Closed List",
                "semi-open-list": "Semi Open List",
                "invalid-vote": "Invalid Vote",
                "blank-vote": "Blank Vote",
            },
            invalidVotePosition: {
                label: "Invalid Vote Position",
                null: "None (Default)",
                top: "Top",
                bottom: "Bottom",
            },
            error: {},
            createCandidateSuccess: "Candidate created",
            createCandidateError: "Error creating candidate",
        },
        contestScreen: {
            common: {
                subtitle: "Contest configuration.",
            },
            edit: {
                externalId: "External ID",
                general: "General",
                type: "Type",
                image: "Image",
                system: "Ballot Voting System",
                design: "Ballot Design",
                reorder: "Reorder candidates",
                policies: "Policies",
            },
            field: {
                name: "Name",
                alias: "Alias",
                description: "Description",
            },
            options: {
                "non-preferential": "No Preferential",
                "plurality-at-large": "Plurality at Large",
                "instant-runoff": "Instant Runoff",
                "random": "Random",
                "external-procedure": "External Procedure",
                "custom": "Custom",
                "alphabetical": "Alphabetical",
            },
            tieBreakingPolicy: {
                label: "Tie-Breaking Policy",
            },
            auditButtonConfig: {
                "label": "Audit Button Display Options",
                "show": "Show",
                "not-show": "Not Show",
                "show-in-help": "Show In Help Dialog",
            },
            underVotePolicy: {
                "label": "Under Vote Policy",
                "allowed": "Allowed",
                "warn-only-in-review": "Warn in Review",
                "warn": "Warn",
                "warn-and-alert": "Warn and Alert",
                "warn-and-confirm-in-review": "Warn and Confirm in Review",
            },
            invalidVotePolicy: {
                "label": "Invalid Vote Policy",
                "allowed": "Allowed",
                "warn": "Warn",
                "warn-invalid-implicit-and-explicit": "Warn Invalid Implicit And Explicit",
                "not-allowed": "Not Allowed",
                "allowed-with-exclusive-explicit": "Allowed With Exclusive Explicit",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Candidates checkbox icon shape",
                "square-checkbox": "Square Checkbox",
                "round-checkbox": "Round Checkbox",
            },
            candidatesLayout: {
                "label": "Candidates layout",
                "helperText": "Paper ballot grid shows candidates as numbered cells with a fill-in circle, filled column by column, using Columns (4 if empty). Ranked contests always use the list.",
                "list": "List",
                "paper-grid": "Paper ballot grid",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Candidates And Lists",
                "allow-selecting-candidates": "Candidates Only",
                "allow-selecting-lists": "Lists Only",
                "disabled": "Disabled",
            },
            collapsibleListsPolicy: {
                "label": "Collapsible Lists",
                "disabled": "Disabled",
                "enabled-expanded": "Enabled (starts expanded)",
                "enabled-collapsed": "Enabled (starts collapsed)",
            },
            blankVotePolicy: {
                "label": "Blank Vote Policy",
                "allowed": "Allowed",
                "warn-only-in-review": "Warn in Review",
                "warn": "Warn",
                "not-allowed": "Not Allowed",
            },
            overVotePolicy: {
                "label": "Over Vote Policy",
                "allowed": "Allowed",
                "allowed-with-msg": "Allowed with Warning Message",
                "allowed-with-msg-and-alert": "Allowed with Warning message and Alert",
                "not-allowed-with-msg-and-alert": "Not Allowed with Warning message and Alert",
                "not-allowed-with-msg-and-disable": "Not Allowed with Warning message and Disable further selections",
            },
            duplicatedRankPolicy: {
                "label": "Invalid Vote - Duplicate Rank Policy",
                "allowed-warn-and-dialog": "Show Warning and Dialog (voter can proceed)",
                "not-allowed-warn-and-dialog": "Show Warning and Dialog (voter not allowed to proceed)",
            },
            preferenceGapsPolicy: {
                "label": "Invalid Vote - Skipped Ranks Policy",
                "allowed-warn-and-dialog": "Show Warning and Dialog (voter can proceed)",
                "not-allowed-warn-and-dialog": "Show Warning and Dialog (voter not allowed to proceed)",
            },
            paginationPolicy: {
                label: "Page Name",
            },
            isAcclaimed: {
                label: "Decided by acclamation",
                helperText: "Voters see this contest but cannot select anything, nothing is recorded for it, and every candidate is reported as a winner with zero votes. Set this before publishing ballots: changing it afterwards invalidates ballots already cast.",
            },
            allowWriteins: {
                label: "Allow Write-Ins",
            },
            maxVotes: {
                helperText: "Maximum number of candidates a voter can select (non-preferential voting).",
                helperTextPreferential: "Highest ranking position available to voters (e.g. '5' means positions 1–5). Must be at least the number of candidates to rank (preferential voting).",
            },
            error: {},
            createContestSuccess: "Contest created",
            createContestError: "Error creating contest",
        },
        keysGeneration: {
            serverCustody: {
                recoveryInstructions: "If you imported this election event or lost the saved file, download its current custody file here. Save it, then upload it below.",
                fileFormat: "Supported format: JSON",
                waiting: "Waiting for your trustee server to create a custody proof…",
                unavailable: "The trustee server has not responded. Check that it is running, then upload the custody file again.",
                failed: "The trustee server could not create the proof: {{error}}",
                invalidReply: "The trustee server returned an incomplete response. Please try again.",
                cancelled: "The request was cancelled. Upload the file again to continue.",
                downloadInstructions: "Download and save this custody file. Upload the same file in the next step and for future tallies. It is not a backup of your private keys.",
                uploadInstructions: "Upload your saved custody file. Your running server or browser trustee will create a signed custody proof automatically. You can also upload a signed custody proof generated manually.",
                tallyInstructions: "Upload the custody file saved during the key ceremony. Your running server or browser trustee will create a fresh signed custody proof for this tally. You can also upload a signed custody proof generated manually.",
            },
            configureStep: {
                create: "Create Key Ceremony",
                name: "Key Ceremony Name",
                allElections: "All Elections",
                title: "Create Election Event Key Ceremony",
                subtitle: "Each trustee generates and keeps their keys locally, then confirms custody for the Election Event. Choose the trustees and the minimum number required to tally.",
                threshold: "Threshold",
                trusteeList: "Trustees",
                errorMinTrustees_one: "You selected only {{selected}} trustee, but you must select at least {{threshold}}.",
                // `_many` is selected only in es/cat/fr, for exact multiples of a million. English never
                // selects it, but the other bundles are typed `TranslationType = typeof englishTranslation`,
                // so the key has to be declared here before they can carry it.
                errorMinTrustees_many: "You selected only {{selected}} trustees, but you must select at least {{threshold}}.",
                errorMinTrustees_other: "You selected only {{selected}} trustees, but you must select at least {{threshold}}.",
                errorThreshold: "You selected threshold {{selected}} but it must be between {{min}} and {{max}}.",
                errorCreatingCeremony: "Error creating Key Ceremony: {{error}}",
                createCeremonySuccess: "Key Ceremony created",
                confirmdDialog: {
                    ok: "Yes, Create Key Ceremony",
                    cancel: "Cancel",
                    title: "Are you sure you want to Create Key Ceremony?",
                    automaticCeremonyTitle: "Are you sure you want to Create Automatic Key Ceremony?",
                    description: "You are about to Create Key Ceremony. This action will notify the Trustees to participate in the creation and distribution of the Election Event Keys.",
                    automaticCeremonyDescription: "Automatic ceremonies skip manual custody confirmations. The trustee runners must still generate and verify the election keys.",
                },
                filterTrustees: "Filter Trustees",
                errorPermisionLabels: "Cannot create Key Ceremony: one or more permission labels are missing.",
                automaticCeremonyToggle: "Automatic Ceremony",
            },
            ceremonyStep: {
                custodyConfirmed: "Custody confirmed",
                custodyComplete: "Your part is complete. No further action is required from you.",
                waitingForTrustees: "Waiting for the remaining trustees to complete their custody confirmation and any required approval.",
                moreActions: "More actions",
                cancel: "Cancel Key Ceremony",
                progressHeader: "Key Ceremony Progress",
                waiting: "Waiting",
                complete: "Complete",
                halted: "Halted",
                description: "This screen shows the progress and logs of the Election Event's Key Ceremony. Each trustee generates and keeps their key share on their trustee machine, then confirms custody using a signed proof.",
                executionStatus: "Status: {{status}}",
                confirmdDialog: {
                    ok: "Yes, Cancel Create Key Ceremony",
                    cancel: "Go back to Key Ceremony",
                    title: "Are you sure you want to Cancel Key Ceremony?",
                    description: "You are about to Cancel Key Ceremony. After performing this action, to have a succcessful Key Ceremony you will have to Create a new one.",
                },
                header: {
                    trusteeName: "Trustee Name",
                    fragment: "Key Fragment Generated",
                    downloaded: "Custody Request Downloaded",
                    checked: "Custody Confirmed",
                },
                logsHeader: {
                    title: "Logs",
                    date: "Date",
                    entry: "Entry",
                },
                emptyLogs: "No logs yet.",
            },
            startStep: {
                title: "Trustee Key Ceremony",
                subtitle: "You are about to participate in the Key Ceremony as a Trustee (<strong>{{name}}</strong>). This involves the following steps:",
                one: "<strong>Download</strong> the custody file.",
                two: "Keep copies of your <strong>custody file</strong>. Trustee recovery backups are managed separately.",
                three: "<strong>Upload</strong> the saved custody file. Your server or browser trustee creates a signed custody proof; complete any required approval signature.",
            },
            downloadStep: {
                title: "Download Custody File",
                subtitle: "Save this custody file for custody confirmation and future tallies:",
                downloadButton: "Download Custody File",
                downloaded: "Custody file downloaded successfully.",
                errorEmptyKey: "Download error, empty file",
                unexpectedError: "The custody file could not be downloaded. Please try again.",
                alreadyVerified: "Your trustee custody was already confirmed.",
                unavailable: "The custody file is no longer available because the ceremony has moved on.",
                confirmdDialog: {
                    ok: "Confirm Saved Copies and Continue",
                    cancel: "Go Back",
                    title: "Save Your Custody File",
                    description: "Keep two copies of the custody file. Trustee keys and election state must be backed up separately by the trustee server operator.",
                    firstCopy: "First copy saved",
                    secondCopy: "Second copy saved",
                    confirmError: "Save both copies and check the confirmation boxes to continue",
                },
            },
            checkStep: {
                title: "Confirm Trustee Custody",
                required: "Custody confirmation required",
                reconfirmButton: "Reconfirm custody (optional)",
                reconfirmDescription: "Your custody is already confirmed. This additional confirmation is optional.",
                subtitle: "Upload your saved custody file or a signed custody proof:",
                errorUploading: "Invalid signed custody proof, please try again",
                errorEmptyFile: "File empty or not found",
                verified: "Trustee custody confirmed successfully.",
            },
        },
        miruExport: {
            create: {
                success: "Creating Transmission Package...",
                error: "Error creating Transmission Package ",
            },
            send: {
                success: "Sending Transmission Package...",
                error: "Error sending Transmission Package ",
            },
        },
        tally: {
            errorUploadingSignature: "There was an error uploading signature",
            downloadTransmissionPackage: "Download Transmission Package",
            resultsPublication: {
                sectionTitle: "Publish to results website",
                policyTitle: "Results Website",
                policyAccess: "Results Website Access",
                policyVisibility: "Results Website Visibility",
                enabled: "Enabled",
                disabled: "Disabled",
                fullEvent: "Full event",
                areaBased: "Area based",
                publishStarted: "Results publication started",
                publishError: "Could not start results publication",
                revoked: "Results publication revoked",
                revokeError: "Could not revoke results publication",
                waitingForTally: "Results can be published after this tally has completed.",
                writePermissionRequired: "You need publish-results-write permission to publish or revoke results.",
                readPermissionRequired: "You need publish-results-read permission to view publication history.",
                disabledPolicy: "Results website publishing is disabled for this election event. Enable it in the election event data before publishing results.",
                loadingElectionContext: "Results publication is loading election context.",
                route: "Route",
                eventResults: "Event results",
                electionResults: "Election results",
                election: "Election",
                access: "Access",
                publicAccess: "Public access",
                authenticatedAccess: "Authenticated access",
                visibility: "Visibility",
                fullPublishedScope: "Full published scope",
                personalVisibility: "Personal visibility",
                contests: "Contests",
                noTalliedContests: "No tallied contests available.",
                publishSelectedContests: "Publish selected contests",
                selectedContestCount_one: "{{count}} contest selected",
                selectedContestCount_many: "{{count}} contests selected",
                selectedContestCount_other: "{{count}} contests selected",
                history: "Publication history",
                version: "Version",
                status: "Status",
                published: "Published",
                revokedAt: "Revoked",
                actions: "Actions",
                open: "Open",
                revoke: "Revoke",
                noPublications: "No publications yet.",
                confirmTitle: "Start publish to results website?",
                confirmDescription: "This will create a new publication from the current tally execution. The existing voter-facing results stay active until this publish task succeeds.",
                close: "Close",
            },
            transmissionPackage: {
                title: "Transmission Package for Area '{{name}}' and Election '{{eventName}}'",
                description: "Allows you to export a Transmission Package to Destination Servers or download it.",
                erFileSha256: "ER file SHA-256:",
                actions: {
                    send: {
                        title: "Send",
                        dialog: {
                            title: "Do you want to Send the Transmission Package?",
                            description: "Please confirm you want to Send the Transmission Package for Area `{{name}}` to the Destination Servers.",
                            confirm: "Send Transmission Package",
                            cancel: "Close",
                        },
                        disabled: "The required signatures are missing, or the transmission package has already been sent to every destination.",
                    },
                    regenerate: {
                        title: "Regenerate",
                        dialog: {
                            title: "Do you want to regenerate the Transmission Package?",
                            description: "Please confirm you want to regenerate the Transmission Package for Area `{{name}}`",
                            confirm: "Regenerate Transmission Package",
                            cancel: "Close",
                        },
                    },
                    sign: {
                        title: "Regenerate",
                        dialog: {
                            title: "Do you want to sign the Transmission Package?",
                            description: "Please confirm you want to regenerate the Transmission Package for Area `{{name}}`",
                            confirm: "Sign Transmission Package",
                            cancel: "Close",
                            input: {
                                placeholder: "Enter your password",
                            },
                        },
                    },
                    download: {
                        title: "Download",
                        emlTitle: "Download EML {{date}}",
                        transmissionPackageTitle: "Download Transmission Package {{date}}",
                        transmissionReportTitle: "Download Transmission Report",
                        csvTitle: "Download Results CSV {{date}}",
                        ovcsPublicKeyTitle: "Download OVCS public key",
                        recordError: "The download could not be recorded, so it was not started. Please try again.",
                        dialog: {
                            title: "Do you want to Download the Transmission Package?",
                            description: "Please confirm you want to Download the Transmission Package for Area `{{name}}.`",
                            confirm: "Download Transmission Package",
                            cancel: "Close",
                        },
                    },
                },
                destinationServers: {
                    title: "Destination Servers",
                    description: "The table below shows the sending status of each of the Destination Servers.",
                    status: "Sent to {{signed}} out of {{total}}",
                    manualReceipt: "Manual receipt",
                    handOver: "Download the package and hand it over",
                    sealedFor: "Sealed for its key, SHA-256 {{key}}…",
                    table: {
                        serverName: "Server Name",
                        sendStatus: "Sending Status",
                    },
                },
                signatures: {
                    title: "Signatures",
                    description: "Members can sign the transmission package. The table shows each member’s signing status.",
                    status: "{{signed}} of {{total}}, {{minimum}} needed",
                    statusNoMinimum: "{{signed}} of {{total}}",
                    table: {
                        trusteeName: "Member",
                        signed: "Has Signed",
                    },
                },
            },
            sendToTransmissionPackageServers: "Send Transmission Package for Area '{{name}}'",
            uploadTransmissionPackage: "Sign Transmission Package",
            uploadTransmissionPackageDesc: "Upload your Signature to sign the Transmission Package. This is an optional operation.",
            exportElectionArea: "Generate Transmission Package for Area '{{name}}'",
            generateReport: "Generate {{name}}",
            templateTitle: "Results Template",
            templateSubTitle: "Optionally overwrite the results template.",
            keysCeremonyTitle: "Key Ceremony",
            keysCeremonySubTitle: "Select the Key Ceremony for this tally",
            ceremonyTitle: "Elections to Tally",
            initializationTitle: "Elections for Initialization Report",
            ceremonySubTitle: "Choose the elections you want to tally",
            tallyTitle: "Elections Tally Progress",
            logsTitle: "Logs",
            resultsTitle: "Results & Participation",
            generalInfoTitle: "General Information",
            sessionId: "Tally session ID",
            selectedQuorum: "Selected quorum",
            trusteeTallyTitle: "Trustees",
            trusteeTallySubTitle: "Custody confirmation status",
            ballotBoxes: {
                unavailable: "Seals unavailable",
                sealed: "{{sealed}} of {{total}} sealed",
                publishing: "Sealed, {{published}} of {{total}} seal records published",
                sealing: "Sealing at {{time}}",
                notSealed: "Not sealed",
                help: "An election can be tallied once every ballot box is sealed and its seal record is published.",
                failed: "Not sealed: incident",
                overdue: "Sealing overdue",
                blocked: "{{name}}: {{reason}}",
                reason: {
                    "not-sealed": "voting hasn't closed, so its ballot boxes have no seals yet",
                    "sealing": "its ballot boxes are sealed when the grace period ends",
                    "overdue": "its ballot boxes are past their deadline and not sealed yet (see its Dashboard)",
                    "publishing": "the seal records of some of its ballot boxes are still being published",
                    "failed": "a ballot box could not be sealed, an incident (see its Dashboard)",
                    "unavailable": "its ballot box seals could not be read",
                },
            },
            eligibility: {
                ballotBoxesUnavailable: "The ballot boxes' seals of a selected election could not be read, so it can't be tallied yet. Reload the page to try again.",
                selectElection: "Select at least one election.",
                publishElection: "Publish each selected election before creating its tally.",
                tallyDisallowed: "Tallying is disabled for a selected election.",
                endVoting: "End voting in each selected election and stop its active voting channels before creating the tally.",
                sealBallotBoxes: "An election can be tallied once every ballot box is sealed and its seal record is published.",
            },
            createTallySuccess: "Tally created",
            createTallyError: "Could not create Tally",
            startTallySuccess: "Tally started",
            startTallyError: "Could not start Tally",
            startTallyCeremonySuccess: "Tally Ceremony started",
            startTallyCeremonyError: "Could not start Tally Ceremony",
            cancelTallyCeremonySuccess: "Tally Ceremony canceled",
            cancelTallyCeremonyError: "Could not cancel Tally Ceremony",
            recountTallyCeremony: "Recount tally",
            recountTallyCeremonyMessage: "This will generate a fresh results event for the completed tally session.",
            recountTallyCeremonyStarting: "Starting recount...",
            recountTallyCeremonySuccess: "Recount started",
            recountTallyCeremonyError: "Could not start recount",
            recountTallyCeremonyOk: "Recount",
            trusteeTitle: "Trustees process",
            trusteeSubTitle: "Upload your custody file or signed custody proof",
            invited: "You have been invited to participate in a Tally ceremony. Please ",
            click: "click on the tally Action",
            participate: "to participate.",
            breadcrumbSteps: {
                start: "Start",
                finish: "Finish",
                tally: "Tally",
                results: "Results",
                ceremony: "Ceremony",
            },
            common: {
                title: "Tally",
                subTitle: "Tally configuration.",
                cancel: "Back",
                next: "Next",
                date: "Tally Date",
                global: "Global",
                noTrustees: "No trustees yet",
                imported: " trustees confirmed custody",
                needed: " trustees needed",
                start: "Start Tally",
                ceremony: "Start Tally Ceremony",
                initialization: "Start Initialization Report",
                results: "Results",
                dialog: {
                    ok: "Ok",
                    okTally: "Start Tally",
                    okCancel: "Cancel Tally",
                    cancel: "Close",
                    title: "Are you sure you want to  start a ceremony?",
                    tallyTitle: "Are you sure you want to  start the tally?",
                    cancelTitle: "Are you sure you want to  cancel the tally?",
                    message: "This tally ceremony asks trustees to submit public custody proofs. Keep their runners active with their local protocol state.",
                    cancelMessage: "You are about to cancel the tally ceremony. This action is not undoable.",
                    ceremony: "The required trustees have confirmed custody. Start the tally with their runners active?",
                    startAutomatedTallyMessage: "Select Start Tally to run tally process and display results, or Close to cancel.",
                },
            },
            table: {
                ballotBoxes: "Ballot boxes",
                elections: "Elections",
                selected: "Selected",
                status: "Status",
                progress: "Progress",
                method: "Tally Method",
                elegible: "Eligible Voters",
                number: "Number of Votes",
                total: "Total",
                turnout: "%",
                candidates: "Candidate Results",
                options: "Options",
                global: "Participation Summary",
                elegible_census: "Eligible Voters",
                cast_votes: "Number of Votes",
                cast_votes_percent: "Percent of Votes",
                total_votes: "Total Voters",
                total_votes_percent: "Participation",
                total_votes_counted: "Total Votes Counted",
                total_auditable_votes: "Total Auditable Votes",
                total_valid_votes: "Total Valid Votes",
                total_valid_votes_percent: "Valid Votes Percent",
                total_invalid_votes: "Total Invalid Votes",
                total_invalid_votes_percent: "Invalid Votes Percent",
                explicit_invalid_votes: "Explicitly Invalid Votes",
                explicit_invalid_votes_percent: "Explicitly Invalid Votes Percent",
                implicit_invalid_votes: "Implicitly Invalid Votes",
                implicit_invalid_votes_percent: "Implicitly Invalid Votes Percent",
                blank_votes: "Blank Votes",
                explicit_blank_votes: "Explicit Blank Votes",
                implicit_blank_votes: "Implicit Blank Votes",
                blank_votes_percent: "Blank Votes Percent",
                number_of_votes: "Number of Votes",
                winning_position: "Winning position",
                weight: "Weight",
                preferential: {
                    candidate: "Candidate",
                    winner: "Winner",
                    eliminated: "Eliminated",
                    round: "Round",
                },
                total_declined_to_vote: "Total Declined to Vote",
                total_blank_ballots: "Total Blank Ballots",
                participation_by_channel: "Participation by channel",
                channel: "Channel",
                channel_online: "Online",
                channel_kiosk: "Kiosk",
                channel_early_voting: "Early voting",
                channel_telephone: "Telephone",
                channel_paper: "Paper",
                channel_postal: "Postal",
                channel_in_person: "In person",
                acclamation_note: "Won by acclamation. This contest was decided without a vote, so no votes were recorded for it.",
            },
            pendingResolutions: {
                round: "Round {{round}}",
                tieResolutionRequired: "Tie Resolution Required",
                tieResolved: "Tie Resolved",
                globalArea: "Global",
                pendingResolutionsHeader: "Pending resolutions",
                pendingResolutionStatus: "Pending Resolution",
                resolvedStatus: "Resolved",
                resolutionTitle: "Resolution",
                selectContest: "Select an item from the left to view details",
                selectCandidateToAdvance: "Select candidate to advance",
                undoResolution: "Undo Resolution",
                applyResolutions: "Apply Resolutions and Recalculate",
                submitSuccess: "Resolutions submitted. Tally is resuming...",
                submitError: "Failed to submit resolutions. Please try again.",
                filter: "Filter",
                save: "Save",
                pendingApplyStatus: "Pending calculation",
                filterElection: "Election",
                filterContest: "Contest",
                filterArea: "Area",
                filterStatusLabel: "Status",
                clearFilters: "Clear filters",
                candidateWithVotes: "{{name}} ({{votes}} votes)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} votes, {{percent}}%)",
                tieInfoTitle: "Tally paused due to unresolved tie (Round {{round}})",
                tieInfoBody: "Candidates tied ({{votes}} votes, {{percent}}%): {{candidates}}. Manual tie-break required to continue tally.",
                tallyResumedTitle: "Tally resumed after resolution applied",
                tallyResumedBody: "Candidates tie was resolved on {{date}} by {{user}}",
            },
            chart: {
                votesForCandidates: "Votes For Candidates",
                blankVotes: "Blank Votes",
                invalidVotes: "Invalid Votes",
                totalVoters: "Total Voters",
                nonVoters: "Non Voters",
            },
            exportAllAreas: "Export All Areas Results in {{format}} format for '{{item}}'",
        },
        publish: {
            initialization: {
                countryInfo: "Generate the report for the entire Post or one country. Voting remains blocked until all required country and event-wide initialization is complete.",
                countriesError: "Could not load eligible countries. Close and try again.",
                noCountries: "This Post has no eligible countries with active ballot styles. Check its areas and publication before initializing.",
                country: "Country",
                entirePost: "Entire Post",
            },
            preview: {
                publicationAreas: "Select Area for Preview",
                action: "Preview",
                copy: "Copy link",
                copy_success: "Success copying preview link",
                copy_error: "Failed to copy preview link",
                success: "Success opening preview",
            },
            header: {
                change: "Changes to be Published",
                viewChange: "View Publication",
                history: "Publish History",
            },
            action: {
                generateInitializationReport: "Generate Initialization Report",
                startVotingPeriod: "Start Voting",
                startKioskVoting: "Start Kiosk Voting",
                startOnlineVoting: "Start Online Voting",
                startEarlyVoting: "Start Early Voting",
                startTelephoneVoting: "Start Telephone Voting",
                stopVotingPeriod: "Stop Voting",
                stopOnlineVoting: "Stop Online Voting",
                stopEarlyVoting: "Stop Early Voting",
                stopTelephoneVoting: "Stop Telephone Voting",
                stopKioskVotingPeriod: "Stop Kiosk Voting",
                pauseVotingPeriod: "Pause Voting",
                pauseKioskVoting: "Pause Kiosk Voting",
                pauseOnlineVoting: "Pause Online Voting",
                pauseEarlyVoting: "Pause Early Voting",
                pauseTelephoneVoting: "Pause Telephone Voting",
                generate: "Regenerate",
                publish: "Publish Changes",
                back: "Back",
            },
            label: {
                current: "Current",
                previous: "Previous Publication",
                publication: "Publication",
                diff: "Changes to Publish",
            },
            empty: {
                header: "No Publication Yet.",
                action: "Generate Publication",
            },
            forbidden: {
                header: "Cannot Publish until the Key Ceremony is completed.",
            },
            skippedElections: {
                dismiss: "Dismiss",
                title: "Some elections stay closed",
                ballotBoxSealPolicy: "{{name}} stays closed: its voting has closed and Seal at close makes closing final.",
                other: "{{name}} was left as it was ({{reason}}).",
            },
            dialog: {
                title: "Confirm Action",
                info: "You have clicked on a sensitive action, so we need you to confirm in order to continue",
                initializationInfo: "You are about to generate initialization report. Are you sure you want to continue?",
                startInfo: "You are about to start voting period. Are you sure you want to continue?",
                stopInfo: "You are about to stop voting period. Are you sure you want to continue?",
                stopSeal: "You are about to stop voting in {{name}}. Its ballot boxes are then sealed: no ballot can be added, changed or deleted, and voting cannot start again. Are you sure you want to continue?",
                stopSealEvent: "You are about to stop voting in every election. Their ballot boxes are then sealed: no ballot can be added, changed or deleted, and voting cannot start again. Are you sure you want to continue?",
                startSealNote: "With Seal at close, closed voting stays closed: elections whose voting has closed won't open.",
                channel: {
                    ONLINE: "Online",
                    KIOSK: "Kiosk",
                    EARLY_VOTING: "Early voting",
                    TELEPHONE: "Telephone",
                },
                kioskStopInfo: "You are about to stop the kiosk voting period. Are you sure you want to continue?",
                pauseInfo: "You are about to pause voting period. Are you sure you want to continue?",
                publishInfo: "You are about to generate a publication. Are you sure you want to continue?",
                ok: "Confirm",
                ko: "Cancel",
                error: "Error loading ballot publication",
                error_publish: "Error publishing ballot publication",
                error_capacity: "Ballot style generation failed: {{message}}",
                error_status: "Error change ballot publication status",
                error_preview: "Error previewing publication",
                diff: "Rendering all changes might make the page unresponsive. Are you sure you want to continue?",
                confirmation: "The action you are about to perform is sensitive and requires confirmation. Please enter your password to proceed with {{action}}.",
                stopSealNotYet: "You are about to stop voting period. {{holding}} Are you sure you want to continue?",
                sealHolding_one: "With Seal at close, its ballot boxes are sealed once every enabled channel is closed: {{channels}} is still enabled and not closed.",
                sealHolding_other: "With Seal at close, its ballot boxes are sealed once every enabled channel is closed: {{channels}} are still enabled and not closed.",
                sealNotEnabled: "{{channel}} isn't closed and isn't enabled for this Post: stop it to seal the ballot boxes.",
                sealNotEnabledPost: "In {{post}}, {{channel}} isn't closed and isn't enabled: stop it at that Post to seal its ballot boxes.",
                sealNoChannel: "No channel is enabled for this Post and none has run, so its ballot boxes aren't sealed.",
                stopNeverOpened_one: "{{channels}} never opened: stopping it means it won't open.",
                stopNeverOpened_other: "{{channels}} never opened: stopping them means they won't open.",
                stopSealGrace_one: "You are about to stop voting in {{name}}. Its ballot boxes are sealed when the grace period ends, {{count}} minute later: from then on no ballot can be added, changed or deleted. Voting cannot start again. Are you sure you want to continue?",
                stopSealGrace_other: "You are about to stop voting in {{name}}. Its ballot boxes are sealed when the grace period ends, {{count}} minutes later: from then on no ballot can be added, changed or deleted. Voting cannot start again. Are you sure you want to continue?",
                stopSealEventGrace_one: "You are about to stop voting in every election. Their ballot boxes are sealed when each election's grace period ends, up to {{count}} minute later: from then on no ballot can be added, changed or deleted. Voting cannot start again. Are you sure you want to continue?",
                stopSealEventGrace_other: "You are about to stop voting in every election. Their ballot boxes are sealed when each election's grace period ends, up to {{count}} minutes later: from then on no ballot can be added, changed or deleted. Voting cannot start again. Are you sure you want to continue?",
                stopSealEventSome: "You are about to stop voting in every election. {{sealed}} {{holding}} Are you sure you want to continue?",
                sealedNowPart: "The ballot boxes of {{names}} are then sealed: no ballot can be added, changed or deleted, and voting cannot start again there.",
                sealedGracePart_one: "The ballot boxes of {{names}} are sealed when their grace period ends, up to {{count}} minute later.",
                sealedGracePart_other: "The ballot boxes of {{names}} are sealed when their grace period ends, up to {{count}} minutes later.",
                holdingEventPart_one: "{{names}} keeps another channel enabled and not closed: its ballot boxes are sealed once that channel is closed.",
                holdingEventPart_other: "{{names}} keep another channel enabled and not closed: their ballot boxes are sealed once those channels are closed.",
                noChannelEventPart_one: "{{names}} enables no channel and none has run there: its ballot boxes aren't sealed.",
                noChannelEventPart_other: "{{names}} enable no channel and none has run there: their ballot boxes aren't sealed.",
                startSealNoteList: "With Seal at close, closed voting stays closed: {{items}}.",
                startKeptChannels_one: "{{post}}: {{channels}} stays closed",
                startKeptChannels_other: "{{post}}: {{channels}} stay closed",
                startKeptSealed: "{{post}} stays closed, as its ballot boxes are sealed",
                startNotEnabledList: "With Seal at close, a Start opens a channel only at the Posts that enable it: {{items}}.",
                startNotEnabledChannels_one: "{{post}}: {{channels}} isn't enabled there and stays Not started",
                startNotEnabledChannels_other: "{{post}}: {{channels}} aren't enabled there and stay Not started",
                stopNeverOpenedPosts_one: "{{names}} never opened: stopping closes it and seals its empty ballot boxes.",
                stopNeverOpenedPosts_other: "{{names}} never opened: stopping closes them and seals their empty ballot boxes.",
            },
            notifications: {
                generated: "Ballot generated",
                published: "Ballot published",
                change_status: "Election status changed",
            },
            sealRefusals: {
                startAgain: "Voting can't start again: with Seal at close, voting that has closed stays closed and its ballot boxes are sealed.",
                startDisabled: "Start Voting isn't available: this election's ballot boxes are sealed or being sealed, and with Seal at close closed voting stays closed.",
                closedIsFinal: "Closed voting can't change: with Seal at close, closed voting stays closed.",
            },
        },
        emailEditor: {
            subject: "Email Subject",
            tabs: {
                plaintext: "Plain Text Body",
                richtext: "Rich Text Body",
            },
        },
        sendCommunication: {
            send: "Send",
            title: "Send Notification",
            subtitle: "Send a notification to voters.",
            sendButton: "Send Notification",
            voters: "Audience",
            schedule: "Schedule",
            nowInput: "Send now",
            dateInput: "Date and time to start sending notifications",
            chooseDate: "Please choose a date",
            languages: "Languages",
            smsMessage: "SMS Message",
            errorSending: "Error sending the notification: {{error}}",
            successSending: "Notification scheduled successfully",
            method: "Template Method",
            type: "Communication Type",
            alias: "Template Alias",
            votersSelection: {
                ALL_USERS: "Everyone",
                NOT_VOTED: "Those who didn't vote yet",
                VOTED: "Those who already voted",
                SELECTED: "To {{total}} Selected {{voters}}",
            },
            path: {
                users: "users",
                voters: "voters",
            },
            methodTitle: "Communication Template",
            communicationMethod: {
                EMAIL: "Email",
                SMS: "SMS",
                WHATSAPP: "WhatsApp",
                VIBER: "Viber",
                MESSENGER: "Facebook Messenger",
            },
            communicationType: {
                CREDENTIALS: "Credentials",
                BALLOT_RECEIPT: "Ballot Receipt",
            },
            email: {
                subject: "Subject",
            },
        },
        tallysheet: {
            title: "Ballot boxes",
            subtitle: "Digitalized ballot boxes by channel",
            createTallySuccess: "Tally Sheet saved",
            createTallyError: "Error saving Tally Sheet",
            createTallyErrorSameKindExists: "Tally Sheet already exists for this contest with the same channel and area",
            allFieldsRequired: "All fields are required",
            header: {
                change: "Changes to be Published",
                viewChange: "View Publication",
                history: "Publish History",
            },
            action: {
                start: "Start Election",
                stop: "Stop Election",
                pause: "Pause",
                generate: "Regenerate",
                publish: "Publish Changes",
                back: "Back",
            },
            inputError: {
                totalValidDoesNotMatch: "Candidate votes ({{candidateVotesSum}}) must be between {{lowerBound}} and {{upperBound}} for this contest's voting rules ({{nonBlankValidVotes}} valid non-blank votes × up to {{maxMarks}} marks per ballot)",
                censusTooSmall: "Total votes ({{totalVotes}}) must not be greater than census ({{census}})",
                totalInvalidDoesNotMatch: "Total invalid votes ({{totalInvalid}}) must equal implicit invalid votes ({{implicitInvalid}}) plus explicit invalid votes ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "Total votes ({{totalVotes}}) must equal total valid votes ({{totalValidVotes}}) plus total invalid votes ({{totalInvalid}})",
                unknownCountingAlgorithm: "This contest's counting algorithm ({{countingAlgorithm}}) is not recognised, so the allowed number of candidate votes cannot be determined. Check the contest configuration.",
                blankBallotsInconsistent: "Blank Ballots must have the same value on every contest sheet of this ballot box",
                blankBallotsOutOfBounds: "Blank Ballots value is outside the range implied by this box's per-contest blank vote counts",
            },
            label: {
                area: "Area",
                channel: "Channel",
                total_votes: "Total Votes",
                total_valid_votes: "Total Valid Votes",
                total_invalid: "Total Invalid Votes",
                explicit_invalid: "Explicitly Invalid Votes",
                implicit_invalid: "Implicitly Invalid Votes",
                total_blank_votes: "Blank Votes",
                blank_ballots: "Blank Ballots",
                census: "Census",
            },
            common: {
                tallyCeremony: {
                    manage: "Manage Tally Ceremony",
                    view: "View Tally Ceremony",
                    cancel: "Cancel Tally Ceremony",
                    addKey: "Add Tally Key",
                },
                edit: "Edit",
                confirm: "Confirm",
                back: "Back",
                next: "Next",
                cancel: "Back",
                data: "Data",
                title: "Tally Sheet",
                subtitle: "Tally Sheet configuration.",
                candidates: "Candidates",
                save: "Save",
                approve: "Approve",
                disapprove: "Disapprove",
                show: "Show",
                add: "Add",
                versions: "Versions",
                warningDisapprove: "Are you sure to disapprove this Tally Sheet?",
                warningApprove: "Are you sure to approve this Tally Sheet?",
            },
            empty: {
                header: "No Tally Sheet Yet.",
                action: "Generate Tally Sheet",
                add: "Add",
            },
            breadcrumbSteps: {
                start: "Start",
                edit: "Edit",
                confirm: "Confirm",
                view: "View",
            },
            table: {
                area: "Area",
                contest: "Contest",
                approvedVersion: "Approved version",
                latestVersion: "Latest version",
                labels: "Labels",
                annotations: "Annotations",
            },
            versionsTable: {
                title: "Versions for ballot box",
                version: "Version",
                createdBy: "Created by",
                reviewedBy: "Reviewed by",
                createdAt: "Created at",
                reviewedAt: "Reviewed at",
                sourceImport: "Source import",
                importStatus: "Import status",
                openImport: "Open import",
                sourceFile: "Source file",
            },
            message: {
                reviewError: "Error reviewing tally sheet",
                reviewSuccess: "Tally sheet reviewed",
            },
        },
        application: {
            import: {
                title: "Import applications",
                subtitle: "Import applications data",
                paragraph: "Import applications using a spreadsheet file in Comma Separated Values (CSV) format. Download an example import CSV file here.",
                messages: {
                    success: "Applications imported successfully",
                    error: "Error importing applications",
                },
            },
            export: {
                title: "Export applications",
                subtitle: "Export applications data",
                button: "Export",
                paragraph: "Export applications data to a spreadsheet file in Comma Separated Values (CSV) format.",
                messages: {
                    success: "Applications exported successfully",
                    error: "Error exporting applications",
                },
            },
        },
        template: {
            noPermissions: "You don't have permission to access templates.",
            title: "Templates",
            subtitle: "List of templates",
            chooseMethods: "Choose Methods",
            default: "Use default template",
            empty: {
                title: "No Template Yet",
                subtitle: "Do you want to create one?",
            },
            action: {
                createOne: "Create Template",
            },
            create: {
                title: "Create a Template",
                success: "Template created",
                error: "Error creating Template",
            },
            update: {
                success: "Template updated",
                error: "Error updating Template",
            },
            edit: {
                title: "Edit a Template",
            },
            form: {
                smsMessage: "SMS Message",
                document: "Document",
                pdfOptions: "PDF Options",
                reportOptions: "Report Options",
                name: "Template Name",
                alias: "Template Alias",
                type: "Type",
                communicationMethod: "Method",
            },
            type: {
                CREDENTIALS: "Credentials",
                INITIALIZATION_REPORT: "Initialization Report",
                ELECTORAL_RESULTS: "Electoral Results",
                BALLOT_IMAGES: "Ballot Images",
                BALLOT_RECEIPT: "Ballot Receipt",
                ACTIVITY_LOGS: "Activity Logs",
                MANUAL_VERIFICATION: "Manual Verification",
                PARTICIPATION_REPORT: "Participation Report",
            },
            method: {
                email: "Email",
                sms: "SMS",
                document: "Document",
                whatsapp: "WhatsApp",
                viber: "Viber",
                messenger: "Facebook Messenger",
            },
            import: {
                title: "Import Templates",
                subtitle: "Import templates data",
                paragraph: "Import templates using a spreadsheet file in Comma Separated Values (CSV) format. Download an example import CSV file here.",
            },
        },
        materials: {
            audioInstructions: {
                screenLabel: "Audio instructions for screen",
                languageLabel: "Language of the recording",
                none: "Not audio instructions",
                helperText: "Voters hear this file when they ask for the instructions on that screen.",
                screens: {
                    "election-chooser": "Election list",
                    "start": "Start",
                    "ballot": "Ballot",
                    "review": "Review",
                    "confirmation": "Confirmation",
                    "audit": "Audit",
                    "ballot-locator": "Ballot locator",
                    "support-materials": "Support materials",
                },
            },
            createMaterialSuccess: "Support material created",
            createMaterialError: "Error creating support material",
            updateMaterialSuccess: "Support material updated",
            updateMaterialError: "Error updating support material",
            common: {
                title: "Support Material",
                subtitle: "Enter support material data.",
            },
            error: {
                title: "Title is required",
                document: "Document is required",
            },
            fields: {
                isHidden: "Is Hidden",
                publicUrl: "Public URL",
            },
            empty: {
                header: "No support material yet",
                action: "Generate support material  ",
            },
        },
        widget: {
            logs: "Logs",
        },
        settings: {
            countries: {
                title: "Country Blocking",
                votingDescription: "Choose below the countries you want to block voting from.",
                enrollmentDescription: "Choose below the countries you want to block enrollment from.",
                error: {
                    errorSaving: "Error saving the country list",
                },
            },
            backupRestore: {
                title: "Backup / Restore Tenant config",
                backup: {
                    label: "Backup",
                    subtitle: "Backup Tenant configurations",
                },
                restore: {
                    label: "Restore",
                    subtitle: "Restore Tenant config",
                    title: "Import Tenant Configurations",
                    paragraph: "Import tenant configurations, Keycloak configurations, roles & permissions data using zip folder",
                    tenantConfigOption: "Import Tenant Configurations",
                    keycloakConfigOption: "Import Keycloak Configurations",
                    RolesConfigOption: "Import Roles & Permissions Configurations",
                },
            },
            previewScreen: {
                label: "Previews",
                noContent: "No Previews found",
                table: {
                    title: "External Previews",
                    description: "A record of ballot style previews generated via external requests",
                    requestedBy: "Requested By",
                    document: "Document",
                    url: "URL",
                },
            },
            languages: {
                logsTimezone: "Timezone for tenant logs",
                default: "Default Language",
            },
        },
        approvalsScreen: {
            column: {
                status: "Status",
                id: "Application ID",
                applicantId: "Applicant ID",
                verificationType: "Verification",
                createdAt: "Applied",
                verified_by: "Verified by",
                voter: "Voter",
                what: "What happened",
                post: "Post",
                when: "When",
            },
            status: {
                PENDING: "Needs review",
                ACCEPTED: "Approved",
                REJECTED: "Rejected",
            },
            verification: {
                AUTOMATIC: "Automatic",
                MANUAL: "Manual",
            },
            time: {
                minutes_one: "{{count}} minute",
                minutes_other: "{{count}} minutes",
                hours_one: "{{count}} hour",
                hours_other: "{{count}} hours",
                days_one: "{{count}} day",
                days_other: "{{count}} days",
            },
            summary: {
                join: "{{head}} and {{last}}",
                differs_one: "{{fields}} differs from the registry",
                differs_other: "{{fields}} differ from the registry",
                typedByHand: "Details typed by hand, not read from an ID scan",
                needsFaceToFace: "Needs a face-to-face check",
                scanVerified: "ID scan verified",
                noVoter: "No voter found in the registry",
                allMatch: "All details match the registry",
                needsReview: "Waiting for a person to decide",
                approvedBy: "Approved by {{name}}",
                approvedAuto: "Approved automatically",
                rejectedBy: "Rejected by {{name}}",
                rejectedAuto: "Rejected automatically",
            },
            list: {
                title: "Approvals",
                subtitle: "Enrollments the rules can't decide on their own wait here for a person.",
                search: "Search",
                review: "Review enrollment",
                openRecord: "Open enrollment",
                seeRule: "See the rule that decided",
                unnamed: "Unnamed applicant",
                waiting: "Waiting {{time}}",
                applied: "Applied {{date}}",
                empty: {
                    title: "Nothing here",
                    text: "Enrollments with this status will appear here. Try another search or status.",
                },
                searchHelp: "A name, email or ID number, or the support reference the voter was given, such as Q5KW-8RFX.",
                referenceError: "The support reference could not be looked up.",
            },
            flow: {
                stepsLabel: "Review steps",
                steps: {
                    identity: "Check the identity",
                    voter: "Find the voter",
                    decide: "Decide",
                },
                continue: "Continue",
                backToList: "Back to Approvals",
                identity: {
                    details: "Details on the enrollment",
                    confirm: "I checked the voter's ID in person or by video call, and it matches this enrollment.",
                    checked: "Face-to-face check confirmed",
                    notChecked: "Face-to-face check not confirmed yet",
                },
                voter: {
                    none: "None of these is the voter",
                    noneHint: "The enrollment can then only be rejected, for no matching voter.",
                    noneChosen: "None of these is the voter",
                    notChosen: "No voter chosen yet",
                },
                decide: {
                    approve: "Approve",
                    reject: "Reject",
                    approveText: "Link this enrollment to {{voter}} in the registry. The voter is told by email or text message and can sign in to vote when voting opens.",
                    rejectText: "The voter is told why. This can't be undone.",
                    chooseVoter: "Choose the matching voter in step 2 to approve.",
                    noVoter: "You found no matching voter, so this enrollment can only be rejected.",
                    enrolled: "The chosen voter is already enrolled.",
                    faceToFace: "Confirm the face-to-face check in step 1 to approve.",
                },
            },
            review: {
                loadError: "The enrollment could not be loaded.",
                applied: "Applied {{date}}",
                waiting: "Waiting {{time}}",
                whyTitle: "Why this needs a person",
                decisionTitle: "How this was decided",
                rule: "Rule {{rule}} of matrix version {{version}}",
                ruleLast: "Last rule of matrix version {{version}}",
                seeRule: "See the rule",
                why: {
                    typedByHand: "The voter typed their details by hand instead of scanning an ID. Enrollments like this are never approved automatically: an officer confirms who they are first.",
                    differs_one: "One detail doesn't match the registry: {{details}}. The approval rules ask a person to check this enrollment.",
                    differs_other: "{{count}} details don't match the registry: {{details}}. The approval rules ask a person to check this enrollment.",
                    differsFields_one: "One detail doesn't match the registry: the {{fields}}. The approval rules ask a person to check this enrollment.",
                    differsFields_other: "{{count}} details don't match the registry: the {{fields}}. The approval rules ask a person to check this enrollment.",
                    difference: "the {{field}} is “{{enrollment}}” on the enrollment and “{{registry}}” in the registry",
                    noVoter: "No voter in the registry has these details. The approval rules ask a person to check this enrollment.",
                    severalVoters: "More than one voter in the registry fits this enrollment. A person chooses the right one.",
                    pending: "The approval rules ask a person to check this enrollment.",
                    unknown: "This enrollment is waiting for a person to decide.",
                    approvedAuto: "The approval rules approved this enrollment automatically. Every check they require passed.",
                    approvedBy: "{{name}} approved this enrollment on {{date}}.",
                    rejectedAuto: "The approval rules rejected this enrollment automatically: {{reason}}.",
                    rejectedBy: "{{name}} rejected this enrollment on {{date}}: {{reason}}.",
                },
                registryHelp: "We looked for voters with the same {{fields}}. Choose the one this enrollment belongs to.",
                registrySearching: "These are the voters in the registry that match your search. Choose the one this enrollment belongs to.",
                registrySearch: "Not in the list? Search the registry by name or email",
                registryLoading: "Looking in the registry",
                registryError: "The registry could not be searched.",
                noCandidates: "No voter in the registry matches. Try searching by name or email.",
                candidates: "Voters in the registry",
                alreadyEnrolled: "Already enrolled",
                bestMatch: "Best match",
                detailsMatch: "{{count}} of {{total}} details match",
                compareTitle: "Compared with {{name}} in the registry",
                col: {
                    detail: "Detail",
                    enrollment: "On the enrollment",
                    registry: "In the registry",
                    result: "Result",
                },
                same: "Same",
                differs: "Different",
                compareNote: "Names ignore capital letters, accents and hyphens.",
                compareJoint: "For driver's licenses and seafarer's books, first and middle name are compared together.",
                applicationId: "Application ID",
                copy: "Copy",
                copied: "Copied",
                approve: "Approve enrollment",
                approveDialog: {
                    title: "Approve {{name}}?",
                    body: "This links the enrollment to the registry voter below. The voter is told by email or text message and can sign in to vote when voting opens.",
                    checked: "You checked the voter's ID face to face.",
                    irreversible: "This can't be undone.",
                    confirm: "Approve",
                },
                reject: "Reject enrollment",
            },
            idCheck: {
                title: "ID check",
                method: {
                    VERIFIED: "ID scan verified",
                    MANUAL_ENTRY: "Typed by hand",
                    UNKNOWN: "Not reported",
                },
                verified: "The enrollment flow verified the voter's ID",
                typedByHand: "The voter typed their details by hand",
                unknown: "The enrollment flow didn't report how the identity was checked",
                faceToFaceTitle: "Check them face to face before approving",
                faceToFaceText: "Meet the voter in person or by video call and compare their ID with the details on this page.",
            },
            reject: {
                rejectReason: "Reason for rejecting",
                message: "Message to the voter",
                messageRequired: "Write a message for the voter when the reason is Other.",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Missing data",
                    "no-matching-voter": "No matching voter",
                    "voter-already-approved": "Already approved",
                    "EMAIL_IN_USE": "Email used by another voter",
                    "other": "Other",
                },
                hint: {
                    "insufficient-information": "Details are missing or can't be read.",
                    "no-matching-voter": "The person isn't in the voter registry.",
                    "voter-already-approved": "This voter is already enrolled.",
                    "other": "Write your own message.",
                },
                preview: {
                    "insufficient-information": "We couldn't enroll you because some of your details are missing or can't be read. Please enroll again with complete details.",
                    "no-matching-voter": "We couldn't find a voter in the registry that matches your details. Check your details and enroll again, or contact your election office.",
                    "voter-already-approved": "You are already enrolled. You can sign in to vote when voting opens.",
                },
                previewTitle: "The voter will see",
            },
            notifications: {
                approveError: "The enrollment could not be approved",
                approveSuccess: "{{name}} approved. The voter has been told.",
                rejectError: "The enrollment could not be rejected",
                rejectSuccess: "{{name}} rejected. The voter has been told.",
                VoterApprovedAlready: "This voter is already enrolled.",
            },
            export: {
                success: "Applications export finished successfully",
                error: "Error exporting applications",
            },
            matrix: {
                button: "Approval matrix",
                title: "Approval matrix",
                back: "Approvals",
                subtitle: "Rules decide what happens to each enrollment. The first rule that fits decides.",
                versionChip: "Version {{version}}",
                savedBy: "Saved {{date}} by {{user}}",
                builtIn: "Built-in rules, used until a version is saved",
                unsaved: "Unsaved changes",
                viewOnly: "View only",
                readOnlyTitle: "You can see the rules but not change them",
                readOnlyText: "Ask an administrator who has the approval-matrix-write permission to make changes.",
                loadError: "The approval matrix could not be loaded.",
                compared: "What we compare",
                comparedHelp: "Each enrollment is compared with the voter found in the registry. Names ignore capital letters, accents and hyphens; for driver's licenses and seafarer's books, first and middle name are compared together.",
                addCompared: "Compare another detail",
                rules: "Rules",
                rulesHelp: "Rules are checked from the top. The first one that fits decides; if none fits, the last rule applies.",
                when: "When",
                then: "Then",
                otherwise: "Otherwise",
                noneApply: "None of the rules above apply",
                andWord: "and",
                and: " and ",
                appliesToExample: "Applies to your example",
                cameFrom: "Decided the enrollment you came from",
                voterIsTold: "The voter is told: “{{reason}}”.",
                sentence: "When {{when}}, {{outcome}}.",
                sentenceOtherwise: "If none of the rules above apply, {{outcome}}.",
                sentenceEmpty: "Add a condition to say when this rule applies.",
                addRule: "Add rule",
                discard: "Discard changes",
                actions: {
                    edit: "Edit rule {{number}}",
                    editOtherwise: "Edit the last rule",
                    moveUp: "Move rule {{number}} up",
                    moveDown: "Move rule {{number}} down",
                    delete: "Delete rule {{number}}",
                },
                saveBar: {
                    title: "You have unsaved changes",
                    fix_one: "Fix 1 rule before saving",
                    fix_other: "Fix {{count}} rules before saving",
                    more: "+{{count}} more",
                },
                test: "Try an example",
                testHelp: "Describe an enrollment to see which rule decides it. Your unsaved changes count.",
                testDetails: "Details compared",
                applies: "Rule {{number}} applies",
                otherwiseApplies: "The last rule applies",
                testError: "The example could not be tried.",
                testInvalid: "Fix these rules to try an example:",
                ruleError: "Rule {{number}}: {{error}}",
                invariants: {
                    MANUAL_ENTRY_NOT_ACCEPTED: "A typed identity is never approved automatically, so this goes to a person.",
                    ALREADY_ENROLLED_NOT_ACCEPTED: "A voter who is already enrolled is never approved again.",
                    NO_VOTER_NOT_ACCEPTED: "Nobody is approved without a voter in the registry.",
                    OTHERWISE_NOT_ACCEPTED: "The last rule never approves.",
                },
                dialog: {
                    editTitle: "Edit rule {{number}}",
                    newTitle: "New rule",
                    otherwiseTitle: "Edit the last rule",
                    summary: "In short",
                    whenHelp: "All of these must be true. Leave a condition out when it doesn't matter.",
                    otherwiseHelp: "If none of the rules above apply",
                    addCondition: "Add condition",
                    remove: "Remove “{{condition}}”",
                    identity: "Identity check",
                    voterFound: "Voter in the registry",
                    alreadyEnrolled: "Already enrolled",
                    validId: "ID type",
                    differing: "Details that differ",
                    decision: "Decision",
                    reason: "What the voter is told",
                    voterSees: "The voter sees",
                    apply: "Apply",
                    close: "Close",
                    yes: "Yes",
                    no: "No",
                    notReported: "Not reported",
                },
                identity: {
                    VERIFIED: "Verified by ID scan",
                    MANUAL_ENTRY: "Typed by hand",
                },
                differing: {
                    none: "None",
                    exactly_1: "Exactly 1",
                    at_most_1: "At most 1",
                    exactly_2: "Exactly 2",
                    at_most_2: "At most 2",
                    at_least_3: "3 or more",
                },
                fieldMatch: {
                    MATCHES: "Same",
                    DIFFERS: "Different",
                },
                decisions: {
                    ACCEPTED: "Approve automatically",
                    PENDING: "Send to a person",
                    REJECTED: "Reject",
                },
                outcomeShort: {
                    ACCEPTED: "approve automatically",
                    PENDING: "send to a person",
                    REJECTED: "reject",
                },
                outcomeHelp: {
                    ACCEPTED: "The voter is enrolled without anyone looking at it.",
                    PENDING: "An officer decides, and the voter is told the enrollment is under review.",
                    REJECTED: "The voter is told why, and can enroll again.",
                },
                outcomeSentence: {
                    ACCEPTED: "approve the enrollment automatically",
                    PENDING: "send the enrollment to a person",
                    REJECTED: "reject the enrollment",
                },
                reasons: {
                    NO_VOTER: "No matching voter",
                    ALREADY_APPROVED: "Already approved",
                    INSUFFICIENT_INFORMATION: "Missing data",
                    IDENTITY_NOT_VERIFIED: "Identity not verified",
                    OTHER: "Other",
                },
                voterText: {
                    NO_VOTER: "We couldn't find a voter in the registry that matches your details. Check your details and enroll again, or contact your election office.",
                    ALREADY_APPROVED: "You are already enrolled. You can sign in to vote when voting opens.",
                    INSUFFICIENT_INFORMATION: "We couldn't enroll you because some of your details are missing or can't be read. Please enroll again with complete details.",
                    IDENTITY_NOT_VERIFIED: "We could not verify your identity automatically, so an election officer will review your enrollment.",
                    OTHER: "An election officer writes this message when they decide.",
                },
                conditions: {
                    any: "No conditions yet",
                    identity: {
                        VERIFIED: "Identity verified by ID scan",
                        MANUAL_ENTRY: "Identity typed by hand",
                    },
                    voterFound: {
                        true: "Voter found in the registry",
                        false: "No voter found in the registry",
                    },
                    alreadyEnrolled: {
                        true: "Already enrolled",
                        false: "Not enrolled yet",
                    },
                    validId: "ID: {{id}}",
                    differing: {
                        none: "All details match",
                        exactly_1: "Exactly 1 detail differs",
                        at_most_1: "At most 1 detail differs",
                        exactly_2: "Exactly 2 details differ",
                        at_most_2: "At most 2 details differ",
                        at_least_3: "3 or more details differ",
                    },
                    field: {
                        MATCHES: "{{field}} matches",
                        DIFFERS: "{{field}} differs",
                    },
                },
                errors: {
                    ACCEPTS_MANUAL_ENTRY: "Enrollments whose identity was typed by hand can't be approved automatically.",
                    ACCEPTS_ALREADY_ENROLLED: "A voter who is already enrolled can't be approved again.",
                    ACCEPTS_WITHOUT_VOTER: "An enrollment can't be approved without a voter in the registry.",
                    OTHERWISE_ACCEPTS: "The last rule can send enrollments to a person or reject them, but not approve them.",
                    MISSING_REASON: "Choose what the voter is told.",
                    UNEXPECTED_REASON: "An approval has no reason.",
                    NO_COMPARED_FIELDS: "Choose at least one detail to compare with the registry.",
                    DUPLICATE_COMPARED_FIELD: "A compared detail is repeated.",
                    UNKNOWN_FIELD: "A rule uses a detail that is not compared.",
                    NO_CONDITIONS: "Add at least one condition. Only the last rule applies to everything else.",
                },
                change: {
                    added: "Rule {{number}} added",
                    decision: "Rule {{number}}: {{from}} → {{to}}",
                    edited: "Rule {{number}} changed",
                    removed: "A rule was removed ({{text}})",
                    moved: "Rules were reordered",
                    otherwise: "The last rule changed",
                    compared: "The details compared changed",
                },
                save: {
                    button: "Save as version {{version}}",
                    title: "Save as version {{version}}?",
                    body: "New enrollments are decided with these rules from now on. Enrollments already decided keep their decision.",
                    changes: "What changed",
                    log: "The new version is recorded in the electoral log.",
                    confirm: "Save version {{version}}",
                    success: "Saved as version {{version}}",
                    error: "The approval matrix could not be saved",
                },
            },
        },
        monitoring: {
            configuredDashboards: "Configurable dashboards",
            modeChangeError: "Could not change the dashboard mode. Try again.",
            title: "Monitoring",
            loading: "Loading monitoring",
            unavailableAlert: "Monitoring dashboards could not be loaded, so the standard dashboard is shown.",
            noDashboards: "This event has no monitoring dashboards.",
            dashboardFailed: "The monitoring dashboard could not be loaded.",
            dashboardInvalid: "This dashboard cannot be shown: {{problem}}",
            retry: "Retry",
            errors: {
                busy: "The server is busy. It is tried again in a few seconds.",
                forbiddenScope: "You may not see this region, Post or country. Choose another one.",
                snapshotPruned: "The update shown is no longer kept. The dashboard now shows the latest update: export again to use it.",
                checksUnavailable: "The chart service is not available right now. Try again later.",
                lockedDown: "The election event is locked down, so this cannot be changed.",
                notFound: "This dashboard or widget is no longer configured. Reload the page.",
                badRequest: "The request was not accepted. Reload the page and try again.",
                conflict: "Someone else saved a change first. Reload and try again.",
                invalid: "Some of the export's values are not accepted.",
                unknown: "Something went wrong. Try again later.",
            },
            header: {
                dashboard: "Dashboard",
                updated: "Updated {{time}} ({{timeZone}})",
                notUpdated: "Not counted yet",
                refresh: "every {{seconds}} s",
                export: "Export",
                editDashboard: "Edit dashboard",
                preset: "Dashboard preset",
                reload: "Check for new figures",
            },
            footer: {
                dataThrough: "Data through {{time}} ({{timeZone}})",
            },
            selectors: {
                region: "Region",
                post: "Post",
                country: "Country",
                allRegions: "All regions",
                allPosts: "All Posts",
                allAuthorizedPosts: "All authorized Posts",
                allCountries: "All countries",
                authorizedOnly: "{{all}} (authorized)",
            },
            widget: {
                menu: "Actions for {{widget}}",
                configure: "Configure widget",
                viewData: "View data",
                export: "Export",
                duplicate: "Duplicate",
                loading: "Loading {{widget}}",
                missing: "The dashboard names a widget that does not exist: {{id}}",
                updating: "Updating {{widget}}",
                updatingNote: "Updating: the chart shown is the previous one.",
            },
            frame: {
                title: "{{widget}} chart",
            },
            sources: {
                voter_turnout: "Voter turnout",
                test_voting: "Test voting",
                enrollment_decisions: "Enrollment decisions",
                voting_credentials: "Voting credentials",
                poll_status: "Poll status",
                final_testing_lockdown: "Final testing and lockdown",
                counting_transmission: "Counting and transmission",
                voting_enrollment_activity: "Voting and enrollment activity",
                access_security: "Access and security",
                attack_detections: "Attack detections",
                helpdesk: "Helpdesk",
            },
            reasons: {
                TEST_ELECTION_DESIGNATION: "test elections cannot be marked yet",
                CREDENTIAL_ISSUED_EVENT: "issuing credentials is not recorded yet",
                FINAL_TESTING_LOCKDOWN_STATE: "final testing and lockdown are not recorded yet",
                ATTACK_DETECTION_FEED: "no attack detection feed is connected",
                HELPDESK_INTEGRATION: "no helpdesk system is connected",
            },
            notices: {
                UNREGISTERED_ATTEMPTS_AT_EVENT_SCOPE_ONLY: "Attempts by unregistered usernames belong to no Post, so they are counted for the whole event only.",
                UNREGISTERED_ATTEMPTS_EXCLUDED: "These figures leave out attempts by unregistered usernames; they are counted for the whole event.",
                CREDENTIALS_ISSUED_WHEN_PASSWORD_SET: "Credentials count as issued when the voter's password is set, until the platform records their issue.",
                CONFIG_NEWER_THAN_SNAPSHOT: "Drawn with the latest settings; the figures are counted with them in the next pass.",
                CONFIG_AT_SNAPSHOT_UNAVAILABLE: "Drawn with the current settings: those the figures were counted under are no longer kept.",
            },
            unavailable: {
                notConnected: "Not connected · {{reason}}",
                notConnectedHelp: "Nothing is shown until it is.",
                unknownReason: "data source not available",
                noSnapshot: "Not counted yet",
                noSnapshotHelp: "The first count has not finished. This widget updates on its own.",
                scopePending: "Counting this selection",
                scopePendingHelp: "This selection is counted in the next pass, within about a minute.",
                settingsPending: "Counting with the new settings…",
                settingsPendingHelp: "The figures are counted again with the saved settings, within about a minute.",
                renderFailed: "The chart could not be drawn",
                renderFailedHelp: "The figures are shown instead.",
                invalid: "This widget cannot be shown",
                invalidHelp: "Its configuration has a problem.",
                requestFailed: "This widget could not be loaded",
                requestFailedHelp: "It is tried again when the dashboard updates.",
            },
            dataTable: {
                title: "{{widget}} · data",
                close: "Close",
                empty: "No rows",
                rowsPerPage: "Rows per page:",
                shownRows: "{{from}}–{{to}} of {{total}}",
                firstPage: "First page",
                previousPage: "Previous page",
                nextPage: "Next page",
                lastPage: "Last page",
            },
            columns: {
                numerator: "Numerator",
                denominator: "Denominator",
                pct: "Percentage",
                pct_label: "Percentage as shown",
                group: "Group",
                group_key: "Group key",
                post: "Post",
                post_id: "Post ID",
                region: "Region",
                country: "Country",
                reason: "Reason",
                category: "Category",
                state: "State",
                state_label: "State as shown",
                bucket_start: "Period start",
                bucket_label: "Period",
                bucket_utc: "Period start (UTC)",
                measure: "Measure",
                label: "Label",
                value: "Value",
            },
            measures: {
                registered: "Registered",
                pre_enrolled: "Pre-enrolled",
                credentials_issued: "Credentials issued",
                test_voted: "Test voted",
                voted: "Voted",
                voted_pre_enrolled: "Pre-enrolled and voted",
                applications: "Applications",
                pending: "Pending",
                approved: "Approved",
                disapproved: "Disapproved",
                posts: "Posts",
                initialized: "Initialized",
                opened: "Opened",
                paused: "Paused",
                closed: "Closed",
                tested: "Tested",
                locked_down: "Locked down",
                tallied: "Tallied",
                transmitted: "Transmitted",
                transmission_failed: "Transmission failed",
                logins: "Logins",
                login_failures: "Login failures",
                login_failures_valid_user: "Failed, valid user",
                login_failures_unregistered: "Failed, unregistered user",
                password_resets: "Password resets",
                password_reset_requests: "Password reset requests",
                detections: "Detections",
                issues: "Issues",
                pending_issues: "Pending issues",
            },
            export: {
                title: "Export monitoring data",
                format: "Format",
                csv: "CSV",
                sql: "SQL",
                from: "From",
                to: "To",
                timeZoneHelp: "Times are in {{timeZone}}. Totals, statuses and groups are as of the shown update; only the rows of activity series are limited to the range, from the start time up to, but not including, the end time.",
                cancel: "Cancel",
                export: "Export",
                invalidRange: "The end must be after the start.",
                problems: {
                    unknownSelector: "{{widget}} no longer has the choice “{{selector}}”. Reload the dashboard and export again.",
                    unknownOption: "The value chosen for “{{selector}}” in {{widget}} is no longer offered. Choose it again and export.",
                },
            },
            editor: {
                scopeSelector: {
                    region: "Region",
                    post: "Post",
                    country: "Country",
                },
                sources: {
                    voter_turnout: "Voter turnout",
                    test_voting: "Test voting",
                    enrollment_decisions: "Enrollment decisions",
                    voting_credentials: "Voting credentials",
                    poll_status: "Poll status",
                    final_testing_lockdown: "Final testing and lockdown",
                    counting_transmission: "Counting and transmission",
                    voting_enrollment_activity: "Voting and enrollment activity",
                    access_security: "Access and security",
                    attack_detections: "Attack detections",
                    helpdesk: "Helpdesk",
                },
                templates: {
                    summary: "Summary",
                    by_group: "By group",
                    by_post: "By Post",
                    timeseries: "Over time",
                    by_measure: "By measure",
                },
                yaml: {
                    label: "YAML",
                    readOnly: "The YAML has a syntax error. Fix it in the YAML tab to use the forms again.",
                },
                diagnostics: {
                    title: "Checks",
                    none: "No problems found",
                    localUnavailable: "Checks in the browser are unavailable; problems appear after the preview or Validate.",
                    line: "Line {{line}}",
                    engineCode: "dbt Charts {{code}}",
                    severity: {
                        ERROR: "Error",
                        WARNING: "Warning",
                    },
                    origin: {
                        SYNTAX: "YAML syntax",
                        LOCAL: "Browser check",
                        SERVER: "Server check",
                    },
                },
                footer: {
                    preview: "Preview",
                    valid: "Valid",
                    errors_one: "{{count}} error",
                    errors_other: "{{count}} errors",
                    noWarnings: "no chart warnings",
                    warnings_one: "{{count}} chart warning",
                    warnings_other: "{{count}} chart warnings",
                    rendering: "Rendering…",
                    previewFailed: "preview failed",
                    renderedIn: "rendered in {{ms}} ms",
                    revision: "Revision {{revision}}",
                    savedBy: "saved {{date}} by {{user}}",
                    unknownUser: "an administrator",
                    notSaved: "not saved yet",
                    unsaved: "unsaved changes",
                    cancel: "Cancel",
                    validate: "Validate",
                },
                preview: {
                    title: "Preview",
                    empty: "The preview appears once the YAML is valid.",
                    failed: "The preview could not be rendered: {{reason}}",
                    notConnectedTail: "Nothing is shown until it is.",
                    queryResult: "Query result · first rows",
                    noRows: "The query returned no rows.",
                    state: {
                        RENDERED: "Rendered",
                        NOT_CONNECTED: "Not connected",
                        NO_SNAPSHOT: "No data yet",
                        SCOPE_PENDING: "This scope is being counted",
                        RENDER_FAILED: "The chart could not be drawn",
                        INVALID: "The configuration is invalid",
                    },
                },
                configureWidget: {
                    title: "Configure widget",
                    tabs: {
                        dataQuery: "Data & query",
                        selectors: "Selectors",
                        yaml: "YAML",
                        preview: "Preview",
                    },
                    save: "Save widget",
                    loading: "Loading the widget…",
                    loadFailed: "The widget could not be loaded: {{reason}}",
                    saved: "Widget saved as revision {{revision}}",
                    refused: "The widget was not saved: fix the problems listed.",
                    validated: "The widget is valid.",
                    invalid: "The widget has problems: see the checks.",
                    requestFailed: "The request failed: {{reason}}",
                    discardTitle: "Discard changes?",
                    discardBody: "Your changes to this widget have not been saved.",
                    discard: "Discard",
                    keepEditing: "Keep editing",
                },
                dataQuery: {
                    title: "Title",
                    source: "Data source",
                    template: "Query",
                    measures: "Measures",
                    ratio: "Numerator / denominator",
                    numerator: "Numerator",
                    denominator: "Denominator",
                    groupBy: "Group by",
                    sort: "Sort",
                    sortOrder: "Order",
                    templateOrder: "The query's own order",
                    sortBy: {
                        label: "Label",
                        value: "Value",
                        ratio: "Ratio",
                    },
                    order: {
                        asc: "Ascending",
                        desc: "Descending",
                    },
                    limit: "Rows",
                    noLimit: "All",
                    none: "None",
                    fromSelector: "From selector: {{name}}",
                    follow: "Follow dashboard selectors",
                    followHelp: "A selector left unticked does not narrow this widget.",
                    manyQueries: "This widget has several queries; edit them in the YAML tab.",
                    notConnected: "Not connected · {{reason}}",
                    sourceHelp: {
                        DISTINCT_VOTERS: "Counts distinct voters; counting rules are fixed by the data source.",
                        DISTINCT_PRE_ENROLLED_VOTERS: "Counts distinct pre-enrolled voters; counting rules are fixed by the data source.",
                        LATEST_DECISION_PER_VOTER: "Counts the latest decision per voter; counting rules are fixed by the data source.",
                        APPROVED_VOTERS: "Counts approved voters; counting rules are fixed by the data source.",
                        POSTS_IN_SCOPE: "Counts the Posts in scope; counting rules are fixed by the data source.",
                        FIRST_EVENT_PER_VOTER: "Counts each voter's first valid vote or approval; counting rules are fixed by the data source.",
                        ATTEMPTS: "Counts attempts, not people; counting rules are fixed by the data source.",
                        DETECTIONS: "Counts detections; counting rules are fixed by the data source.",
                        REPORTED_ISSUES: "Counts reported issues; counting rules are fixed by the data source.",
                        default: "Counting rules are fixed by the data source.",
                    },
                },
                selectors: {
                    help: "Selectors appear in the widget header. Their values feed the query; dashboard selectors (Region, Post, Country) apply to every widget.",
                    name: "Name",
                    label: "Label",
                    control: "Control",
                    controls: {
                        dropdown: "Dropdown",
                        toggle: "Toggle",
                    },
                    default: "Default",
                    optionValue: "Value",
                    optionLabel: "Option label",
                    addOption: "Add option",
                    addSelector: "Add selector",
                    removeOption: "Remove option {{option}}",
                    removeSelector: "Remove selector {{name}}",
                    moveUp: "Move {{name}} up",
                    moveDown: "Move {{name}} down",
                    dynamic: "Options come from the data ({{source}}).",
                    none: "This widget has no selectors.",
                    newLabel: "New selector",
                    newOption: "New option",
                    shownWhen: "Shown when {{selector}} is {{values}}",
                },
                conflict: {
                    title: "Someone saved first",
                    body: "{{user}} saved revision {{revision}} ({{date}}) while you were editing.",
                    bodyShort: "Revision {{revision}} was saved while you were editing.",
                    saved: "Saved revision",
                    mine: "My changes",
                    reload: "Reload",
                    copy: "Copy my YAML",
                    copied: "Your YAML is on the clipboard.",
                    copyFailed: "The clipboard is unavailable; select the YAML and copy it by hand.",
                    keepEditing: "Keep editing",
                    removed: "The document was removed while you were editing. Keep editing to save it again.",
                },
                dashboard: {
                    editing: "Editing dashboard",
                    title: "Title",
                    selectors: "Dashboard selectors",
                    theme: "Theme",
                    editTheme: "Edit theme",
                    addWidget: "Add widget",
                    cancel: "Cancel",
                    save: "Save dashboard",
                    width: "Width",
                    widthValue: "{{n}} of 12",
                    moveUp: "Move up",
                    moveDown: "Move down",
                    remove: "Remove",
                    duplicate: "Duplicate",
                    configure: "Configure widget",
                    empty: "This dashboard has no widgets yet.",
                    saved: "Dashboard saved as revision {{revision}}",
                    refused: "The dashboard was not saved: fix the problems listed.",
                    requestFailed: "The request failed: {{reason}}",
                    dragHandle: "Drag to reorder {{title}}",
                    widgets: "Widgets",
                    duplicated: "Duplicated as {{id}}",
                    resetToPreset: "Reset to preset",
                    actions: "Actions for {{title}}",
                    discardBody: "Your changes to this dashboard have not been saved.",
                    duplicateInvalid: "The copy was not saved: {{problem}}",
                    layoutMalformed: "Some layout items are not a widget with a width. Fix them in the YAML tab to reorder the widgets.",
                },
                catalog: {
                    title: "Add widget",
                    search: "Search widgets, data sources or requirements",
                    add: "Add",
                    empty: "No widget matches.",
                    onDashboard: "On this dashboard",
                    close: "Close",
                },
                theme: {
                    title: "Dashboard theme",
                    subtitle: "dbt Charts style applied to every widget on this dashboard",
                    appliesTo_one: "applies to {{count}} widget",
                    appliesTo_other: "applies to {{count}} widgets",
                    apply: "Apply theme",
                    saved: "Theme saved as revision {{revision}}",
                    discardBody: "Your changes to this theme have not been saved.",
                },
                reset: {
                    title: "Reset to preset",
                    body: "Every dashboard, widget and theme of this event is replaced by the preset's. The current configuration stays in the history.",
                    preset: "Preset",
                    confirm: "Reset",
                    cancel: "Cancel",
                    done: "The event now uses {{title}}.",
                    failed: "The reset failed: {{reason}}",
                    noPresets: "No presets are available.",
                    loading: "Loading presets…",
                },
                lockedDown: "The event is locked down; its monitoring configuration cannot change.",
                document: {
                    loadFailed: "The document could not be loaded: {{reason}}",
                    refused: "Not saved: fix the problems listed.",
                    validated: "The document is valid.",
                    invalid: "The document has problems: see the checks.",
                    requestFailed: "The request failed: {{reason}}",
                    savedWithWarnings_one: "{{count}} warning: see the checks.",
                    savedWithWarnings_other: "{{count}} warnings: see the checks.",
                },
                errors: {
                    checksUnavailable: "The chart engine could not check the change, so it was not saved. Try again in a moment.",
                    busy: "Other changes to this event are being saved. Try again in a moment.",
                    lockedDown: "The event is locked down; its monitoring configuration cannot change.",
                    forbiddenScope: "You cannot see figures for the chosen region, Post or country.",
                    badRequest: "The editor sent a request the server could not read. Reload the page and try again.",
                },
                duplicate: {
                    copyTitle: "{{title}} (copy)",
                    done: "Added {{id}}, a copy of the widget, to the dashboard.",
                    failed: "The widget could not be duplicated: {{reason}}",
                    notPlaced: "The copy {{id}} was saved, but the dashboard did not take it ({{reason}}). Add it with Edit dashboard.",
                },
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Voters",
                enrolledOverseasVoters: "Enrolled Overseas Voters",
                approvalStatus: "Approval Status: Approved/Disapproved Voters",
                manuallyApproval: "Manually Approved/Disapproved Voters",
                automaticallyApproval: "Automatically Approved/Disapproved Voters",
                authenticatedVoters: "Authenticated Voters",
                invalidUserErrors: "Invalid User Errors:",
                invalidPasswordErrors: "Invalid Password Errors:",
            },
            polls: {
                title: "Polls",
                initializedSystems: "Posts with Initialized Systems",
                votingOpened: "Posts with Online Voting Opened",
                votingClosed: "Posts with Both Voting Channels Closed",
                votingStarted: "Posts with Voting Started",
                voterTurnout: "Voter Turnout",
            },
            tally: {
                title: "Tally",
                activeVotesCounting: "Posts with Active Vote Counting",
                generatedERs: "Posts with Generated ERs",
                transmittedResults: "Posts with Transmitted Results",
            },
            testing: {
                title: "Testing",
                testElectionVoterCount: "Test Election Voter Count",
            },
        },
        certificateAuthorities: {
            title: "Certificates",
            subtitle: "Certificate Authorities (CAs) trusted for this election event. Imported CAs are used to validate voter certificates.",
            importButton: "Import Certificates",
            type: {
                root: "Root",
                intermediate: "Intermediate",
            },
            expiry: {
                expired: "Expired",
                expiringSoon: "Expiring soon",
                valid: "Valid",
            },
            columns: {
                commonName: "Common Name",
                type: "Type",
                issuerCn: "Issuer CN",
                notBefore: "Valid From",
                notAfter: "Expires",
                fingerprint: "SHA256 Fingerprint",
            },
            importDialog: {
                title: "Import Certificate Authorities",
                subtitle: "Import one or more CA certificates from a PEM file",
                description: "Select a PEM file containing one or more certificates. Bundles are supported — each certificate is imported individually.",
                selectFile: "Select PEM file",
                fileLoaded: "File loaded ({{bytes}} bytes)",
                importButton: "Import",
            },
            notify: {
                importSuccess: "Imported {{inserted}} certificate(s).",
                importSkipped: "{{count}} certificate(s) skipped (already present).",
                importErrors: "Import issues: {{errors}}",
                importError: "Import failed: {{error}}",
                deleteSuccess: "Certificate deleted.",
                deleteError: "Error deleting certificate.",
                exportSuccess: "Certificate(s) exported successfully.",
                exportError: "Error exporting certificates.",
            },
            exportDialog: {
                title: "Export Certificate Authorities",
                description: "You are about to export {{amount}} certificate(s).",
                all: "all",
            },
            deleteDialog: {
                description: "Are you sure you want to delete {{count}} certificate(s)?",
            },
            emptyHeader: "No certificate authorities have been imported for this election event.",
            fileReadError: "Failed to read the file.",
            viewDialog: {
                title: "Certificate Authority Details",
                subject: "Subject",
                issuer: "Issuer",
                serialNumber: "Serial Number",
                pemContent: "PEM Content",
            },
            confirmDelete: "Delete Certificate Authority",
            confirmDeleteDescription: 'Are you sure you want to delete the certificate "{{name}}" (fingerprint: {{fingerprint}})?',
        },
        signing: {
            terms: {
                post: "Post",
                posts: "Posts",
            },
            tab: {
                title: "Signatures",
                intro: "Protected actions run only after enough authorized people sign them with their digital certificates. Each signature is checked against the trusted issuers and recorded in the log.",
                protectedActions: "Protected actions",
                certificates: "Certificates",
                requests: "Requests",
            },
            loadError: "The signing settings couldn't be loaded. Reload the page to try again.",
            errors: {
                automatedCeremonies: "This event uses automatic key ceremonies. Trustees do not perform these steps, so their signatures cannot be required. To require trustee signatures, use manual key ceremonies.",
                forbidden: "You don't have the permission for this change.",
                invalid: "The server refused these values. Check them and try again.",
                conflict: "Someone else changed this meanwhile. Reload the page and try again.",
                lockedDown: "The election event is locked down: signing rules change only through a new configuration version.",
                notFound: "It no longer exists. Reload the page.",
            },
            readOnly: {
                chip: "Read only",
                rules: "Read only. Changing signing rules needs the permission “Signatures: edit protected actions”.",
                whoCanSign: "Roles with the permission “Sign: {{action}}” in Users and Roles. Changing them needs permission to edit roles.",
            },
            groups: {
                "voting": "Voting",
                "results-and-reports": "Results and reports",
                "enrollment": "Enrollment",
                "configuration-and-keys": "Configuration and keys",
            },
            actions: {
                "initialize-voting": {
                    label: "Initialize voting",
                    short: "Initialization",
                    permissionName: "initialize voting",
                    object: "initialization of voting",
                    appliesTo: "Each $t(signing.terms.post)",
                    description: "Started in Publish. Initializes the $t(signing.terms.post) and generates its Initialization Report.",
                },
                "open-voting": {
                    label: "Open voting",
                    short: "Opening",
                    permissionName: "open voting",
                    object: "opening of voting",
                    appliesTo: "Each $t(signing.terms.post)",
                    description: "Started in Publish with Start voting. Opens voting at the $t(signing.terms.post).",
                },
                "close-voting": {
                    label: "Close voting",
                    short: "Closing",
                    permissionName: "close voting",
                    object: "closing of voting",
                    appliesTo: "Each $t(signing.terms.post)",
                    description: "Started in Publish with Stop voting. Closes voting at the $t(signing.terms.post); the closing signatures are kept in its record.",
                    descriptionSealed: "Started in Publish with Stop voting. Closes voting at the $t(signing.terms.post). Once every channel is closed, its ballot boxes are sealed, after the grace period when there is one: no ballot can be added, changed or deleted, and voting can't start again. The closing signatures are kept in its record.",
                },
                "generate-election-returns": {
                    label: "Generate election returns",
                    short: "Election returns",
                    permissionName: "generate election returns",
                    object: "election returns",
                    appliesTo: "Each $t(signing.terms.post) and country",
                    description: "Started by the tally, one request per $t(signing.terms.post) and country. Releases the signed election returns for printing and transmission.",
                },
                "generate-reports": {
                    label: "Generate other election reports",
                    short: "Report",
                    permissionName: "generate other election reports",
                    object: "report",
                    appliesTo: "Each $t(signing.terms.post)",
                    description: "Started by the tally for the Initialization Report and in Reports for the participation report. Releases the signed report.",
                },
                "transmit-results": {
                    label: "Transmit results",
                    short: "Transmission",
                    permissionName: "transmit results",
                    object: "results package",
                    appliesTo: "Each $t(signing.terms.post) and country",
                    description: "Started in Tally, Transmission. Builds the signed results package for its destinations; the signatures fill its signature list.",
                },
                "approve-voter": {
                    label: "Approve a voter manually",
                    short: "Voter approval",
                    permissionName: "approve a voter manually",
                    object: "voter approval",
                    appliesTo: "The voter's $t(signing.terms.post)",
                    description: "Started in Approvals. Approves the voter and issues their credentials.",
                },
                "approve-configuration": {
                    label: "Approve a configuration version",
                    short: "Configuration version",
                    permissionName: "approve a configuration version",
                    object: "configuration version",
                    appliesTo: "The election event",
                    description: "Started in Publish. Publishes the configuration version.",
                },
                "key-ceremony": {
                    label: "Confirm custody (key ceremony)",
                    short: "Custody proof",
                    permissionName: "confirm custody",
                    object: "custody proof",
                    appliesTo: "Each trustee",
                    description: "Started in Keys by each trustee. Records the trustee's signature with the ceremony and the bulletin board.",
                },
                "tally-key": {
                    label: "Authorize tally custody (tally)",
                    short: "Tally custody proof",
                    permissionName: "authorize tally custody",
                    object: "tally custody proof",
                    appliesTo: "Each trustee",
                    description: "Started in Tally by each trustee. Records the trustee's contribution.",
                },
            },
            protectedActions: {
                intro: "Each signature is made with the digital certificate on the signer's security token.",
                columns: {
                    action: "Action",
                    appliesTo: "Applies to",
                    whoCanSign: "Who can sign",
                    signaturesNeeded: "Signatures needed",
                    requestExpires: "Request expires",
                    waiting: "Waiting",
                },
                off: "Off",
                eachTrustee: "Each trustee",
                footerVersion: "Signing rules are part of this event's configuration version {{version}}.",
                footerFirstVersion: "Signing rules become part of this event's first configuration version when it is published.",
                footerChanged: "Last changed {{date}}.",
                footerChangedBy: "Last changed {{date}} by {{name}}.",
                lockedDown: "The election event is locked down: its signing rules belong to its configuration version, so they change only through a new configuration version.",
                edit: "Edit {{action}}",
                view: "View {{action}}",
                waitingCount_one: "{{count}} request waiting",
                waitingCount_other: "{{count}} requests waiting",
                capacityError: "Who can sign couldn't be loaded, so the number of signatures can't be checked against the $t(signing.terms.posts).",
            },
            expiry: {
                "30": "30 minutes",
                "60": "1 hour",
                "120": "2 hours",
                "1440": "24 hours",
                "none": "No limit",
                "other": "{{count}} minutes",
            },
            rule: {
                needsSignatures: "Needs signatures",
                whoCanSign: "Who can sign",
                whoCanSignHelp: "These roles get the permission “Sign: {{action}}” in Users and Roles, for every election event. Signers must also have access to the $t(signing.terms.post).",
                signaturesNeeded: "Signatures needed",
                signaturesNeededHelp: "Each signer uses their digital certificate. Every $t(signing.terms.post) has at least {{n}} people who can sign.",
                signaturesNeededShortHelp: "Each signer uses their digital certificate.",
                requesterSigning: "The person who starts it can also sign",
                expiresAfter: "A request expires after",
                trusteesSign: "Trustees sign this step",
                trusteesHelp: "Each trustee signs their own step with their digital certificate. The key ceremony sets how many trustees take part.",
                footer: "Changes are recorded in the election event's log and become part of the next configuration version.",
                cancel: "Cancel",
                save: "Save",
                saved: "The signing rule was saved.",
                savedShort_one: "The signing rule was saved. {{posts}} can't reach the number yet: add a signer there.",
                savedShort_other: "The signing rule was saved. {{posts}} can't reach the number yet: add signers there.",
                checkedOnSave: "The number is checked against the new roles when you save.",
                savedRequesterShort: "The signing rule was saved. Some $t(signing.terms.posts) can't reach the number without the person who starts a request.",
                saveError: "The signing rule couldn't be saved. Someone may have changed it meanwhile; reload and try again.",
            },
            validation: {
                atLeastOne: "At least 1.",
                tooMany: "No $t(signing.terms.post) has {{n}} people who can sign. The most is {{max}}.",
                tooManyEvent: "Only {{max}} people can sign this. Choose at most {{max}}.",
                atMost: "At most {{max}}.",
                shortPosts_one: "{{posts}} has only {{n}} people who can sign, so it can't reach {{required}} signatures. Add a signer there or lower the number.",
                requesterShort_one: "Without the person who starts it, {{posts}} has only {{n}} people who can sign, so it can't reach {{required}} signatures.",
                requesterShort_other: "Without the person who starts it, {{posts}} have only {{n}} people who can sign, so they can't reach {{required}} signatures.",
                shortPosts_other: "{{posts}} have only {{n}} people who can sign, so they can't reach {{required}} signatures. Add a signer there or lower the number.",
            },
            pendingRequests_one: "{{count}} request is waiting for signatures under the current rule. Saving cancels it; the person who started it starts again.",
            pendingRequests_other: "{{count}} requests are waiting for signatures under the current rule. Saving cancels them; the people who started them start again.",
            certificates: {
                issuersIntro: "Staff certificates must chain to one of these. They are separate from the certificates voters sign in with.",
                checkRevocation: "Check revocation lists",
                crlUnavailable: {
                    "label": "When a list can't be downloaded",
                    "refuse": "Don't accept signatures",
                    "accept-unchecked": "Accept and mark the signature as unchecked",
                },
                registration: {
                    "label": "Registering a certificate to a person",
                    "on-first-use": "When its holder first signs with it",
                    "security-officer-only": "Only when someone who can register certificates registers it",
                },
                onePost: "A certificate signs for one $t(signing.terms.post) only",
                issuers: "Trusted issuers",
                import: "Import issuer certificates",
                importHelp: "Choose a PEM or CER file with the issuer's certificate. A PEM file can hold several certificates.",
                chooseFile: "Choose a certificate file",
                fileError: "The file couldn't be read.",
                imported: "{{imported}} issuer certificates imported; {{skipped}} were already trusted.",
                importedWithErrors: "{{imported}} issuer certificates imported, {{skipped}} already trusted. Refused: {{errors}}",
                importError: "The issuer certificates couldn't be imported.",
                deleteIssuer: "Remove {{name}}",
                deleteIssuerConfirm: "Remove {{name}} from the trusted issuers? Certificates it issued can no longer sign.",
                deleteError: "The issuer couldn't be removed.",
                noIssuers: "No trusted issuers yet. Staff can't sign until one is imported.",
                root: "Root",
                intermediate: "Intermediate",
                columns: {
                    issuer: "Issuer",
                    type: "Type",
                    issuedBy: "Issued by",
                    validUntil: "Valid until",
                    sha256: "SHA-256",
                    person: "Person",
                    post: "$t(signing.terms.post)",
                    certificate: "Certificate",
                    registered: "Registered",
                    status: "Status",
                },
                checks: "Checks",
                checksSaved: "The certificate checks were saved.",
                checksError: "The certificate checks couldn't be saved.",
                crlSchedule: "Downloaded from each issuer every hour.",
                crlUpdated: "{{url}}: updated {{time}}",
                crlFailed: "{{url}}: couldn't be downloaded (last try {{time}})",
                registeredTitle: "Registered certificates",
                search: "Search people, certificates or $t(signing.terms.posts)",
                status: "Status",
                statusAll: "All",
                statuses: {
                    "active": "Active",
                    "expires-soon": "Expires soon",
                    "expired": "Expired",
                    "revoked": "Revoked",
                },
                revokedOn: "Revoked {{date}}",
                allPosts: "All",
                noCertificates: "No registered certificates.",
                registeredHow: {
                    "first-use": "On first signature",
                    "security-officer": "Registered by an administrator",
                },
                register: "Register a certificate",
                registerSubmit: "Register",
                registerDone: "The certificate was registered.",
                registerError: "The certificate couldn't be registered.",
                person: "Person",
                personSearchHelp: "Type part of a username to find the person.",
                registeredBy: "By {{name}}",
                registerRefused: "This certificate can't be registered: check that a trusted issuer issued it, that it's valid today and that it's made for signing.",
                registeredToOther: "This certificate is registered to {{name}}. If this account is {{name}}'s too, link it as their second account.",
                linkAccount: "Link as a second account of the same person",
                alreadyRegistered: "This certificate is already registered to this person.",
                pem: "Certificate (PEM)",
                revoke: "Revoke",
                revokeOf: "Revoke the certificate of {{name}}",
                revokeTitle: "Revoke the certificate of {{name}}",
                revokeHelp: "A revoked certificate can't sign anymore. Signatures it already made still count.",
                revokeReason: "Reason",
                revokeDone: "The certificate was revoked.",
                revokeError: "The certificate couldn't be revoked.",
            },
            requests: {
                exportCsv: "Export CSV",
                exportError: "The requests couldn't be exported.",
                exportFileName: "signing-requests.csv",
                status: "Status",
                statusAll: "All",
                statusCount: "{{status}} · {{count}} of {{total}}",
                expires: "Expires {{time}}",
                lastSignatureBy: "{{name}}, {{time}}",
                empty: "No signing requests yet.",
                columns: {
                    request: "Request",
                    status: "Status",
                    started: "Started",
                    by: "By",
                    lastSignature: "Last signature",
                    code: "Code",
                },
            },
            reports: {
                postRequired: "Select a Post to generate this report when signatures are required.",
                generateNotice: "{{post}}: the document is generated now. It can be printed and transmitted once {{n}} people have signed it.",
            },
            status: {
                waiting: "Waiting",
                completed: "Signed",
                executed: "Done",
                cancelled: "Cancelled",
                expired: "Expired",
                failed: "Failed",
            },
            cancelReasons: {
                "by-requester": "The person who started it cancelled it",
                "by-operator": "An operator cancelled it",
                "rule-changed": "The action's signing rule changed",
                "payload-changed": "What it signs changed",
                "superseded": "A newer request replaced it",
                "certificate-revoked": "A certificate that signed it was revoked",
            },
            panel: {
                rulePost: "Needs {{n}} signatures from {{post}}'s signers, each with their digital certificate.",
                ruleEvent: "Needs {{n}} signatures, each with the signer's digital certificate.",
                signingCode: "Signing code",
                signers: "Signers",
                sign: "Sign",
                handover: "Next member signs in",
                cancel: "Cancel request",
                signedAt: "Signed {{time}}",
                notSigned: "Not signed",
                certificate: "Certificate {{name}}",
                you: "(you)",
                expiresAt: "Expires at {{time}}",
                progress: "{{count}} of {{total}}",
                openDocument: "Open the document",
                configurationVersion: "Configuration version {{version}}",
                configurationChanges: "Changes in this version",
            },
            dialog: {
                title: "Sign the {{object}}",
                steps: {
                    check: "Check",
                    certificate: "Certificate",
                    signed: "Signed",
                },
                localNote: "Signing happens in this browser. Your certificate file, its private key and its password are never sent. Only your signature and your public certificate go to the server.",
                check: {
                    signingAs: "You are signing as {{name}}",
                    titlePost: "{{title}}, {{post}}",
                    sameCode: "Everyone who signs sees the same code.",
                    confirmDocument: "I have checked the {{object}}",
                },
                certificate: {
                    intro: "Insert your security token and choose your certificate file.",
                    password: "Certificate password",
                    open: "Open certificate",
                    chooseAnother: "Choose another file",
                },
                checks: {
                    "passed": {
                        "trusted-issuer": "Issued by a trusted issuer ({{root}})",
                        "valid-now": "Valid today",
                        "signing-key-usage": "Made for signing",
                        "not-revoked": "Not revoked (lists updated {{time}})",
                        "registered": "Registered to you on {{date}}",
                        "registered-to-other": "Not registered to anyone else",
                        "already-signed": "Not used for this request yet",
                        "post-binding": "Registered for this $t(signing.terms.post)",
                        "signature": "The signature covers this request",
                    },
                    "failed": {
                        "trusted-issuer": "Not issued by a trusted issuer",
                        "valid-now": "Not valid today",
                        "signing-key-usage": "Not made for signing",
                        "not-revoked": "Revoked, or no current revocation list to check it",
                        "registered": "Not registered to you",
                        "registered-to-other": "Registered to {{name}}",
                        "already-signed": "Already used for this request",
                        "post-binding": "Registered for another $t(signing.terms.post)",
                        "signature": "The signature doesn't cover this request",
                    },
                    "first-use": "First use: it will be registered to you",
                },
                problems: {
                    wrongPassword: "Wrong password. Check it and try again.",
                    notForYou: "This certificate can't sign for you. Use the certificate on your own security token.",
                    issuerNotAccepted: "Use the certificate {{organization}} registered for you. Certificates from other issuers are not accepted.",
                    cancelled: "This request was cancelled: {{reason}}. Signatures given for it no longer count. Start it again to sign the current version.",
                },
                signed: {
                    title: "Signed",
                    withCertificate: "with the certificate of {{name}}",
                    count: "{{n}} of {{total}} signatures.",
                    allIn: "All {{total}} signatures are in.",
                    next: "Next: {{names}} sign.",
                },
                handover: "You will be signed out. The next member signs in on this computer and returns to this request to sign. The request stays open until {{time}}.",
                sign: "Sign",
                back: "Back",
                cancel: "Cancel",
            },
            widget: {
                continue: "Continue",
                done: "Done",
                close: "Close",
                retry: "Try again",
                loading: "Loading the request…",
                loadError: "The request could not be loaded.",
                chooseFile: "Choose certificate file",
                fileInput: "Certificate file",
                fileSize: "{{size}} KB",
                showPassword: "Show password",
                hidePassword: "Hide password",
                opening: "Opening the certificate…",
                checking: "Checking the certificate…",
                signing: "Signing…",
                certificateCard: "Issued by {{issuer}} · valid until {{date}} · {{algorithm}}",
                fingerprint: "SHA-256 {{fingerprint}}",
                algorithms: {
                    "rsa-pkcs1-sha256": "RSA",
                    "ecdsa-p256-sha256": "EC P-256",
                },
                document: "{{type}} · SHA-256 {{hash}}",
                documentPages: "{{type}} · {{pages}} pages · SHA-256 {{hash}}",
                checksTitle: "Certificate checks",
                untrustedIssuer: "{{issuer}} is not a trusted issuer for this election event",
                registeredToSomeoneElse: "Registered to someone else",
                checkPassedNoDetail: {
                    "trusted-issuer": "Issued by a trusted issuer",
                    "not-revoked": "Not revoked",
                },
                organization: "your organization",
                cantSign: "This certificate can't sign this request.",
                checkError: "The certificate could not be checked. Try again.",
                fileErrors: {
                    UNREADABLE_FILE: "This file is not a certificate file (.p12 or .pfx), or it is damaged.",
                    UNSUPPORTED_ENCRYPTION: "This browser can't open the encryption this file uses.",
                    NO_PRIVATE_KEY: "This file has no private key. Choose the certificate file from your security token.",
                    NO_CERTIFICATE: "This file has no certificate.",
                    UNSUPPORTED_KEY: "This certificate's key type is not supported. Use an RSA or EC P-256 certificate.",
                    KEY_CERTIFICATE_MISMATCH: "The certificate in this file does not match its key.",
                },
                openError: "The certificate could not be opened. Try again.",
                signError: "The signature could not be sent. Try again.",
                refused: "The server refused the signature.",
                stale: "The document changed while you were signing. Sign again.",
                mismatch: "What would be signed does not match this request. Close the dialog and open the request again.",
                documentMismatch: "The document does not match the one this request signs.",
                documentError: "The document could not be downloaded. Try again.",
                alreadySigned: "You have already signed this request.",
                closed: {
                    changed: "This request changed after you opened it. Close this window and check it again before you sign.",
                    allSigned: "This request already has all its signatures.",
                },
                chooseCertificate: "Certificate to sign with",
                renderError: "The signing request could not be shown. Close it and open it again.",
                signedAt: "{{time}}",
                panel: {
                    completedAt: "Signed at {{time}}",
                    expired: "This request expired. Signatures given for it no longer count. Start it again to sign.",
                    failed: "All signatures are in, but the action failed. The log has the details.",
                    details: "Details",
                    close: "Close the request panel",
                },
                cancelDialog: {
                    title: "Cancel this request?",
                    body: "Signatures given for it no longer count. The person who started it starts again.",
                    reason: "Reason (optional)",
                    confirm: "Cancel request",
                    back: "Keep it",
                    error: "The request could not be cancelled. Try again.",
                },
                handoverDialog: {
                    title: "Next member signs in",
                    noExpiry: "You will be signed out. The next member signs in on this computer and returns to this request to sign.",
                    confirm: "Sign out",
                    back: "Stay signed in",
                    error: "The handover could not be recorded. Try again.",
                },
            },
            details: {
                keys_ceremony_id: "Ceremony",
                tally_session_id: "Tally session",
                trustee_id: "Trustee",
                custody_proof_sha256: "Custody proof SHA-256",
                channel: "Channel",
                channels: "Channels",
                publication_id: "Ballot publication",
                ballot_publication_id: "Ballot publication",
                digest: "Configuration SHA-256",
                signing_rules: "Signing rules",
                scheduled_events: "New scheduled events",
                ballots_and_contests: "Ballots and contests",
                application_id: "Application",
                applicant_registry_id: "Registry account",
                decision: "Decision",
                submitted_at: "Submitted",
                reason: "Why it needs a person",
                registry_record: "Registry record",
                status: "Application status",
                from: "Status before",
            },
            closed: {
                pending: "Every signature is in. Voting closes in a moment.",
                title: "Voting closed at {{time}}.",
                titleSealed: "Voting closed at {{time}}. Ballots sealed.",
                record: "Seal record",
                ballots: "Ballots in the seal",
                sealHash: "Seal {{algorithm}}",
                signedBy: "Signed by",
                signatures: "Closing signatures in the seal record",
                signaturesValue_one: "{{count}}, signing code {{code}}",
                signaturesValue_other: "{{count}}, signing code {{code}}",
                signers: "Signed by the members",
            },
            values: {
                ballots_and_contests: {
                    "first-version": "First version",
                    "no-changes": "No changes",
                    "changed": "Changed",
                },
                signing_rules: {
                    "initialize-voting": "$t(signing.actions.initialize-voting.label)",
                    "open-voting": "$t(signing.actions.open-voting.label)",
                    "close-voting": "$t(signing.actions.close-voting.label)",
                    "generate-election-returns": "$t(signing.actions.generate-election-returns.label)",
                    "generate-reports": "$t(signing.actions.generate-reports.label)",
                    "transmit-results": "$t(signing.actions.transmit-results.label)",
                    "approve-voter": "$t(signing.actions.approve-voter.label)",
                    "approve-configuration": "$t(signing.actions.approve-configuration.label)",
                    "key-ceremony": "$t(signing.actions.key-ceremony.label)",
                    "tally-key": "$t(signing.actions.tally-key.label)",
                },
                channels: {
                    ONLINE: "Online",
                    KIOSK: "Kiosk",
                    EARLY_VOTING: "Early voting",
                    TELEPHONE: "Telephone",
                },
                statuses: {
                    NOT_STARTED: "Not started",
                    OPEN: "Open",
                    PAUSED: "Paused",
                    CLOSED: "Closed",
                },
                channelStatus: "{{channel}}: {{status}}",
                ruleChange: "{{action}}: {{rule}}",
                ruleChangeFrom: "{{action}}: {{rule}} (was {{was}})",
                ruleNeeds: "needs {{n}}",
                ruleOff: "off",
                decision: {
                    approve: "Approve",
                },
            },
            waiting: {
                title: "Waiting for my signature",
                buttonCount_one: "Waiting for my signature: {{count}} request to sign",
                buttonCount_other: "Waiting for my signature: {{count}} requests to sign",
                intro: "Requests waiting for the signatures of the actions you can sign, in your $t(signing.terms.posts).",
                close: "Close the list",
                empty: "Nothing is waiting for your signature.",
                loadError: "The requests waiting for signatures couldn't be loaded.",
                signedByYou: "Signed by you",
            },
            notes: {
                afterApproval: "After approval",
                afterApprovalValue: "The voter's credentials are issued and sent to them",
                custodyProof: "Your custody proof",
                custodyProofChecked: "Checked: it is your custody proof for this ceremony",
                recordedIn: "Recorded in",
                recordedInCeremony: "The keys ceremony and the bulletin board",
                recordedInTally: "The tally session",
            },
            results: {
                signatures: "Signatures",
                needs: "Needs {{n}}",
                off: "Off",
                openRequest: "Open the signing request",
                downloadSigned: "Download signed PDF",
                print: "Print",
                transmit: "Transmit results",
                sendTo: "Send to {{count}} destinations",
                awaiting: "{{item}}: awaiting signatures",
                transmission: {
                    title: "Signatures",
                    description: "Each signer signs the package's results with their digital certificate, in this browser. The package can be sent once {{n}} people have signed it.",
                    waiting: "The package can be sent once its signing request has all its signatures.",
                    signed: "The package carries all its signatures and can be sent.",
                    ended: "This package's signing request ended. Create the package again to sign it.",
                },
            },
            custodyProof: {
                signing: "Sign your custody proof in the signing panel. It is recorded once you have signed.",
                record: "Record my custody proof",
                failed: "Your signed custody proof could not be recorded: {{error}}",
                dropAgain: "Drop your custody proof file again to record your signed custody proof. (signed-custody-proof.json)",
                redo: "Your custody proof was contributed without your signature, which this election now needs. Contribute it again and sign it.",
                notTaken: "The ceremony no longer takes this custody proof. Drop your custody proof file again. (signed-custody-proof.json)",
            },
        },
        lifecycle: {
            signedClose: {
                title: "Signed close deadline",
                deadline: "{{election}}: {{time}} · authorized by configuration {{code}}.",
                explanation: "This signed deadline remains authoritative after the editable schedule is changed or removed. The scheduler closes its authorized channels that are still open.",
                reached: "This signed deadline has passed. Check the current voting state and audit log; processing has not been recorded yet.",
                processed: "Signed close deadline processed at {{time}}.",
                signedAt: "Signed deadline: {{time}}.",
                channels: "Channels still covered by this deadline: {{channels}}.",
                result: "Consult the voting state and audit log for the actual changes and complete result.",
                unavailable: "Unable to load signed close deadlines. Check the published schedule and audit log.",
            },
            picker: {
                noMatch: "No timezone matches. Type a city, country, zone, abbreviation or offset.",
            },
            input: {
                timezone: "Timezone",
                scheduledAt: "Scheduled at",
                meetingStart: "Meeting start",
                cronZone: "The schedule runs in the event's primary timezone, {{zone}}.",
                unconfiguredZone: "{{zone}} isn't one of the event's configured timezones. Choose one of them.",
            },
            schedule: {
                allElections: "All elections",
                outcome: "Outcome",
                noOffset: "No timezone offset: never runs",
                unpublished: "Not published yet",
                notPublished: "Nothing is published yet: voters see the schedule after the first publication.",
                unpublishedChanges_one: "{{count}} scheduled event changed since the last publication. Voters see it after you publish.",
                unpublishedChanges_other: "{{count}} scheduled events changed since the last publication. Voters see them after you publish.",
                offsetless_one: "{{count}} scheduled time has no timezone offset, so it never runs. Edit it to set its timezone.",
                offsetless_other: "{{count}} scheduled times have no timezone offset, so they never run. Edit them to set their timezone.",
                outcomeChange: "Saving changes what this scheduled transition does: {{before}} → {{after}}.",
                outcomeNew: "Once saved, this scheduled transition: {{after}}.",
                outcomeElections: "{{count}} of {{total}} elections",
                exportError: "The schedule could not be exported.",
                exportFileName: "schedule.csv",
                totals: {
                    refused_one: "{{count}} scheduled row will be refused ({{transitions}} election transitions).",
                    refused_other: "{{count}} scheduled rows will be refused ({{transitions}} election transitions).",
                    runsUnsigned_one: "{{count}} scheduled close will run without signatures ({{transitions}} election transitions).",
                    runsUnsigned_other: "{{count}} scheduled closes will run without signatures ({{transitions}} election transitions).",
                    review: "Review",
                    showAll: "Show all",
                    showing: {
                        refused: "Showing the {{count}} scheduled rows that will be refused ({{transitions}} election transitions).",
                        runsUnsigned: "Showing the {{count}} scheduled closes that will run without signatures ({{transitions}} election transitions).",
                    },
                },
                recompute: {
                    title_one: "A timezone database update moves {{count}} future scheduled time. Nothing changes until you apply it.",
                    title_other: "A timezone database update moves {{count}} future scheduled times. Nothing changes until you apply them.",
                    change: "{{type}}: {{before}} → {{after}}",
                    apply: "Apply",
                    applied_one: "{{count}} scheduled time updated.",
                    applied_other: "{{count}} scheduled times updated.",
                    error: "The scheduled times could not be updated.",
                },
                outcomeChangeElections_one: "Saving changes the outcome at {{count}} election:",
                outcomeChangeElections_other: "Saving changes the outcome at {{count}} elections:",
            },
            authorizes: {
                reportPolicyOf: "{{election}}: {{value}}",
                initializationRetained: "A required report in this signed configuration remains required if the current Post setting is changed to not required.",
                title: "What this approval authorizes",
                schedule: "Scheduled openings and closings",
                noSchedule: "No scheduled openings or closings: the signers open and close voting.",
                opens: "Opens {{time}}",
                closes: "Closes {{time}}",
                settings: "Settings",
                unsignedClose: "Scheduled close without signatures: {{value}}",
                initialization: "Initialization: {{value}}",
                firstConfiguration: "This is the first approved configuration: nothing to compare with.",
                sameAsPrevious: "The settings are the same as in the previous approved configuration.",
                rule: {
                    openNeeds_one: "Opening needs {{count}} signature",
                    openNeeds_other: "Opening needs {{count}} signatures",
                    openNoSignatures: "Opening needs no signatures",
                    closeNeeds_one: "Closing needs {{count}} signature",
                    closeNeeds_other: "Closing needs {{count}} signatures",
                    closeNoSignatures: "Closing needs no signatures",
                    openSetting: "Opening voting",
                    closeSetting: "Closing voting",
                    signatures_one: "{{count}} signature",
                    signatures_other: "{{count}} signatures",
                    none: "no signatures",
                },
                diff: {
                    tightens: "Tightens: {{setting}} {{before}} → {{after}}",
                    loosens: "Loosens: {{setting}} {{before}} → {{after}}",
                    mixed: "Changes: {{setting}} {{before}} → {{after}} (stricter in one way, looser in another)",
                },
                comparedWith: "Compared with the previous approved configuration, approval {{code}}:",
                channels: "Voting channels per election",
                channelsOf: "{{election}}: {{channels}}",
                noChannels: "none",
            },
            publish: {
                openedAuthorized: "Voting opened on schedule at {{time}}, authorized by configuration approval {{code}} (signed by {{names}}).",
                closedAuthorized: "Voting closed on schedule at {{time}}, authorized by configuration approval {{code}} (signed by {{names}}).",
                closedUnsigned: "Voting closed on schedule at {{time}}. No closing signatures: the schedule closed voting at its deadline.",
                authorizedBy: "Authorized by",
                cancelledRequest: "Request {{code}} had {{n}} of {{k}} signatures and was cancelled.",
                openedRefused: "The scheduled opening at {{time}} was refused.",
                closedRefused: "The scheduled close at {{time}} was refused.",
                openedNoSignaturesNeeded: "Voting opened on schedule at {{time}}; no signatures were needed.",
                closedNoSignaturesNeeded: "Voting closed on schedule at {{time}}; no signatures were needed.",
                openedNothingToChange: "At {{time}} the scheduled opening had nothing to open: its channels were already open.",
                closedNothingToChange: "At {{time}} the scheduled close had nothing to close: its channels were already closed.",
            },
            import: {
                title: "Import schedule",
                subtitle: "One row per event and election, in local time. Leave timezone empty to use the election's timezone.",
                chooseFile: "Choose a CSV file",
                template: "Download template",
                templateFileName: "schedule-template.csv",
                ready: "{{ok}} events ready for {{posts}} elections.",
                needsAttention_one: "{{ok}} events ready for {{posts}} elections. {{count}} row needs attention; fix the file and upload it again.",
                needsAttention_other: "{{ok}} events ready for {{posts}} elections. {{count}} rows need attention; fix the file and upload it again.",
                preview: "Rows to import",
                row: "Row",
                asWritten: "{{local}} · {{place}}",
                moreRows: "…and {{count}} more rows",
                imported: "Schedule imported: {{created}} created, {{updated}} updated.",
                uploadError: "The file could not be checked. Upload it again.",
                importError: "The schedule could not be imported.",
                error: {
                    unknownElection: "No election has the alias {{election}}.",
                    unknownEventType: "{{type}} is not a scheduled event type.",
                    invalidTimeZone: "{{zone}} is not a timezone.",
                    invalidDateTime: "The date and time must read YYYY-MM-DDTHH:MM.",
                    invalidVotingChannels: "The voting channels are unknown, or open Online and Early voting together.",
                    dstGap: "{{dateTime}} does not exist in {{city}} because clocks go forward. Write a time that exists.",
                    duplicate: "Another row schedules the same event for this election.",
                    other: "This row can't be imported ({{code}}).",
                    ambiguousElection: "More than one election has the alias {{election}}.",
                },
            },
            settings: {
                accordion: "Language, Date and Time",
                dateAndTime: "Date and time",
                configured: "Configured timezones",
                configuredHelp: "{{count}} timezones. Elections choose theirs from this list; type a city or country to add one.",
                moreZones: "+{{count}}",
                primary: "Primary timezone",
                primaryHelp: "Used for event-wide schedules, reports and elections without their own timezone.",
                primaryInUse: "{{zone}} is the primary timezone. Choose another primary timezone first.",
                inUse: "{{zone}} is in use by {{names}}. Change those elections first.",
                logs: "Times in Logs and log exports",
                logsPrimary: "Primary timezone ({{abbr}})",
                logsElection: "Each row's election timezone",
                logsHelp: "Rows without an election use the primary timezone.",
                electionZone: "Timezone",
                electionPrimary: "Event primary: {{zone}}",
                electionZoneHelp: "Schedules, voter screens and reports for this election use this timezone, including every area under it. Empty uses the event's primary timezone.",
                electionUnconfigured: "The event no longer configures this timezone, so the election uses the primary timezone, {{zone}}. Choose one of the configured timezones.",
                electionUnconfiguredSave: "Choose one of the event's configured timezones.",
            },
            policies: {
                accordion: "Voting lifecycle",
                intro: "These settings are part of the election event's configuration: the configuration approval signs them, and scheduled openings and closings follow the stricter of the current and the published settings.",
                nothingPublished: "Nothing published yet: until the first publication, scheduled openings and closings use the defaults (per election, refuse).",
                publishedValue: "Published configuration: {{value}}",
                changedSincePublished: "Changed since the published configuration: scheduled openings and closings follow the stricter of the two until the next approved publication.",
                scope: {
                    title: "Initialization before voting opens",
                    post: {
                        label: "Per election",
                        help: "An election opens once it is initialized.",
                    },
                    event: {
                        label: "Whole event",
                        help: "No election opens until every election is initialized.",
                        warning: "One election that isn't initialized keeps every election closed, including at their scheduled openings.",
                    },
                    postAndCountry: {
                        label: "Per election and country",
                        help: "An election opens once every country (area) under it is initialized.",
                        warning: "An election stays closed, also at its scheduled opening, until every country under it is initialized; each country is initialized with its own report.",
                    },
                },
                close: {
                    title: "Scheduled close without signatures",
                    help: "When closing voting needs signatures and a scheduled close isn't in the signed configuration.",
                    refuse: {
                        label: "Refuse",
                        help: "The close doesn't run; the election's signers close voting with their signatures.",
                    },
                    runAsSystem: {
                        label: "Run as system",
                        help: "Voting closes at the deadline, recorded as closed by the schedule without signatures.",
                        warning: "Scheduled closes outside the signed configuration close voting without anyone's signature. The log and the documents say so.",
                    },
                },
                onSave: {
                    outcomes_zero: "No scheduled transition changes its outcome.",
                    outcomes_one: "{{count}} scheduled transition changes its outcome. Review it in Scheduled Events.",
                    outcomes_other: "{{count}} scheduled transitions change their outcome. Review them in Scheduled Events.",
                },
                saveError: "The voting lifecycle settings could not be saved.",
                publishedPerTarget: "Published configuration, per target: {{values}}",
                publishedCount_one: "{{value}} ({{count}} target)",
                publishedCount_other: "{{value}} ({{count}} targets)",
                savedWithoutPolicies: "The election event was saved, but the voting lifecycle settings were not: {{reason}}. Save them again.",
            },
        },
        scheduledOutcome: {
            chip: {
                waitingForInitialization: "Waiting for initialization",
                runs: "Will run",
                runsUnsigned: "Will run without signatures",
                refused: "Will be refused",
            },
            note: {
                waitingForInitialization: "Waiting for initialization",
                authorized: "Authorized by configuration {{code}}",
                noSignaturesNeeded: "No signatures needed",
                closesUnsigned: "Closes without signatures",
                refused: {
                    initialization: "Required initialization is incomplete",
                    votingClose: "Voting cannot open at or after its close deadline",
                    needsSignatures: "Needs the signers' signatures",
                    covered: "Not in the signed configuration",
                    unsignedClose: "A close without signatures is refused",
                    stricterCopy: "Changed since the published configuration, which still decides",
                    defaults: "Nothing published yet: the defaults apply",
                },
                refusedWithStep: "{{reason}}. {{next}}",
            },
            why: {
                button: "Why?",
                title: {
                    waitingForInitialization: "Why it is waiting for initialization",
                    runs: "Why it will run",
                    runsUnsigned: "Why it will run without signatures",
                    refused: "Why it will be refused",
                },
                checks: "Checks",
                check: "Check",
                current: "Current settings",
                published: "Published configuration",
                verdict: "Verdict",
                allows: "Allows",
                blocks: "Blocks",
                deciding: "Deciding check",
                nextStep: "Next step:",
                signedBy: "Signed by {{names}}",
            },
            question: {
                initialization: "Is the required initialization complete?",
                votingClose: "Does this opening respect the voting close deadline?",
                needsSignatures: "Does this action need signatures?",
                covered: "Is this exact schedule in the signed configuration?",
                unsignedClose: "What happens to a close without signatures?",
                stricterCopy: "Do the current and the published settings differ? Which one decides?",
                defaults: "Is anything published yet?",
            },
            check: {
                initialization: {
                    waiting: "Initialization requirements in both the current and published settings must be satisfied.",
                },
                votingClose: {
                    passed: "Voting closes at {{closes_at}}; this opening cannot run at or after that deadline.",
                },
                needsSignatures: {
                    yes: "Yes, {{signatures}} signatures",
                    yes_one: "Yes, {{count}} signature",
                    yes_other: "Yes, {{count}} signatures",
                    no: "No",
                },
                covered: {
                    overriddenBySignedPostRow: "The signed configuration {{code}} uses this Post's own opening {{scheduled_event_id}}. The event-wide opening does not apply.",
                    yes: "Yes: approval {{code}}, unchanged",
                    changed: "No: changed since approval {{code}}",
                    changedBy: "No: edited on {{edited_at}} by {{edited_by}}, after approval {{code}}",
                    notInApproval: "No: approval {{code}} doesn't include it",
                    noApproval: "No approved configuration yet",
                    channelsChanged: "No: the election's voting channels changed since approval {{code}}",
                    alreadyFired: "No: this transition of approval {{code}} already ran at {{fired_at}}; running it again needs signatures",
                    late: "No: it is more than 15 minutes past {{scheduled_date}} (approval {{code}}); running it now needs signatures",
                },
                unsignedClose: {
                    refuse: "Refuse",
                    runAsSystem: "Run as system",
                },
                stricterCopy: {
                    same: "Both are the same",
                    currentStricter: "Current settings are stricter: applied now",
                    currentLooser: "Current settings are looser: they apply after the next approved publication",
                    combined: "Each is stricter in one value: both apply",
                },
                defaults: {
                    published: "Published on {{published_at}}",
                    nothingPublished: "Nothing published: defaults apply",
                    noSnapshot: "Published on {{published_at}}, before publications kept these settings: defaults apply",
                },
            },
            nextStep: {
                initialize: "Complete the required initialization. The scheduler will retry before voting closes.",
                closed: "This opening will not run after voting closes.",
                none: "No action needed.",
                publishAndApprove: "Publish and approve the configuration.",
                requireConfigurationApproval: "Make Approve configuration need signatures, then publish and approve the configuration.",
                askSignersToOpen: "Ask the election's signers to open voting.",
                askSignersToClose: "Ask the election's signers to close voting.",
            },
            applies: {
                tightens: "Applies now to manual and scheduled actions.",
                loosens: "Applies now to manual actions; to scheduled openings and closings after the next approved publication.",
                tightensAndLoosens: "Its stricter part applies now to manual and scheduled actions; its looser part applies now to manual actions and to scheduled openings and closings after the next approved publication.",
            },
        },
        messagingEvent: {
            tab: "Messaging",
            intro: "The channels voters of this event can choose for codes and notices, and the account each one sends from. Accounts are managed in Settings > Messaging.",
            readOnly: "You can view these settings. Changing them needs the messaging-config-write permission.",
            savingNote: "Saving also updates the channels the enrollment pages offer for each Post.",
            save: "Save",
            saved: "Messaging settings saved.",
            saveRejected: "The messaging settings were not saved. Fix the problems shown.",
            saveError: "Could not save the messaging settings.",
            accountLabel: "{{channel}} account",
            notUsed: "Not used",
            missingAccount: "Account not found",
            noAccount: "Add an account in Settings > Messaging first",
            missing: "Missing: {{blockers}}",
            purposeSwitch: "{{channel}}: {{purpose}}",
            sections: {
                channels: "Channels",
                templates: "Approved templates",
                posts: "Channels by Post",
                postsCount: "Channels by Post ({{count}} Posts)",
                delivery: "Delivery status",
            },
            column: {
                channel: "Channel",
                account: "Sends from",
                purpose: "Purpose",
                language: "Language",
                template: "Provider template",
                status: "Status",
                post: "Post",
                key: "Message type or template",
                providerLanguage: "Provider language",
                voters: "Voters using it",
                sent24h: "Sent, last 24 h",
                sent24hHelp: "Every message whose latest attempt was in the last 24 hours, in any state, failed ones included. The state columns count all of the event's messages.",
            },
            outOfWindow: {
                utility: "Outside the 24-hour window, {{channel}} sends notices with the approved utility template bound to notices under Approved templates.",
            },
            messageTypes: {
                otp: "Verification code",
                otl: "Sign-in link",
                enrollmentAccepted: "Enrollment accepted",
                enrollmentAcceptedKiosk: "Enrollment accepted (kiosk)",
                enrollmentPending: "Enrollment pending approval",
                enrollmentRejected: "Enrollment rejected",
                passwordReset: "Password reset",
                temporaryPassword: "Temporary password",
                contactChanged: "Contact method changed",
            },
            templates: {
                empty: "Choose an account that sends approved templates, such as WhatsApp, Viber or Messenger, to bind its templates here.",
                help: "Choose a built-in message type or a template alias from Templates. Leave this empty to use the approved template by default for this purpose. Language is the voter's language. Provider template is the template's name or ID at the provider. Provider language is the provider's code for that template when it differs from the voter's language: WhatsApp needs the exact code of the approved template, such as en_US.",
                order: "For each message the most specific row wins: the row for the message in the voter's language, then the row for the message in any language, then the default for the purpose in the voter's language, then any default for the purpose.",
                noneRequired: "{{channel}} sends only approved templates. Add at least a default template for each purpose in use.",
                noneOptional: "No templates are bound for {{channel}}. They are needed only to send notices outside the conversation window.",
                row: "{{channel}} template {{position}}",
                keyDefault: "Default for this purpose",
                add: "Add {{channel}} template",
                remove: "Remove {{channel}} template {{position}}",
                incomplete: "Enter the language and the provider template, or remove this row.",
                approval: {
                    APPROVED: "Approved",
                    NOT_APPROVED: "Not approved",
                    NOT_CHECKED: "Approval not checked",
                },
            },
            posts: {
                noChannels: "Turn on codes or notices for a channel to choose the channels of each Post.",
                help: "Enrollment shows each Post's voters the channels ticked here.",
                restricted: "{{count}} Posts offer fewer than all {{total}} channels.",
                allChannels: "Every Post offers all {{total}} channels; untick a channel for a Post where it does not work.",
                search: "Search Posts",
                cell: "{{post}}: {{channel}}",
                showing: "Showing {{shown}} of {{total}} Posts. Search to find others.",
            },
            delivery: {
                notConfigured: "Not offered by this event",
                empty: "No channel is in use.",
                help: "Counts are per message, by the state of its latest attempt. Accepted means the provider accepted the message, not that the voter received it. Unknown means delivery is not confirmed yet; after 24 hours it is shown as Unresolved, never as failed. An account without delivery reports shows delivery as unavailable.",
                loadError: "The message counts could not be loaded.",
                noReceipts: "This account gets no delivery reports, so delivery can't be shown.",
                showFailed: "Show the failed {{channel}} messages in Logs",
                noChannelHelp: "Voters with no contact channel on record. Their notices fail and are never counted under a channel.",
                showFailedNoChannel: "Show the failed messages of voters with no contact channel in Logs",
            },
            error: {
                UNSUPPORTED_VERSION: "This configuration uses version {{version}}, which is not supported.",
                DUPLICATE_CHANNEL: "{{channel}} is configured more than once.",
                UNKNOWN_ACCOUNT: "The {{channel}} account no longer exists. Choose another account.",
                ACCOUNT_OF_ANOTHER_TENANT: "The selected account belongs to another tenant.",
                ACCOUNT_CHANNEL_MISMATCH: "The selected account does not send {{channel}} messages.",
                PURPOSE_NOT_READY: "{{channel}} cannot send {{purpose}} yet. Missing: {{blockers}}.",
                TEMPLATE_NOT_APPROVED: "The {{channel}} template for {{purpose}} in {{language}} is not approved by the provider.",
                OUT_OF_WINDOW_NOT_SUPPORTED: "{{channel}} cannot send outside a conversation window with this account: it has no conversation window, or its notices already need a template.",
                ELECTION_CHANNEL_NOT_ENABLED: "{{election}} offers {{channel}}, which this event does not use.",
                UNKNOWN_ELECTION: "{{election}} is not an election of this event.",
                UTILITY_TEMPLATE_MISSING: "{{channel}} notices outside the 24-hour window need the approved utility template. Bind it to notices under Approved templates.",
            },
            noReadPermission: "Reading these settings needs the messaging-config-read permission.",
            chooseAccount: "Choose an account first.",
            needsSavingAgain: "Configuration needs saving again.",
            needsSavingAgainHelp: "It was copied from the earlier storage and didn't pass the checks a save makes. Fix the problems shown, then save it again.",
        },
        messaging: {
            channel: {
                EMAIL: "Email",
                SMS: "SMS",
                WHATSAPP: "WhatsApp",
                VIBER: "Viber",
                MESSENGER: "Facebook Messenger",
            },
            provider: {
                AWS_SES: "Amazon SES",
                SMTP: "SMTP server",
                AWS_SNS: "Amazon SNS",
                WHATSAPP_CLOUD_API: "WhatsApp Cloud API (Meta)",
                MESSENGER_SEND_API: "Messenger Platform (Meta)",
                VIBER_INFOBIP: "Viber Business Messages (Infobip)",
                CONSOLE: "Console (no longer supported)",
                HTTP_API: "Custom HTTP API (no longer supported)",
            },
            purpose: {
                OTP: "OTPs",
                NOTICE: "Notices",
            },
            state: {
                QUEUED: "Queued",
                ACCEPTED: "Accepted",
                DELIVERED: "Delivered",
                FAILED: "Failed",
                UNKNOWN: "Unknown",
                UNRESOLVED: "Unresolved",
            },
            stateHelp: {
                QUEUED: "Waiting to be handed to the provider.",
                ACCEPTED: "The provider accepted the message. This does not mean the voter received it.",
                DELIVERED: "The provider reported the message as delivered.",
                FAILED: "The provider confirmed the message was not delivered.",
                UNKNOWN: "Delivery is not confirmed yet.",
                UNRESOLVED: "Delivery couldn't be confirmed within 24 hours. This doesn't mean it failed.",
            },
            blocker: {
                UNCHECKED: "Not checked for its current number, Page or sender",
                NOT_CONNECTED: "Not connected",
                UNSUPPORTED_PURPOSE: "Not supported by this provider",
                NEEDS_PROVIDER_APPROVAL: "Needs provider approval",
                NEEDS_PRODUCTION_ACCESS: "Needs production access",
                NEEDS_APPROVED_TEMPLATE: "Needs approved template",
                UNSUPPORTED_PROVIDER: "Unsupported provider: replace this account",
                CALLBACK_NOT_CONFIGURED: "Callback address not configured",
                REPORT_CREDENTIALS_MISSING: "Report credentials not generated",
            },
            readiness: {
                connected: "Connected",
                notConnected: "Not connected",
                readyOtp: "Ready for OTP",
                readyNotice: "Ready for notices",
                notReady: "Not ready",
                lastCheck: "Checked {{date}}",
                neverChecked: "Not checked yet",
            },
            approval: {
                PENDING: "Pending provider approval",
                CONFIRMED: "Provider approval confirmed",
            },
            credential: {
                ACCESS_TOKEN: "Access token",
                APP_SECRET: "App secret",
                VERIFY_TOKEN: "Verify token",
                API_KEY: "API key",
                SMTP_PASSWORD: "Password",
                AWS_ACCESS_KEY_ID: "AWS access key ID",
                AWS_SECRET_ACCESS_KEY: "AWS secret access key",
                REPORT_USERNAME: "Report user name",
                REPORT_PASSWORD: "Report password",
            },
            deliveryUnavailable: "Delivery unavailable",
            templates: {
                noMethod: "Choose at least one method for the template.",
                parameters: "Template parameters",
                parametersHelp: "What fills each placeholder of the approved template, in order, such as user.first_name or vote_url. For a template with named parameters write @name=value, such as @first_name=user.first_name; any other entry is positional.",
                parameter: "Parameter {{position}}",
                removeParameter: "Remove parameter {{position}}",
                addParameter: "Add parameter",
                noAccount: "There is no {{channel}} account yet. Add one in Settings > Messaging to see which languages are approved.",
                account: "Account",
                approvalTitle: "Approved templates",
                language: "Language",
                approvalFor: "Approved for {{purpose}}",
                approved: "Approved",
                notApproved: "Not approved",
                approvalHelp: "Approvals come from the provider and are updated by the account's connection check.",
                messengerIntro: "Within 24 hours of the voter's last message, Messenger sends the text below.",
                messengerMessage: "Message within 24 hours",
                messengerWindow: "A saved Messenger recipient is not permission to send. Outside the 24-hour window this notice is sent with the approved utility template set below or bound in the election event; without one it isn't sent, and the failure shows with its reason. Utility messages need the page_utility_messaging permission and an approved UTILITY template on the Page.",
                intro: {
                    WHATSAPP: "WhatsApp sends only templates that Meta approved for the account's WhatsApp Business Account. The message must match the approved template; choose what fills its parameters.",
                    VIBER: "Viber sends codes and transactional messages only with templates the Viber partner approved. The message must match the approved template; choose what fills its parameters.",
                },
                approvedWording: "Approved wording",
                approvedWordingHelp: "A copy of the approved template, used as a preview. Changing it here does not change what the provider sends.",
                providerTemplateTitle: "Provider template",
                providerTemplateHelp: "Optional. The name or ID of the approved template at the provider. When empty, the election event's template bound to this template's alias is used, or the event's default for the purpose.",
                providerTemplate: "Provider template name or ID",
                providerLanguage: "Provider language code",
                providerLanguageHelp: {
                    WHATSAPP: "Use the exact language code of the approved WhatsApp template, such as en or en_US. A regional code is needed only when that template was approved with it.",
                    VIBER: "The language code the Viber provider knows the template by, when it needs one.",
                    MESSENGER: "The language code of the approved utility template, such as en_US.",
                },
                noReadPermission: "Reading the accounts needs the messaging-config-read permission.",
            },
            send: {
                eachVoter: "Each voter's channel",
                eachVoterHelp: "Each voter gets one message on their own channel. If delivery fails, it is retried on that channel and the failure shows on the event's Messaging tab. Unconfirmed delivery is shown as Unknown.",
                channelColumn: "Channel",
                sendsFrom: "Sends from",
                noAccount: "No account",
                missingContent: "This notification has no content for {{channels}}.",
                approvedTemplateHelp: "Because {{channel}} templates are approved by the provider, their wording, provider template and language cannot be changed here. Choose another saved template to use different approved content.",
                voters: "Voters",
                environment: "The deployment's default sender",
                noNoticeChannels: "This event's messaging settings turn on notices for no channel, so no voter would get this notification. Turn on notices for a channel on the event's Messaging tab.",
                noReadPermission: "Showing each voter's channel needs the messaging-config-read permission. Each voter still gets the notification on their own channel.",
            },
            audience: {
                notOfferedRow: "None of these voters' Posts offer this channel for notices, so none of them gets it: {{reason}}.",
                willSend: "Will get the notification: {{willSend}}",
                selectedTimedOut: "Counting the selected voters took too long, so no counts are shown. Each voter still gets the notification on their own channel.",
                notSent: "Not sent",
                deletedAccount: "Deleted account",
                notOffered: "{{notOffered}} of them don't get it: {{reason}}.",
                noAccountHelp: "No account sends on this channel, so these voters' notices fail: {{reason}}.",
                noChannelHelp: "These voters have no contact channel on record. They get nothing, and each shows as failed: {{reason}}.",
                total: "Voters in this audience: {{total}}",
                loadError: "The voter counts could not be loaded. Each voter still gets the notification on their own channel.",
            },
            voterCount: {
                countedAt: "Counted at {{time}}.",
                never: "Not counted yet.",
                pending: "A recount is on its way.",
                timedOut: "The last recount took too long and was stopped.",
                failed: "The last recount failed.",
                previous: "The counts shown are from the count before it.",
                recount: "Recount",
                recountAsked: "Recount asked for. The counts update when it finishes.",
                recountAlreadyAsked: "A recount is already on its way.",
                recountError: "The recount could not be asked for.",
                loadError: "The voter counts could not be loaded.",
            },
            volumes: {
                title: "Monthly volumes",
                intro: "Attempts handed to a provider each month, by channel, sending account, destination country and billing category, to reconcile the providers' invoices. Each attempt counts in the month it was made, so a retry counts again. The billing category is the one expected when sending, or the one the provider reported; whether an attempt is billable is what the provider reported. No prices are shown.",
                month: "Month",
                monthHelp: "Months are counted in UTC.",
                loading: "Loading the monthly volumes",
                loadError: "The volumes could not be loaded.",
                empty: "No attempt was handed to a provider in {{month}}.",
                noPermission: "Showing the volumes needs the messaging-account-read or messaging-config-read permission.",
                notReported: "Not reported",
                deploymentOrDeleted: "Deployment sender or a deleted account",
                category: {
                    AUTHENTICATION: "Authentication",
                    UTILITY: "Utility",
                    SERVICE: "Service",
                    TRANSACTIONAL: "Transactional",
                    EMAIL: "Email",
                },
                billableYes: "Billable",
                billableNo: "Not billable",
                total: "All attempts",
                column: {
                    account: "Sent from",
                    country: "Destination country",
                    category: "Billing category",
                    billable: "Billable",
                    messages: "Attempts",
                },
            },
            voter: {
                listChannel: "Messaging channel",
                title: "Messaging",
                notSet: "Not set",
                channel: "Channel",
                destination: "Sends to",
                messengerPage: "Messenger Page",
                consent: "Consent",
                lastFailure: "Last failure",
                noFailure: "None",
                failureNeedsPermission: "Shown with the messaging-config-read permission.",
                noChannel: "No contact on record",
                notConfirmed: "Delivery not confirmed",
                notConfirmedHelp: "The last message whose delivery isn't confirmed yet. After 24 hours it shows as Unresolved, which doesn't mean it failed.",
            },
            logs: {
                channel: "Channel",
                status: "Status",
                statusAsLogged: "The state when the entry was written; the current state needs the messaging-config-read permission.",
            },
            stats: {
                sent: {
                    WHATSAPP: "WhatsApp messages sent",
                    VIBER: "Viber messages sent",
                    MESSENGER: "Messenger messages sent",
                },
            },
            reason: {
                CANDIDATE_REFUSED: "The new credentials didn't connect: the previous ones are kept",
                ACCOUNT_IN_USE: "Used by an election event's messaging settings: remove it there first",
                NUMBER_CHANGED: "A voter changed their WhatsApp number: ask them to verify their contact again",
                IDENTITY_CHANGED: "The account's sending identity changed: it is checked again",
                TEMPLATES_NOT_READ: "The provider's templates couldn't be read",
                PARTNER_LOGIN_REFUSED: "Infobip refused the account's API key",
                NO_PAGES_MESSAGING: "The Page token lacks the pages_messaging permission",
                NOT_SUBSCRIBED: "The app is not subscribed to the Page",
                NUMBER_STATUS_NOT_READ: "The number's status couldn't be read",
                CALLBACK_NOT_CONFIGURED: "Callback address not configured",
                UNSUPPORTED_PROVIDER: "Unsupported provider: replace this account",
                CREDENTIALS_FOLLOW_ENDPOINT: "Enter the credentials again for the new address",
                NO_CONTACT_CHANNEL: "No contact channel",
                NOT_RETRYABLE_NO_TEMPLATE: "Can't be retried: no stored template",
                CHANNEL_NOT_OFFERED_FOR_NOTICES: "Channel not offered for notices",
                CHANNEL_NOT_OFFERED_FOR_CODES: "Channel not offered for codes",
                NO_CONTENT_FOR_CHANNEL: "No content for the channel",
                NO_ACCOUNT_FOR_CHANNEL: "No sending account for the channel",
                INVALID_DESTINATION: "Invalid destination for the channel",
                NOT_RETRYABLE_PROTECTED_FIELDS: "Can't be retried: contains protected fields",
                REPORTED_TOO_LATE: "Reported too late to retry",
                CHANNEL_CHANGED: "The voter's channel changed: not retried",
                WORKER_STOPPED_BEFORE_SENDING: "The worker stopped before sending",
                WORKER_STOPPED_AFTER_SENDING: "The worker stopped before recording the outcome",
                CODE_EXPIRED_BEFORE_SENDING: "The code expired before it could be sent",
                CAPACITY_BUSY: "Not sent: the account stayed at its sending limit for too long",
                PROVIDER_ANSWER_LATE: "The provider didn't answer in time: the message may have been sent",
                UNRESOLVED: "Delivery couldn't be confirmed",
                SELECTED_WITHOUT_VOTERS: "Select at least one voter",
                WRONG_RECIPIENT_KIND: "The destination isn't the kind this channel sends to",
                UNSUPPORTED_PURPOSE: "The provider doesn't send this kind of message",
                MISSING_APPROVED_TEMPLATE: "No approved template for this message",
                OUTSIDE_CONVERSATION_WINDOW: "Outside the conversation window",
                DESTINATION_NOT_ALLOWED: "This account doesn't send to the destination's country",
                CODE_EXPIRED: "The code expired",
                MISSING_CODE: "No code to send",
                ENDPOINT_NOT_HTTPS: "The provider address must start with https://",
                PROVIDER_CODE: "Provider error code {{code}}",
                CHECK_DROPPED: "The account changed while it was checked: check it again",
                ACCOUNT_NOT_READY: "Not sent: the account isn't ready ({{blocker}})",
                PROVIDER_UNREACHABLE: "The provider couldn't be reached",
                PROVIDER_STATUS: "The provider answered with status {{status}}",
                MISSING_CREDENTIAL: "Missing credential: {{credential}}",
                PROVIDER_CHECK_FAILED: "The provider's check failed: {{detail}}",
                NUMBER_STATUS: "The number's status is {{status}}",
                NUMBER_NAME_STATUS: "The number's display name is {{status}}",
                NUMBER_IN_SANDBOX: "The number is in sandbox mode",
                NUMBER_NOT_VERIFIED: "The number's code is not verified",
                SMS_SANDBOX: "The account is in the SMS sandbox",
                SES_SANDBOX: "The account is in the SES sandbox",
                SES_SENDING_DISABLED: "Sending is disabled for this account",
                SMTP_REFUSED: "SMTP server unreachable or credentials rejected",
                TOKEN_INVALID: "The access token isn't valid or has expired",
                TOKEN_CANNOT_SEND: "The access token lacks the permission to send",
                TOKEN_NOT_CHECKED: "The access token couldn't be checked",
                APP_SECRET_REFUSED: "Meta refused the app secret",
                APP_SECRET_NOT_CHECKED: "The app secret couldn't be checked",
                RETRY_NOT_PREPARED: "Can't be retried: the message couldn't be prepared again",
                NOT_THE_VOTERS_CHANNEL: "Not the voter's channel",
                REPORT_CREDENTIALS_MISSING: "Generate the report credentials and create the Infobip subscription",
                CALLBACK_NOT_HTTPS: "Callback address must be https",
                UNKNOWN_ACCOUNT: "This account no longer exists: it may have been deleted in another tab. Reload the list.",
                INTERNAL_ERROR: "The server couldn't complete the request. Try again later.",
                VERIFY_TOKEN_GENERATED: "The verify token is generated, not entered",
                CREDENTIAL_GENERATED: "{{credential}} is generated, not entered",
                CREDENTIAL_NOT_USED: "{{provider}} accounts don't use {{credential}}",
                CREDENTIAL_EMPTY: "{{credential}} can't be empty",
                NO_REPORT_CREDENTIALS: "{{provider}} accounts have no report credentials",
                UNKNOWN_AUDIENCE: "Unknown audience",
                INVALID_MONTH: "The month must be written as YYYY-MM",
                INVALID_SUPPORT_REFERENCE: "Not a support reference",
                MESSENGER_PAGE_CHANGED: "Not sent: the voter is connected to another Messenger Page",
            },
        },
        messagingAccounts: {
            status: {
                title: "Provider status",
                daily: "Accounts are checked once a day and whenever you check the connection.",
                unchecked: "The number, Page or sender changed since the last check. Until the account is checked again, codes and notices through it fail as not ready; the test message is still sent.",
                notReported: "Not reported",
                yes: "Yes",
                no: "No",
                token: "Access token",
                tokenExpires: "Valid · expires {{date}}",
                tokenNoExpiry: "Valid · doesn't expire",
                tokenInvalid: "Not valid",
                missingScopes: "Missing permissions: {{scopes}}",
                numberStatus: "Number status",
                nameStatus: "Display name: {{status}}",
                qualityRating: "Quality rating",
                quality: {
                    GREEN: "High",
                    YELLOW: "Medium",
                    RED: "Low",
                    UNKNOWN: "Unknown",
                },
                messagingLimit: "Messaging limit",
                pagesMessaging: "Permission to send (pages_messaging)",
                subscribed: "App subscribed to the Page",
                getStarted: "Get Started button",
                getStartedMissing: "Without the button, voters who never wrote to the Page can't start the conversation that brings their code.",
                partnerLogin: "Partner login",
                appSecret: "App secret",
                notChecked: "Couldn't be checked",
                numberQualityWarning: "A quality warning from Meta: the number still sends, but low quality can lower its messaging limit.",
                accepted: "Accepted",
                refused: "Refused",
                callback: "Callback address",
                callbackReady: "Configured",
                approvalFromCheck: "Reported by the provider's check",
                approvalEntered: "Entered by an administrator: the provider's check didn't report it",
                approvalEnteredHelp: "It is used only until the provider's check reports the approval.",
                templates: {
                    title: "Templates at the provider",
                    none: "No templates",
                    name: "Template",
                    language: "Language",
                    category: "Category",
                    status: "Status",
                    entered: "Viber templates are entered by an administrator under Approved templates: the partner has no API for template approval.",
                },
                templateCategory: {
                    AUTHENTICATION: "Authentication",
                    UTILITY: "Utility",
                    MARKETING: "Marketing",
                },
                templateStatus: {
                    APPROVED: "Approved",
                    PENDING: "In review",
                    REJECTED: "Rejected",
                    PAUSED: "Paused",
                    DISABLED: "Disabled",
                },
                numberChanges: {
                    title: "Voters who changed their WhatsApp number",
                    description: "WhatsApp reported these number changes. Ask these voters to verify their contact again; nothing was changed automatically.",
                    item: "{{old}} changed to {{new}} on {{date}}.",
                    voters: "Voters: {{voters}}",
                    noVoters: "No voter received messages from this account at the old number.",
                },
            },
            tab: "MESSAGING",
            description: "Accounts that send voters their codes and notices. Each election event chooses the account for each channel; new events start with the default account.",
            list: {
                title: "Sending accounts",
                add: "Add account",
                loading: "Loading accounts",
                loadError: "The sending accounts could not be loaded.",
                empty: "No sending accounts yet.",
            },
            column: {
                channel: "Channel",
                name: "Account",
                sender: "Sends as",
                provider: "Provider",
                default: "Default",
                isDefault: "Default account",
                lastCheck: "Last check",
                actions: "Actions",
            },
            action: {
                edit: "Edit",
                editNamed: "Edit {{name}}",
                view: "View",
                viewNamed: "View {{name}}",
                check: "Check connection",
                checkNamed: "Check the connection of {{name}}",
                test: "Send test message",
                testNamed: "Send a test message from {{name}}",
                delete: "Delete",
                deleteNamed: "Delete {{name}}",
            },
            check: {
                done: "{{name}} was checked. Its status is updated.",
                error: "{{name}} could not be checked.",
            },
            delete: {
                refused: "The account was not deleted: {{reason}}",
                title: "Delete account",
                body: "Delete {{name}}? Election events that use it stop sending on its channel.",
                success: "Account deleted",
                error: "The account could not be deleted.",
            },
            editor: {
                addTitle: "Add account",
                editTitle: "Edit {{channel}} account",
                subtitle: "Voters receive codes and notices from this account on the channels that use it.",
                channel: "Channel",
                provider: "Provider",
                save: "Save",
                cancel: "Cancel",
                close: "Close",
                channelHelp: "Cannot be changed after the account is created.",
            },
            field: {
                name: "Account name",
                from_address: "From address",
                from_name: "From name",
                region: "AWS region",
                notification_topic_arn: "Delivery notifications topic (SNS ARN)",
                server_url: "Server and port",
                sender_id: "Sender ID",
                origination_number: "Origination number",
                business_account_id: "WhatsApp Business Account ID",
                phone_number_id: "Phone number ID",
                display_phone_number: "Number",
                display_name: "Display name",
                api_version: "Graph API version",
                page_id: "Facebook Page ID",
                page_name: "Page name",
                page_username: "Page username",
                base_url: "API base URL",
                sender: "Sender name",
                provider_approval: "Provider approval",
                is_default: "Default {{channel}} account for new election events",
                api_base_url: "Graph API base URL",
            },
            fieldHelp: {
                from_address: "The address voters see. Its domain must be verified with the provider.",
                notification_topic_arn: "The SNS topic SES publishes delivery and bounce events to. Notifications from any other topic are refused.",
                sender_id: "Up to 11 letters and digits. Some countries require registration.",
                origination_number: "Used instead of the sender ID where a country requires a number.",
                phone_number_id: "The number messages are sent from.",
                display_name: "The display name Meta approved for the number.",
                page_username: "Used for the m.me link voters open to get their code.",
                api_version: "For example v23.0.",
                base_url: "The account's Infobip API base URL.",
                sender: "The approved sender voters see.",
                provider_approval: "Meta allows government messaging on WhatsApp only through an approved arrangement. Choose Provider approval confirmed once Meta has approved it for this account; until then OTPs and notices cannot be enabled for it.",
                api_base_url: "Only when the Graph API is not Meta's own, such as a Solution Provider's endpoint. Empty uses Meta's.",
            },
            error: {
                REQUIRED: "Required",
                NOT_A_COUNT: "Enter a whole number",
                AT_LEAST_ONE: "Enter 1 or more",
                OTP_ABOVE_TOTAL: "Cannot exceed the messages per second",
                INVALID_CALLING_CODE: "Enter country calling codes of 1 to 3 digits, such as 63",
                DUPLICATE_LANGUAGE: "This language already has a template for this purpose",
                NOT_A_URL: "Enter an address starting with https://",
                UNSUPPORTED_PROVIDER: "Unsupported provider: replace this account",
                CREDENTIALS_FOLLOW_ENDPOINT: "Enter the credentials again for the new address",
            },
            warning: {
                pageChangeCount: "Voters connected to {{page}} who must connect again: {{count}}.",
                pageChangeCounting: "Counting the voters connected to the Page…",
                pageChangeCountError: "The number of voters connected to the Page could not be read.",
                recheck: "Saving checks the account again in the background. Until that check succeeds, codes and notices through it fail as not ready; the test message is still sent.",
                pageChange: "Messenger conversations belong to a Page. After changing the Page, codes and notices to the voters connected to {{page}} aren't sent until they connect again. A voter reconnects at their next sign-in, after entering their password: the sign-in shows the connect step for the new Page, the voter taps Get Started in Messenger, then receives the code there. A voter who can't sign in with a password, for example because they forgot it, needs staff to change their channel.",
                numberChange: "Messages will come from another number. Its templates must be approved in that business account before it can send codes, and voters will see a new chat.",
            },
            viber: {
                title: "Approved templates",
                description: "Enter the templates Viber approved through the partner, per purpose and language. The partner's template API is not available, so this list is kept by hand and the connection check reads it.",
                purpose: "Purpose",
                language: "Language",
                templateId: "Partner template ID",
                add: "Add template",
                remove: "Remove template",
            },
            limits: {
                title: "Sending limits",
                messagesPerSecond: "Messages per second",
                messagesPerSecondHelp: "Empty: messages are not throttled.",
                otpReservedPerSecond: "Reserved for OTPs per second",
                otpReservedHelp: "A floor in the account's one shared sending budget: notices stop at it and codes go first. With no codes being sent, a bulk send can use the full rate.",
                otpConcurrency: "Codes sent at once",
                otpConcurrencyHelp: "Empty: 8. Codes and Keycloak's notices (reset links, temporary passwords) each hold a place while they are sent. Counted per server process; further sends wait their turn.",
                allowedCallingCodes: "Allowed destinations (country calling codes)",
                allowedCallingCodesHelp: "Separated by commas, for example 63, 971. Empty allows any destination.",
            },
            credentials: {
                title: "Credentials",
                description: "Credentials are write-only: after saving, only the date each was last replaced is shown.",
                set: "Set · replaced {{date}}. It is stored encrypted and never shown.",
                replace: "Replace",
                replaceNamed: "Replace {{name}}",
                reenter: "The address changed: enter this credential again.",
            },
            credentialHelp: {
                AWS_SES: {
                    AWS_ACCESS_KEY_ID: "Optional. Without keys, the service's own role is used.",
                    AWS_SECRET_ACCESS_KEY: "Optional. Set it together with the access key ID.",
                },
                AWS_SNS: {
                    AWS_ACCESS_KEY_ID: "Optional. Without keys, the service's own role is used.",
                    AWS_SECRET_ACCESS_KEY: "Optional. Set it together with the access key ID.",
                },
                SMTP: {
                    SMTP_PASSWORD: "The SMTP server's password.",
                },
                WHATSAPP_CLOUD_API: {
                    ACCESS_TOKEN: "A token of a system user in the owner's business portfolio, with whatsapp_business_messaging.",
                    APP_SECRET: "Checks that webhook calls come from Meta.",
                },
                MESSENGER_SEND_API: {
                    ACCESS_TOKEN: "A Page access token with pages_messaging.",
                    APP_SECRET: "Checks that webhook calls come from Meta.",
                },
                VIBER_INFOBIP: {
                    API_KEY: "The Infobip API key.",
                },
            },
            webhook: {
                title: "Delivery reports",
                description: {
                    WHATSAPP_CLOUD_API: "Enter this callback URL in Meta's webhook settings. Delivery reports arrive here and are checked with the app secret.",
                    MESSENGER_SEND_API: "Enter this callback URL in Meta's webhook settings. Delivery reports and the voter's Get Started tap arrive here and are checked with the app secret.",
                    VIBER_INFOBIP: "Infobip sends Viber delivery reports to this callback URL through a subscription with Basic authentication.",
                    AWS_SES: "Subscribe this callback URL (HTTPS) to the delivery notifications topic. Delivery and bounce events arrive here and are checked with Amazon's signature.",
                },
                afterSaving: "Shown after saving",
                tokenSet: "Set · replaced {{date}}",
                tokenMissing: "Not generated yet",
                tokenAfterSaving: "Generated after saving",
                generate: "Generate verify token",
                tokenTitle: "Verify token",
                tokenOnce: "Enter this token in Meta's webhook settings now. It is shown only once.",
                copyToken: "Copy verify token",
                tokenDone: "Done",
                tokenError: "The verify token could not be generated.",
                url: "Callback URL",
                copyUrl: "Copy callback URL",
                needsWrite: "Shown to administrators who can manage messaging accounts.",
                loading: "Loading…",
                unavailable: "Not available",
                loadError: "The callback URL could not be loaded.",
            },
            copy: {
                success: "Copied",
                error: "Could not copy",
            },
            save: {
                success: "Account saved",
                error: "The account could not be saved.",
                refused: "The account was not saved: {{reason}}",
            },
            test: {
                title: "Send a test message from {{name}}",
                description: "Sends a real message for the chosen purpose to this destination. The result shows what the provider reported.",
                purpose: "Purpose",
                destination: {
                    EMAIL_ADDRESS: "Email address",
                    PHONE_NUMBER: "Phone number (E.164)",
                    PAGE_SCOPED_ID: "Page-scoped ID",
                },
                language: "Language",
                send: "Send test message",
                reason: "Reason: {{reason}}",
                error: "The test message could not be sent.",
                template: "Approved template",
                templateHelp: "The name or ID of the template the provider approved for this purpose and language.",
                viberTemplate: "Viber uses the template this account lists as approved for the chosen purpose and language.",
                languageHelp: "For a provider that sends approved templates, enter the provider's language code of the template, such as en_US.",
            },
            unsupported: "Unsupported provider: replace this account. Its provider is no longer supported, so it can't send. Add an account for this channel with a supported provider, choose it in the election events that use this one, then delete this account.",
            reports: {
                label: "Report credentials",
                missing: "Not generated yet",
                generate: "Generate report credentials",
                title: "Report credentials",
                once: "Enter these in the Infobip subscription now. They are shown only once; generating new ones replaces them.",
                copyUsername: "Copy report user name",
                copyPassword: "Copy report password",
                error: "The report credentials could not be generated.",
                step: {
                    subscription: "In Infobip, create a subscription for Viber delivery reports.",
                    url: "Set its URL to this account's callback URL.",
                    auth: "Choose Basic authentication and enter the report user name and password.",
                },
                confirmTitle: "Replace the report credentials?",
                confirmBody: "The current report user name and password stop working at once. Until Infobip's subscription has the new ones, Viber delivery reports are refused and messages stay Accepted.",
                confirm: "Replace",
            },
        },
        sentMessages: {
            showMore: "Show more",
            showLess: "Show less",
            tab: "Sent messages",
            accountsTab: "Accounts",
            tabsLabel: "Messaging sections",
            description: "Messages the demo provider of this development stack received, shown as the voters' apps would show them. None of them reached a real voter. This tab is shown only where the demo provider routes are enabled.",
            modeLabel: "Show messages from",
            all: "All",
            refresh: "Refresh",
            refreshing: "Refreshing…",
            refreshError: "The messages could not be refreshed. The list shown is the last one read.",
            empty: "No messages yet.",
            emptyChannel: "No {{channel}} messages yet.",
            column: {
                time: "Time",
                channel: "Channel",
                from: "From",
                to: "To",
                message: "Message",
                report: "Delivery report",
            },
            report: {
                accepted: "Report accepted by the webhook component (HTTP 200)",
                refused: "Report refused: HTTP {{status}}",
                pending: "Report pending",
                notSent: "Report not sent: {{reason}}",
                noAnswer: "The report got no answer: {{reason}}",
                noReason: "no reason given",
                unavailable: "No delivery reports on this channel",
            },
            content: {
                demoCode: "{{code}} is your verification code. For your security, do not share this code with anyone.",
                demoNotice: "Voting reminder\n\nHello {{name}}, voting is now open for {{event}}.\n\nSign in to the voting portal to review your ballot and cast your vote:\n{{url}}\n\nDo not share your sign-in code with anyone. If you have already voted, no further action is needed.",
                demoLegacyNotice: "Voting reminder\n\nHello {{name}}, voting is now open. Sign in to the voting portal to cast your vote:\n{{url}}\n\nDo not share your sign-in code with anyone.",
                template: "Template {{name}} ({{language}})",
                noText: "(no text)",
                code: "Code",
                copyCode: "Copy code",
                copied: "Code copied",
                copyFailed: "The code could not be copied",
                truncated: "Cut: the demo provider keeps only the first 64 KiB of each field.",
            },
            chat: {
                phone: "{{channel}} on a phone",
                chats: "{{channel}} chats",
                open: "Open the chat with {{recipient}} from {{sender}}",
                back: "Back to the chats",
                from: "From {{sender}}",
                messages: "Messages to {{recipient}}",
            },
            getStarted: {
                title: "Get Started",
                help: "Paste the Messenger link the enrollment page shows, then press Get Started, as the voter would in Messenger. The code then arrives in the chat.",
                link: "Messenger link",
                submit: "Get Started",
                accepted: "The webhook component answered 200. The code arrives in the chat.",
                answered: "The webhook component answered {{status}}.",
                failed: "Get Started failed: {{reason}}",
            },
            email: {
                inbox: "Inbox",
                reading: "Selected email",
                noSubject: "(no subject)",
                from: "From",
                to: "To",
                view: "Show the email as",
                html: "HTML",
                text: "Plain text",
                htmlFrame: "Email content",
                noContent: "This email has no content.",
                loading: "Loading the email…",
                loadError: "The email's HTML could not be read: the demo provider may no longer keep it.",
            },
            reason: {
                SEVERAL_ACCOUNTS: "Several accounts use this sender",
                ACCOUNTS_UNREADABLE: "The accounts couldn't be read",
                UNREACHABLE: "The webhook component didn't answer",
                LINK_UNREADABLE: "Paste the m.me link from the enrollment page",
                LINK_WITHOUT_REF: "The link has no ref: copy the whole link",
                NO_PAGE_ACCOUNT: "No Messenger account of this organization uses this Page",
                SEVERAL_PAGE_ACCOUNTS: "Several Messenger accounts of this organization use this Page",
            },
        },
        electoralLogConsole: {
            title: "Electoral Log",
            subtitle: "Browse an election event's electoral log and ballot box, or query its electoral-log database. Nothing on this page changes any data.",
            notAllowed: "You need the electoral-log-console-read permission to open the electoral log.",
            tabs: {
                tables: "Tables",
                query: "Query",
            },
            electionEvent: "Election Event",
            tenant: "Tenant",
            table: "Table",
            tables: {
                records: "Records",
                ballots: "Ballots",
                voters: "Voters",
                queue: "Sequencer Queue",
            },
            order: {
                "label": "Order",
                "newest-first": "Newest first",
                "oldest-first": "Oldest first",
            },
            filters: {
                statement_kind: "Kind",
                election_id: "Election",
                area_id: "Area ID",
                user_id: "User or Voter ID",
                ballot_id: "Ballot ID",
                status: "Status",
                created_after: "From",
                created_before: "Until",
                any: "Any",
                apply: "Apply Filters",
                clear: "Clear",
                invalid: "Check the highlighted filters: dates must be valid, and the ballot box's area IDs must be UUIDs.",
            },
            statuses: {
                valid: "Valid",
                pending: "Pending",
                rejected: "Rejected",
            },
            estimatedRows: "About {{rows}} rows in this table before filters.",
            personalDataHidden: "Usernames, IP addresses and countries show as hidden: seeing them needs the electoral-log-personal-data-read permission.",
            loadError: "The electoral log could not be read.",
            record: {
                title: "Record {{position}}",
                view: "View record",
                message: "Message (decoded)",
                copy: "Copy JSON",
                close: "Close",
                loadError: "The record could not be read.",
            },
            query: {
                help: "Queries run on the election event's electoral-log database in a read-only transaction. Its tables are electoral_log_messages, ballot_box_ballot, ballot_box_voter, ballot_box_pending and ballot_box_sequencer; trellis_logs describes its Merkle logs.",
                scope: "Each election event has a database of its own, so a query reads one event.",
                chooseEvent: "Choose the election event to query.",
                placeholder: "SELECT …",
                limits: "Read-only · up to 1,000 rows · 30 s timeout · each query is recorded in the server logs with your user",
                run: "Run Query",
                summary: "Rows: {{rows}} · {{ms}} ms",
                truncated: "Only the first {{rows}} rows are shown.",
                error: "The query could not run.",
            },
        },
        taskQueues: {
            title: "Task Queues",
            subtitle: "The environment's task queues: what is waiting, what was processed and how long it took. The queue lists never show task arguments.",
            notAllowed: "You need the task-queues-read permission of the super-admin tenant to open the task queues.",
            live: "Live",
            updated: "Updated at {{time}}",
            error: "The task queues could not be loaded.",
            columns: {
                queue: "Queue",
                ready: "Ready",
                runningOrScheduled: "Running or scheduled",
                oldest: "Oldest",
                processed: "Processed (last hour)",
                lastHour: "Outcomes (last hour)",
                sent: "Sent (total)",
            },
            outcomes: {
                succeeded: "Succeeded",
                failed: "Failed",
                expired: "Expired",
                rejected: "Rejected",
                discarded: "Discarded",
                unknown: "Unknown",
            },
            graphs: {
                title: "Throughput",
                period: "Period",
                periods: {
                    hour: "Last hour",
                    sixHours: "Last 6 hours",
                    day: "Last 24 hours",
                    week: "Last 7 days",
                },
                outcomes: "Processed messages by outcome",
                durations: "Mean wait and processing time",
                wait: "Wait",
                processing: "Processing",
                seconds: "Seconds",
                empty: "No messages of this queue were processed in this period.",
            },
            messages: {
                title: "Messages",
                states: {
                    queued: "Queued",
                    archived: "Archived",
                },
                argumentsHidden: "Task arguments are never shown, because they can contain voters' data.",
                refresh: "Refresh",
                newest: "Newest",
                newer: "Newer",
                older: "Older",
                empty: "No messages",
                unreadable: "Unreadable message",
                columns: {
                    id: "ID",
                    task: "Task",
                    outcome: "Outcome",
                    event: "Event",
                    error: "Error",
                    enqueued: "Enqueued",
                    reads: "Reads",
                    retries: "Retries",
                    archived: "Archived",
                    visible: "Visible from",
                    size: "Size",
                    taskId: "Task ID",
                },
            },
            deadLetters: {
                help: "These electoral-log events could not be processed. Select events to replay them to the event queue or to discard them; discarded events stay in the archive.",
                noWrite: "You need the task-queues-write permission to replay or discard these events.",
                replay: "Replay",
                discard: "Discard",
                cancel: "Cancel",
                confirmTitle: {
                    replay: "Replay events?",
                    discard: "Discard events?",
                },
                confirmBody: {
                    replay_one: "{{count}} event will be sent back to the electoral-log event queue. If it fails again, it returns here.",
                    replay_many: "{{count}} events will be sent back to the electoral-log event queue. Events that fail again return here.",
                    replay_other: "{{count}} events will be sent back to the electoral-log event queue. Events that fail again return here.",
                    discard_one: "{{count}} event will be moved to the archive and not added to the electoral log.",
                    discard_many: "{{count}} events will be moved to the archive and not added to the electoral log.",
                    discard_other: "{{count}} events will be moved to the archive and not added to the electoral log.",
                },
                queued: {
                    replay_one: "Replay of {{count}} event queued as task {{taskId}}.",
                    replay_many: "Replay of {{count}} events queued as task {{taskId}}.",
                    replay_other: "Replay of {{count}} events queued as task {{taskId}}.",
                    discard_one: "Discard of {{count}} event queued as task {{taskId}}.",
                    discard_many: "Discard of {{count}} events queued as task {{taskId}}.",
                    discard_other: "Discard of {{count}} events queued as task {{taskId}}.",
                },
                failed: "The operation could not be queued.",
            },
            tabs: {
                queues: "Queues",
                query: "Query",
            },
            query: {
                help: "Queries run on the environment's task-queue database in a read-only transaction, as its reader role. Each queue has a table of waiting messages, pgmq.q_<queue>, and one of processed messages, pgmq.a_<queue>.",
                arguments: "Queries read the messages as they are stored, with their tasks' arguments, which can include voters' data.",
                placeholder: "SELECT …",
                limits: "Read-only · up to 1,000 rows · 30 s timeout · each query is recorded in the server logs with your user",
                run: "Run Query",
                summary: "Rows: {{rows}} · {{ms}} ms",
                truncated: "Only the first {{rows}} rows are shown.",
                error: "The query could not run.",
            },
        },
    },
};
export default englishTranslation;
